import { deLegalContent } from '../legalContent'

export default {
  brand: {
    logoAlt: 'LPT-Logo'
  },
  legal: deLegalContent,
  language: {
    en: "Englisch",
    fr: "Französisch",
    es: "Spanisch",
    zh: "chinesisch",
    de: "Deutsch"
  },
  navbar: {
    Index: "Start",
    Products: "Produkte",
    Audit: "Prüfung",
    solution: "Lösungen",
    about: "Über uns",
    News: "Nachricht",
    Customer_Service: "Funktionen und Lösung",
    controlCenter: "Kontrollzentrum",
    login: "Login",
    Language: "Sprache",
    logout: "Abmelden",
    logoutSuccess: "Abmelden erfolgreich",
    FAQ: "FAQ",
    AboutLPT: "Über LPT",
    LPTIntro: "LPT-Einführung",
    ContactLPT: "Kontaktieren Sie LPT",
    Company: "Unternehmen",
    IndustryBrain: "Industry Brain",
    CloudRecruitment: "Cloud-Rekrutierung",
    InnovationServices: "Innovationsservices für Unternehmen",
    Consulting: "Industrieberatung",
    ContentCenter: "Content-Center",
    IndustryReports: "Branchenberichte",
    SelectedArticles: "Ausgewählte Artikel",
    MediaReports: "Medienberichte",
    LPTResearch: "LPT-Forschungsinstitut",
    LPTIntroduction: "Über LPT",
    BuyNow: "Jetzt kaufen"
  },
  serverConfig: {
    computeInstance: {
      title: "Compute-Instanzen",
      recommend: "Empfohlen",
      types: {
        g7: { name: "Allzweckinstanz G7", type: "Allzweck" },
        c7: { name: "Rechenoptimierte Instanz C7", type: "Rechenoptimiert" },
        r7: { name: "Speicheroptimierte Instanz R7", type: "Speicheroptimiert" }
      },
      specs: { cpu: " vCPU", memory: " GB" },
      price: { currency: "€", period: " / Monat" }
    },
    storageConfig: {
      title: "Speicherkonfiguration",
      types: {
        essd: "Erweiterte SSD",
        essdDesc: "IOPS im Millionenbereich",
        ssd: "Standard-SSD",
        ssdDesc: "Leistung auf Unternehmensniveau",
        hdd: "Hocheffiziente HDD",
        hddDesc: "Speicher mit hoher Kapazität",
        performance: { iops: "IOPS: ", latency: "Latenz: " }
      },
      capacity: { label: "Speicherkapazität", unitGB: " GB" }
    }
  },
  registration: {
    organization: "Organisation",
    legalRepresentative: "Gesetzlicher Vertreter",
    businessRegistrationNumber: "Handelsregisternummer",
    taxIdNumber: "Steuer-ID",
    businessAddress: "Geschäftsadresse",
    phoneNumber: "Telefonnummer",
    wechatId: "WeChat-ID",
    email: "E-Mail",
    createPassword: "Passwort erstellen",
    repeatPassword: "Passwort wiederholen",
    accept: "Ich akzeptiere die",
    termsConditions: "Allgemeinen Geschäftsbedingungen"
  },
  dialog: {
    termsTitle: "Allgemeine Geschäftsbedingungen"
  },
  common: {
    close: "Schließen",
    loading: "Wird geladen..."
  },
  validation: {
    required: "Dieses Feld ist erforderlich.",
    lengthRange: "Bitte geben Sie zwischen {min} und {max} Zeichen ein.",
    regNumberFormat: "Geben Sie eine gültige 15-stellige Registrierungsnummer ein.",
    passwordComplexity: "Verwenden Sie mindestens 8 Zeichen mit Groß- und Kleinbuchstaben sowie einer Zahl.",
    passwordMismatch: "Die Passwörter stimmen nicht überein.",
    agreementRequired: "Bitte akzeptieren Sie die Allgemeinen Geschäftsbedingungen."
  },
  message: {
    validationFailed: "Bitte korrigieren Sie die markierten Felder."
  },
  payment: {
    steps: {
      methodSelection: "Zahlungsmethode",
      paymentProcess: "Zahlung",
      paymentResult: "Ergebnis"
    },
    methods: {
      wechat: { name: "WeChat Pay", tip: "Empfohlen für WeChat-Nutzer" },
      alipay: { name: "Alipay", tip: "Unterstützt Huabei und Yu’e Bao" },
      mastercard: { name: "Mastercard", tip: "Unterstützt internationale Kreditkarten" }
    },
    qrCode: {
      scanPrompt: "Scannen Sie den {method}-QR-Code, um zu bezahlen",
      countdown: "Der QR-Code läuft in {seconds} s ab"
    },
    form: {
      cardNumber: "Kartennummer",
      expiryDate: "Ablaufdatum",
      cvv: "CVV",
      placeholders: {
        cardNumber: "Kartennummer eingeben",
        expiry: "Ablaufdatum auswählen",
        cvv: "CVV eingeben"
      }
    },
    buttons: { previous: "Zurück", payNow: "Jetzt bezahlen" },
    errors: { bankBusy: "Das Banksystem ist ausgelastet. Bitte versuchen Sie es später erneut." },
    result: {
      success: { title: "Zahlung erfolgreich", subTitle: "Ihre Bestellung wurde bezahlt. Wir bereiten Ihre Produkte vor." },
      failed: { title: "Zahlung fehlgeschlagen", subTitle: "Ihre Zahlung konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut." },
      returnHome: "Zur Startseite"
    }
  },
  periodSelect: {
    Monthlypurchase: "Monatlicher Kauf",
    Annual: "Jährlich"
  },
  datePicker: {
    rangeSeparator: "bis",
    startMonth: "Startmonat",
    endMonth: "Endmonat"
  },
  networkConfig: {
    title: "Netzwerkkonfiguration"
  },
  priceSummary: {
    title: "Preisübersicht",
    serviceDuration: "Servicedauer: {months} Monate",
    unitPrice: "Stückpreis: {price}",
    totalPrice: "Gesamtpreis: {total}"
  },
  orderDetails: {
    title: "Bestelldetails",
    companyName: "Unternehmen",
    template: "Vorlage",
    storage: "Speicher",
    storageUnitGB: "GB",
    computeLevel: "Rechenleistung",
    servicePeriod: "Servicezeitraum",
    totalAmount: "Gesamtbetrag",
    defaultPeriod: "Juli 2023 bis Juni 2024"
  },
  agreement: {
    readAndAgree: "Ich habe die folgenden Dokumente gelesen und stimme ihnen zu:",
    serviceAgreement: "Servicevereinbarung",
    and: "und",
    privacyPolicy: "Datenschutzerklärung"
  },
  template: {
    header: { title: "Audit-Vorlagen auswählen", selectedCount: "{count} ausgewählt" },
    tags: { pro: "PRO", basic: "BASIC" },
    names: {
      iso9001: "ISO 9001", iatf16949: "IATF 16949", vda63: "VDA 6.3", vda65: "VDA 6.5",
      individualPro: "Individueller Vorlageneditor (Pro)", individualBasic: "Individueller Vorlageneditor"
    },
    description: "Intelligentes Produktionsmanagementsystem für die Fertigungsindustrie.",
    alerts: {
      incompatible: "Diese Vorlage ist mit den bereits ausgewählten Vorlagen nicht kompatibel.",
      conflict: "Die Vorlage {template} steht im Konflikt mit den ausgewählten Vorlagen: {selected}"
    }
  },
  demo: {
    title: "Produktdemo buchen",
    subtitle: "Beschreiben Sie uns Ihren Bedarf. Unser Team wird sich mit Ihnen in Verbindung setzen.",
    form: {
      serviceLabel: "Produkt oder Service von Interesse",
      servicePlaceholder: "Produkt oder Service auswählen",
      services: {
        auditPlatform: "Audit-Plattform",
        complianceManagement: "Compliance-Management",
        riskAssessment: "Risikobewertung",
        auditConsulting: "Audit-Beratung"
      },
      nameLabel: "Name", namePlaceholder: "Namen eingeben",
      phoneLabel: "Telefonnummer", phonePlaceholder: "Telefonnummer eingeben",
      codeLabel: "Bestätigungscode", codePlaceholder: "Bestätigungscode eingeben", getCodeButton: "Code anfordern",
      emailLabel: "E-Mail", emailPlaceholder: "E-Mail-Adresse eingeben",
      companyLabel: "Behörde / Park / Organisation / Unternehmen", companyPlaceholder: "Unternehmensnamen eingeben",
      positionLabel: "Position", positionPlaceholder: "Position eingeben",
      remarksLabel: "Anmerkungen", remarksPlaceholder: "Beschreiben Sie Ihre Fragen oder Anforderungen (max. 200 Zeichen)",
      privacyAgreement: "Mit dem Absenden stimmen Sie der Datenschutzerklärung von LPT Creation zu",
      submitButton: "Jetzt buchen"
    }
  },
  back: "Zurück",
  controlCenter: {
    sidebar: {
      title: "Kontrollzentrum",
      subtitle: "Audit-, Zahlungs- und Produktverwaltung",
      dashboard: "Audit-Übersicht",
      paymentDashboard: "Zahlungsübersicht",
      companyEntitlements: "Unternehmenskäufe",
      myProducts: "Meine Produkte",
      catalog: "Katalogverwaltung",
      orders: "Bestellverwaltung",
      invoices: "Rechnungsverwaltung",
      tickets: "Ticketverwaltung",
      addOnManagement: "Add-on-Verwaltung",
      userManagement: "Benutzerverwaltung",
      permissionManagement: "Berechtigungsverwaltung",
      systemSettings: "Systemeinstellungen",
      appManagement: "Anwendungsverwaltung",
      accountInfo: "Konto"
    },
    invoices: {
      title: "Rechnungsverwaltung",
      subtitle: "Rechnungen für Bestellungen hochladen und anzeigen.",
      notUploaded: "Nicht hochgeladen",
      deleteFile: "Datei löschen",
      deleting: "Wird gelöscht...",
      deleteConfirm: "Diese Rechnungsdatei löschen? Danach können Sie eine neue Datei hochladen.",
      deleteSuccess: "Rechnungsdatei gelöscht.",
      deleteError: "Die Rechnungsdatei konnte nicht gelöscht werden.",
      snapshot: "Gespeicherter Snapshot",
      overview: {
        total: "Bestellungen gesamt",
        uploaded: "Auf dieser Seite hochgeladen",
        pending: "Upload ausstehend",
        coverage: "Seitenabdeckung"
      },
      columns: {
        invoice: "Rechnung"
      }
    },
    accessDenied: {
      title: "Administratorzugriff erforderlich",
      description: "Dieser Bereich ist nur für Administratorkonten verfügbar."
    },
    common: {
      loading: "Wird geladen...",
      shop: "SHOP",
      refresh: "Aktualisieren",
      save: "Speichern",
      cancel: "Abbrechen",
      edit: "Bearbeiten",
      enable: "Aktivieren",
      disable: "Deaktivieren",
      actions: "Aktionen",
      all: "Alle",
      search: "Suchen",
      reset: "Zurücksetzen",
      viewDetails: "Details anzeigen",
      close: "Schließen",
      confirm: "Bestätigen",
      exitToHome: "Zur Startseite",
      unknown: "Unbekannt",
      status: "Status"
    },
    statusLabels: {
      PENDING: "Ausstehend",
      SUCCESS: "Erfolgreich",
      ACTIVE: "Aktiv",
      FAILED: "Fehlgeschlagen",
      CANCELED: "Storniert",
      PAST_DUE: "Überfällig",
      UNKNOWN: "Unbekannt"
    },
    billingCycleLabels: {
      one_year: "1 Jahr",
      two_year: "2 Jahre"
    },
    ticketStatusLabels: {
      OPEN: "Offen",
      CLOSED: "Geschlossen",
      UNKNOWN: "Unbekannt"
    },
    ticketCategories: {
      REFUND: "Rückerstattung",
      LICENSE: "Lizenz",
      LOGIN: "Anmeldung",
      AUDIT: "Audit",
      OTHER: "Sonstiges"
    },
    ticketAuthorTypes: {
      EMPLOYEE: "LPT-Mitarbeiter",
      CUSTOMER: "Kunde",
      UNKNOWN: "Unbekannt"
    },
    dashboard: {
      title: "Zahlungsübersicht",
      subtitle: "Bestellungen, Umsatz und beliebte Produkte an einem Ort verfolgen.",
      totalOrders: "Gesamtbestellungen",
      successfulOrders: "Erfolgreiche Bestellungen",
      pendingOrders: "Ausstehende Bestellungen",
      failedOrders: "Fehlgeschlagene Bestellungen",
      totalRevenue: "Gesamtumsatz",
      trendTitle: "Letzte 7 Tage",
      trendDate: "Datum",
      trendOrders: "Bestellungen",
      trendRevenue: "Umsatz",
      recentOrders: "Neueste Bestellungen",
      popularItems: "Beliebte Produkte",
      orderNo: "Bestellnr.",
      company: "Unternehmen",
      amount: "Betrag",
      createdAt: "Erstellt am",
      noPopularItems: "Noch keine beliebten Produkte.",
      loadError: "Dashboard konnte nicht geladen werden."
    },
    companyEntitlements: {
      title: "Unternehmenskäufe",
      subtitle: "Alle Unternehmen, gekaufte Funktionen und Lizenzlaufzeiten anzeigen.",
      keywordPlaceholder: "Nach Unternehmen, Bestellung, Benutzer oder Paket suchen",
      empty: "Keine Unternehmenskäufe gefunden.",
      loadError: "Unternehmenskäufe konnten nicht geladen werden.",
      seatSummary: "{auditors} Prüfer / {admins} Administratoren",
      stats: {
        companies: "Unternehmen",
        activeCompanies: "Aktive Unternehmen",
        entitlements: "Berechtigungen",
        seats: "Sitze gesamt"
      },
      columns: {
        company: "Unternehmen",
        activeEntitlements: "Aktiv / Gesamt",
        purchasedItems: "Gekaufte Inhalte",
        seats: "Sitze",
        startsAt: "Startdatum",
        expiresAt: "Ablaufdatum"
      },
      fields: {
        billingCycle: "Abrechnungszeitraum",
        validity: "Gültigkeit",
        seats: "Sitze",
        updatedAt: "Aktualisiert am",
        languages: "Sprachen",
        standards: "Audit-Vorlagen"
      }
    },
    myProducts: {
      title: "Meine Produkte",
      subtitle: "Produkte und Add-ons des aktuellen Kontos prüfen.",
      activeKicker: "In Nutzung",
      activeTitle: "Derzeit aktiv",
      expiredKicker: "Archiv",
      expiredTitle: "Abgelaufene Produkte",
      expiresAt: "Läuft ab am",
      expiredAt: "Abgelaufen am",
      startsAt: "Startet am",
      sourceOrder: "Bestellung",
      quantity: "{count} Stk.",
      loadError: "Ihre Produkte konnten nicht geladen werden.",
      emptyActiveTitle: "Keine aktiven Produkte",
      emptyActiveText: "Gekaufte Produkte erscheinen hier nach erfolgreicher Zahlung.",
      emptyExpiredTitle: "Keine abgelaufenen Produkte",
      emptyExpiredText: "Abgelaufene Produkte werden hier archiviert.",
      stats: {
        active: "Produkte in Nutzung",
        expired: "Abgelaufene Produkte",
        total: "{count} Produkte insgesamt",
        nextExpiry: "{product} läuft am {date} ab",
        noExpiry: "Kein Ablaufdatum verfügbar"
      },
      groups: {
        package: {
          kicker: "Paket",
          title: "Pakete",
          emptyActiveTitle: "Keine aktiven Pakete",
          emptyActiveText: "Gekaufte Pakete erscheinen hier.",
          emptyExpiredTitle: "Keine abgelaufenen Pakete",
          emptyExpiredText: "Abgelaufene Pakete werden hier angezeigt."
        },
        language: {
          kicker: "Sprache",
          title: "Sprachen",
          emptyActiveTitle: "Keine aktiven Sprachen",
          emptyActiveText: "Gekaufte Sprachen erscheinen hier.",
          emptyExpiredTitle: "Keine abgelaufenen Sprachen",
          emptyExpiredText: "Abgelaufene Sprachen werden hier angezeigt."
        },
        standard: {
          kicker: "Standards",
          title: "Standards",
          emptyActiveTitle: "Keine aktiven Standards",
          emptyActiveText: "Gekaufte Standards erscheinen hier.",
          emptyExpiredTitle: "Keine abgelaufenen Standards",
          emptyExpiredText: "Abgelaufene Standards werden hier angezeigt."
        },
        licence: {
          kicker: "Lizenzen",
          title: "Lizenzen",
          emptyActiveTitle: "Keine aktiven Lizenzen",
          emptyActiveText: "Gekaufte Lizenzen erscheinen hier.",
          emptyExpiredTitle: "Keine abgelaufenen Lizenzen",
          emptyExpiredText: "Abgelaufene Lizenzen werden hier angezeigt."
        }
      },
      status: {
        active: "Aktiv"
      },
      types: {
        licence: "Lizenzen",
        auditorSeat: "Auditor-Lizenzen",
        adminSeat: "Admin-Sitze"
      },
      descriptions: {
        plan: "Hauptpaket · {cycle}",
        language: "Zusätzliche Sprachfunktion",
        standard: "Zusätzliche Auditvorlage",
        seat: "Zusätzliche Lizenzanzahl: {count}",
        addOn: "Gekaufte Add-on-Funktion"
      },
      actions: {
        createAuditor: "Benutzer erstellen"
      }
    },
    catalog: {
      title: "Katalogverwaltung",
      subtitle: "Produktnamen, Preise, Sitzstufen und Verfügbarkeit pflegen.",
      create: "Neuer Eintrag",
      createTitle: "Katalogeintrag erstellen",
      editTitle: "Katalogeintrag bearbeiten",
      enabled: "Aktiv",
      disabled: "Deaktiviert",
      unlimited: "Unbegrenzt",
      loadError: "Katalog konnte nicht geladen werden.",
      createSuccess: "Katalogeintrag erfolgreich erstellt.",
      updateSuccess: "Katalogeintrag erfolgreich aktualisiert.",
      saveError: "Katalogeintrag konnte nicht gespeichert werden.",
      enableSuccess: "Katalogeintrag aktiviert.",
      disableSuccess: "Katalogeintrag deaktiviert.",
      columns: {
        type: "Typ",
        code: "Code",
        name: "Name",
        currency: "Währung",
        oneYear: "Preis 1 Jahr",
        twoYears: "Preis 2 Jahre",
        seatCount: "Sitze",
        languageLimit: "Sprachlimit",
        sortOrder: "Sortierung",
        enabled: "Status"
      },
      types: {
        plan: "Paket",
        language: "Sprache",
        standard: "Auditvorlage",
        auditorSeat: "Auditor-Sitz",
        adminSeat: "Admin-Sitz"
      }
    },
    orders: {
      title: "Bestellverwaltung",
      subtitle: "Alle Bestellungen nach Nummer, Unternehmen, Status und Zahlungsmethode durchsuchen.",
      keywordPlaceholder: "Nach Bestellnummer oder Unternehmen suchen",
      syncStatus: "Status synchronisieren",
      uploadInvoice: "Rechnung hochladen",
      invoiceUploading: "Wird hochgeladen...",
      viewInvoice: "Rechnung ansehen",
      storageTag: "Speicher · Zugehörig",
      invoiceUploadSuccess: "Rechnung erfolgreich hochgeladen.",
      invoiceUploadError: "Rechnung konnte nicht hochgeladen werden.",
      invoiceTypeError: "Bitte laden Sie eine Rechnung als PDF, PNG oder JPG hoch.",
      invoiceSizeError: "Die Rechnungsdatei darf maximal 10 MB groß sein.",
      detailTitle: "Bestelldetails",
      invoiceItems: "Rechnungspositionen",
      companyInfo: "Unternehmensdaten",
      defaultInvoiceInfo: "Standard-Rechnungsdaten",
      noDefaultInvoiceInfo: "Es wurden keine Standard-Rechnungsdaten festgelegt.",
      contactName: "Kontaktperson",
      email: "E-Mail",
      phone: "Telefon",
      registrationNumber: "Registrierungsnummer",
      address: "Adresse",
      loadError: "Bestellungen konnten nicht geladen werden.",
      detailError: "Bestelldetails konnten nicht geladen werden.",
      syncSuccess: "Bestellstatus erfolgreich synchronisiert.",
      syncError: "Bestellstatus konnte nicht synchronisiert werden.",
      columns: {
        orderNo: "Bestellnr.",
        company: "Unternehmen",
        plan: "Paket",
        billingCycle: "Laufzeit",
        amount: "Betrag",
        paymentMethod: "Zahlungsmethode",
        createdAt: "Erstellt am"
      }
    },
    tickets: {
      title: "Ticketverwaltung",
      subtitle: "Kundensupport-Tickets suchen, prüfen und beantworten.",
      create: "Neues Ticket",
      createTitle: "Ticket erstellen",
      detailTitle: "Ticketdetails",
      searchPlaceholder: "Tickets suchen",
      titlePlaceholder: "Tickettitel eingeben",
      categoryPlaceholder: "Ticketkategorie auswählen",
      titleRequired: "Bitte geben Sie einen Tickettitel ein.",
      categoryRequired: "Bitte wählen Sie eine Ticketkategorie aus.",
      empty: "Keine Tickets gefunden.",
      messages: "Nachrichten",
      noMessages: "Noch keine Nachrichten.",
      replyPlaceholder: "Nachricht schreiben",
      sendMessage: "Nachricht senden",
      closeTicket: "Ticket schließen",
      closeConfirmTitle: "Ticket schließen",
      closeConfirmMessage: "Möchten Sie dieses Ticket wirklich schließen?",
      loadError: "Tickets konnten nicht geladen werden.",
      detailError: "Ticketdetails konnten nicht geladen werden.",
      createSuccess: "Ticket erfolgreich erstellt.",
      createError: "Ticket konnte nicht erstellt werden.",
      replyRequired: "Bitte geben Sie eine Nachricht ein.",
      replySuccess: "Nachricht erfolgreich gesendet.",
      replyError: "Nachricht konnte nicht gesendet werden.",
      closeSuccess: "Ticket erfolgreich geschlossen.",
      closeError: "Ticket konnte nicht geschlossen werden.",
      missingId: "Ticket-ID fehlt.",
      columns: {
        id: "Ticket-ID",
        title: "Titel",
        category: "Kategorie",
        createdBy: "Erstellt von",
        createdAt: "Erstellt am"
      }
    },
    auditDashboard: {
      title: "Audit-Übersicht",
      eyebrow: "Executive Command Dashboard",
      subtitle: "Auditkäufe, Berechtigungen, Sitze, Standards und Betriebszustand zentral verfolgen.",
      startNewAudit: "Neues Audit starten",
      activeAuditors: "Aktive Auditoren",
      auditorsAvailable: "{count} Auditoren verfügbar",
      purchasedModules: "Gekaufte Module",
      newThisMonth: "{count} neu in diesem Monat",
      auditsInProgress: "Laufende Audits",
      ongoing: "{count} laufend",
      reportsToReview: "Zu prüfende Berichte",
      viewReports: "Berichte anzeigen",
      activityOverview: "Auditaktivität",
      timePeriods: {
        month: "Monat",
        week: "Woche",
        day: "Tag"
      },
      inProgressAudits: "Laufende Audits",
      projectName: "Projektname",
      leadAuditor: "Leitender Auditor",
      progress: "Fortschritt",
      dueDate: "Fälligkeitsdatum",
      recentReports: "Neueste Berichte",
      completedBy: "Abgeschlossen von {auditor} am {date}",
      loadError: "Audit-Übersicht konnte nicht geladen werden.",
      cards: {
        totalOrders: "Gesamtbestellungen",
        orderMix: "{success} erfolgreich / {pending} ausstehend",
        totalRevenue: "Gesamtumsatz",
        failedOrders: "{count} fehlgeschlagene oder stornierte Bestellungen",
        activeEntitlements: "Aktive Berechtigungen",
        expiring: "{count} laufen bald ab",
        auditorSeats: "Auditor-Sitze",
        adminSeats: "{count} Admin-Sitze",
        catalogItems: "Aktiver Katalog",
        catalogTotal: "{count} Katalogeinträge insgesamt",
        invoiceCoverage: "Rechnungsabdeckung",
        invoiceUploaded: "{count} Bestellungen fakturiert"
      },
      sections: {
        orderMovement: "Bestellentwicklung",
        orderMovementSub: "Tägliches Bestellvolumen der letzten 14 Tage",
        auditHealth: "Audit-Geschäftszustand",
        auditHealthSub: "Erfolg, Rechnungen und Aktivierungen kombiniert",
        revenueMix: "Umsatz nach Paket",
        capabilityComposition: "Leistungszusammensetzung",
        capabilityCompositionSub: "Bestellungen, Sitze, Katalog und Rechnungsbereitschaft",
        entitlementHealth: "Berechtigungszustand",
        entitlementHealthSub: "Aktueller Lizenzlebenszyklus",
        methodMix: "Zahlungsartenmix",
        methodMixSub: "Bestellanzahl nach gewählter Zahlungsart",
        standardDemand: "Standardnachfrage",
        standardDemandSub: "Meistgekaufte Auditvorlagen",
        recentOrders: "Neueste Bestellungen",
        recentOrdersSub: "Aktuelle Kundenkäufe",
        expiringEntitlements: "Ablaufende Berechtigungen",
        expiringEntitlementsSub: "Lizenzen, die innerhalb von 30 Tagen ablaufen"
      },
      labels: {
        healthScore: "Gesundheit",
        orders: "Bestellungen",
        successOrders: "Erfolgreiche Bestellungen",
        auditorSeats: "Auditor-Sitze",
        adminSeats: "Admin-Sitze",
        enabledCatalog: "Aktiver Katalog",
        invoices: "Rechnungen",
        days: "Tage"
      },
      empty: {
        noData: "Keine Daten verfügbar.",
        noOrders: "Keine neuen Bestellungen.",
        noExpiring: "Keine bald ablaufenden Berechtigungen."
      },
      paymentMethods: {
        card: "Karte",
        alipay: "Alipay",
        wechat: "WeChat Pay",
        visa: "Visa",
        mastercard: "Mastercard",
        unknown: "Unbekannt"
      },
      plans: {
        starter: "Starter",
        professional: "Professional",
        enterprise: "Enterprise"
      }
    },
    userManagement: {
      subtitle: "Auditoren, Profile und Kontoberechtigungen verwalten.",
      createAuditor: "Benutzer erstellen",
      allUserTypes: "Alle Benutzertypen",
      typeAdministrator: "Administrator",
      typeAuditor: "Benutzer",
      searchPlaceholder: "Benutzer nach Name oder E-Mail suchen",
      myProfile: "Mein Profil",
      noAuditorsFound: "Keine Auditoren gefunden.",
      userName: "Benutzername",
      email: "E-Mail",
      userType: "Benutzertyp",
      createdDate: "Erstellt am",
      lastUsed: "Zuletzt verwendet",
      showUnassignableUsers: "Nicht zuweisbare Benutzer anzeigen",
      assignSeat: "Sitz zuweisen",
      selectSeat: "Sitz auswählen",
      noAvailableSeats: "Keine verfügbaren Sitze. Bitte kaufen Sie weitere Sitze.",
      assignSeatDeniedTitle: "Sitz kann nicht zugewiesen werden",
      assignSeatDeniedMessage: "Nur Benutzer vom Typ AUDITOR kann ein Sitz zugewiesen werden. Der aktuelle Benutzertyp ist kein Auditor.",
      noAvailableLicence: "Keine verfügbare Lizenz. Bitte kaufen Sie zuerst weitere Lizenzen.",
      neverLogged: "Noch nie angemeldet",
      status: "Status",
      active: "Aktiv",
      inactive: "Inaktiv",
      actions: "Aktionen",
      editAuditor: "Auditor bearbeiten",
      permissionSetting: "Berechtigungseinstellungen",
      changePassword: "Passwort ändern",
      changePasswordTitle: "Passwort ändern",
      delete: "Löschen",
      addAuditorModalTitle: "Auditor hinzufügen",
      firstName: "Vorname",
      lastName: "Nachname",
      cancel: "Abbrechen",
      saving: "Speichern...",
      saveChanges: "Änderungen speichern",
      personalInfo: "Persönliche Informationen",
      phoneNumber: "Telefonnummer",
      nationality: "Nationalität",
      sex: "Geschlecht",
      organizationInfo: "Organisationsdaten",
      organizationName: "Organisationsname",
      legalName: "Rechtlicher Name",
      contactEmail: "Kontakt-E-Mail",
      address: "Adresse",
      quotaInfo: "Kontingentinformationen",
      maxAuditorCount: "Maximale Auditoren",
      accountCreatedDate: "Konto erstellt am",
      close: "Schließen",
      updateSuccess: "Benutzer erfolgreich aktualisiert.",
      addSuccess: "Benutzer erfolgreich hinzugefügt.",
      updateErrorOnceAYear: "Diese Information kann nur einmal pro Jahr geändert werden.",
      saveError: "Benutzer konnte nicht gespeichert werden.",
      loadError: "Auditoren konnten nicht geladen werden.",
      confirmDeleteMsg: "Möchten Sie {userName} wirklich löschen?",
      confirmDeleteTitle: "Auditor löschen",
      deleteSuccess: "Auditor erfolgreich gelöscht.",
      deleteError: "Benutzer konnte nicht gelöscht werden.",
      createAuditorTitle: "Benutzer erstellen",
      basicInfo: "Basisinformationen",
      firstNamePlaceholder: "Vorname eingeben",
      lastNamePlaceholder: "Nachname eingeben",
      emailPlaceholder: "E-Mail-Adresse eingeben",
      password: "Passwort",
      passwordPlaceholder: "Passwort eingeben",
      passwordHint: "Mindestens 8 Zeichen mit Buchstaben und Zahlen verwenden.",
      currentPassword: "Aktuelles Passwort",
      newPassword: "Neues Passwort",
      confirmPassword: "Passwort bestätigen",
      passwordRequired: "Bitte aktuelles Passwort und neues Passwort eingeben.",
      passwordMismatch: "Passwörter stimmen nicht überein.",
      changePasswordSuccess: "Passwort erfolgreich geändert.",
      changePasswordError: "Passwort konnte nicht geändert werden.",
      sexUnknown: "Keine Angabe",
      sexMale: "Männlich",
      sexFemale: "Weiblich",
      birthday: "Geburtsdatum",
      phoneNumberPlaceholder: "Telefonnummer eingeben",
      selectNationality: "Nationalität auswählen",
      addressInfo: "Adressinformationen",
      country: "Land",
      selectCountry: "Land auswählen",
      stateOrProvince: "Bundesland oder Provinz",
      statePlaceholder: "Bundesland oder Provinz eingeben",
      city: "Stadt",
      cityPlaceholder: "Stadt eingeben",
      postalCode: "Postleitzahl",
      postalCodePlaceholder: "Postleitzahl eingeben",
      addressLine1: "Adresszeile 1",
      addressLine1Placeholder: "Straßenadresse eingeben",
      addressLine2: "Adresszeile 2",
      addressLine2Placeholder: "Wohnung, Suite oder Einheit eingeben",
      enableUser: "Benutzer aktivieren",
      creating: "Wird erstellt...",
      createSuccess: "Benutzer erfolgreich erstellt.",
      createError: "Benutzer konnte nicht erstellt werden.",
      permissionDialogTitle: "Berechtigungen für {userName}",
      permissions: "Berechtigungen",
      assignSuccess: "Berechtigungen erfolgreich aktualisiert.",
      permissionLoadError: "Berechtigungsdaten konnten nicht geladen werden.",
      permissionGroups: {
        user: "Benutzerverwaltung",
        permission: "Berechtigungsverwaltung",
        group: "Gruppenverwaltung",
        account: "Kontoverwaltung",
        audit: "Auditverwaltung",
        report: "Berichtsverwaltung"
      }
    },
    permissionManagement: {
      subtitle: "Berechtigungsrichtlinien und Zugriffskontrolle konfigurieren.",
      comingSoon: "Die Berechtigungsverwaltung ist in Kürze verfügbar."
    },
    addOnManagement: {
      subtitle: "Zusätzliche Sprachen, Auditstandards und Lizenzen für das aktuelle Konto kaufen.",
      currentPackage: "Aktuelles Package",
      noPackage: "Kein aktives Package",
      addOnAvailable: "Add-ons verfügbar",
      addOnLocked: "Add-ons gesperrt",
      packageAvailable: "Das aktuelle Package unterstützt Add-on-Sprachen, Standards und Lizenzen.",
      starterRestriction: "Das Starter package unterstützt keine Add-ons. Bitte kaufen Sie ein höheres Package.",
      purchaseDuration: "Laufzeit",
      chooseDuration: "Add-on-Gültigkeit wählen",
      forOneYear: "für 1 Jahr",
      forTwoYears: "für 2 Jahre",
      itemCount: "{count} Einträge",
      standardTemplate: "Auditstandard-Vorlage",
      licenceCapacity: "Zusätzliche Lizenzkapazität",
      currentExpiry: "Aktueller Ablauf: {date}",
      notActive: "Nicht aktiv",
      expiryChange: "Aktuell {current} -> nach Add-on {projected}",
      emptyCategory: "In dieser Kategorie sind keine Add-ons verfügbar.",
      emptySelection: "Wählen Sie ein oder mehrere Add-ons aus, um eine Bestellung zu erstellen.",
      orderSummary: "Bestellung",
      selectedAddOns: "Ausgewählte Add-ons",
      total: "Gesamt",
      confirmAndPay: "Bestätigen und bezahlen",
      summaryNote: "Preise verstehen sich exklusive MwSt. Die endgültige Belastung wird in der Zahlungsbestellung bestätigt.",
      selectRequired: "Bitte wählen Sie mindestens ein Add-on aus.",
      createOrderError: "Add-on-Bestellung konnte nicht erstellt werden.",
      loadErrorTitle: "Add-ons nicht verfügbar",
      loadError: "Add-on-Optionen konnten nicht geladen werden. Bitte aktualisieren und erneut versuchen.",
      checkout: "Checkout",
      completePayment: "Add-on-Zahlung abschließen",
      paymentIntro: "Nutzen Sie dieselben sicheren Zahlungsmethoden wie im Kaufprozess.",
      backToSelection: "Zurück zur Auswahl",
      auditorSeatsName: "{count} Auditor-Lizenzen",
      auditorSeatsDesc: "Zusätzliche Auditor-Sitze für Auditdurchführung und Berichte.",
      adminSeatsName: "{count} Admin-Lizenzen",
      adminSeatsDesc: "Zusätzliche Administrator-Sitze für Benutzer- und Berechtigungsverwaltung.",
      licencesName: "{count} Lizenzen",
      licencesDesc: "Normale Audit-Lizenzen einzeln für Teammitglieder hinzufügen, die Audits durchführen und Berichte erstellen.",
      licenceSelectedCount: "{count} ausgewählt",
      licenceUnitPrice: "{price} / Lizenz / Monat",
      licenceCountLabel: "Lizenzen",
      decreaseLicence: "Lizenzen verringern",
      increaseLicence: "Lizenzen erhöhen",
      singleCapability: "Einzelfunktion",
      seatQuantity: "{count} Sitze",
      categories: {
        languages: {
          title: "Sprachen",
          desc: "Audit-Systemsprachen hinzufügen, ohne das Basispaket zu ändern."
        },
        standards: {
          title: "Standards",
          desc: "Zusätzliche Auditvorlagen kaufen und bestehende verlängern."
        },
        licences: {
          title: "Lizenzen",
          desc: "Normale Lizenzen einzeln hinzufügen; Lieferanten- und Kundenportale bleiben unbegrenzt."
        }
      },
      types: {
        language: "Sprache",
        standard: "Standard",
        licence: "Lizenz",
        auditorSeat: "Auditor-Sitz",
        adminSeat: "Admin-Sitz",
        addOn: "Add-on"
      }
    },
    systemSettings: {
      subtitle: "Organisationsprofil, Adresse und Kontaktdaten verwalten.",
      loading: "Einstellungen werden geladen...",
      orgInfo: "Organisationsdaten",
      orgName: "Organisationsname",
      legalName: "Rechtlicher Name",
      industry: "Branche",
      selectIndustry: "Bitte auswählen",
      regNum: "Registrierungsnummer",
      taxId: "Steuernummer",
      addressContact: "Adresse und Kontakt",
      address: "Adresse",
      country: "Land",
      city: "Stadt",
      postalCode: "Postleitzahl",
      contactEmail: "Kontakt-E-Mail",
      phone: "Telefon",
      loadError: "Organisationseinstellungen konnten nicht geladen werden.",
      updateSuccess: "Organisationseinstellungen erfolgreich aktualisiert.",
      saveError: "Organisationseinstellungen konnten nicht gespeichert werden.",
      industries: {
        healthCare: "Gesundheitswesen",
        dataAndAnalytics: "Daten und Analytik",
        finance: "Finanzdienstleistungen",
        technology: "Technologie",
        education: "Bildung",
        manufacturing: "Fertigung",
        retail: "Einzelhandel",
        transportation: "Transport"
      }
    },
    appManagement: {
      title: "Anwendungsverwaltung",
      subtitle: "Unternehmensanwendungen verwalten - Provision, Suspend, Resume oder Deprovision.",
      keywordPlaceholder: "Nach Anwendungsname, Code oder Unternehmen suchen",
      empty: "Keine Anwendungsdaten verfügbar.",
      loadError: "Anwendungsliste konnte nicht geladen werden.",
      section: {
        active: "Active Anwendungen",
        suspend: "Suspended Anwendungen",
        notProvisioned: "Not Provisioned Anwendungen"
      },
      stats: {
        totalApps: "Gesamtanwendungen",
        activeApps: "Active",
        suspendedApps: "Suspended",
        notProvisionedApps: "Not Provisioned"
      },
      columns: {
        appName: "Anwendungsname",
        company: "Unternehmen",
        status: "Status",
        createdAt: "Aktiviert am",
        expiredAt: "Läuft ab am"
      },
      statusLabels: {
        ACTIVE: "Active",
        SUSPENDED: "Suspended",
        NOT_PROVISIONED: "Not Provisioned",
        DEPROVISIONED: "Deprovisioned"
      },
      actions: {
        provision: 'Provision',
        suspend: 'Suspend',
        resume: 'Resume',
        deprovision: 'Deprovision'
      },
      messages: {
        provisionSuccess: 'Anwendung erfolgreich provisioniert.',
        provisionError: 'Anwendung konnte nicht provisioniert werden.',
        suspendSuccess: 'Anwendung erfolgreich suspendiert.',
        suspendError: 'Anwendung konnte nicht suspendiert werden.',
        resumeSuccess: 'Anwendung erfolgreich fortgesetzt.',
        resumeError: 'Anwendung konnte nicht fortgesetzt werden.',
        deprovisionSuccess: 'Anwendung erfolgreich deprovisioniert.',
        deprovisionError: 'Anwendung konnte nicht deprovisioniert werden.'
      },
      dialogs: {
        deprovision: {
          title: 'Anwendung Deprovision',
          message: 'Sind Sie sicher, dass Sie die Anwendung "{appName}" deprovisionieren möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
          confirm: 'Deprovision bestätigen'
        }
      }
    },
    auditorSeatManagement: {
      title: "Sitzstatus",
      empty: "Keine Sitzdaten verfügbar.",
      loadError: "Sitzdaten konnten nicht geladen werden.",
      forcedLogout: "Sie haben keine Berechtigung, auf diese Seite zuzugreifen. Sie wurden automatisch abgemeldet.",
      goToActivate: "Zur Aktivierung",
      buyNow: "Jetzt kaufen",
      unassigned: "Nicht zugewiesen",
      actions: {
        rename: "Umbenennen",
        assign: "Zuweisen",
        unassign: "Zuweisung aufheben"
      },
      messages: {
        renameSuccess: "Sitz erfolgreich umbenannt.",
        renameError: "Sitz konnte nicht umbenannt werden.",
        assignSuccess: "Prüfer erfolgreich zugewiesen.",
        assignError: "Bitte wenden Sie sich an den Kundenservice, um die Sitzplatzzuweisung aufzuheben.",
        unassignSuccess: "Zuweisung erfolgreich aufgehoben.",
        unassignError: "Bitte wenden Sie sich an den Kundenservice, um die Sitzplatzzuweisung aufzuheben.",
        copied: "Kopiert"
      },
      fields: {
        name: "Name",
        isAuditUser: "Audit-Benutzer",
        auditUserNumeral: "Audit-Benutzer-Nr.",
        auditUserType: "Audit-Benutzertyp",
        notAuditUserPlaceholder: "Noch kein Audit-Benutzer",
        hasSeat: "Sitzstatus",
        hasSeatTooltipTrue: "Bereits einem Sitz zugewiesen",
        hasSeatTooltipFalse: "Kein Sitz zugewiesen",
        email: "E-Mail",
        lastLoginTime: "Zuletzt verwendet",
        yes: "Ja",
        no: "Nein"
      },
      auditUserTypes: {
        AUDITOR: "Prüfer",
        AUDITOR_INTERNAL_USER: "Interner Prüfer-Benutzer",
        SUPPLIER_REPRESENTATIVE: "Lieferantenvertreter",
        SUPPLIER_INTERNAL_USER: "Interner Lieferanten-Benutzer",
        CLIENT: "Mandantenvertreter",
        GUEST: "Gast",
        placeholder: "-"
      },
      dialogs: {
        rename: {
          title: "Sitz umbenennen",
          nameLabel: "Sitzname"
        },
        assign: {
          title: "Prüfer zuweisen",
          auditorLabel: "Prüfer auswählen",
          auditorPlaceholder: "Bitte wählen Sie einen Prüfer",
          searchPlaceholder: "Suche nach Name / E-Mail / Prüfbenutzernummer.",
          countSuffix: "Einträge",
          empty: "Keine übereinstimmenden Benutzer",
          assignableTag: "Zuweisbar",
          unassignableTag: "Nicht zuweisbar",
          warningTitle: "Wichtiger Hinweis",
          warningMessage: "Bitte wählen Sie den zuständigen Prüfer sorgfältig aus. Stellen Sie sicher, dass der richtige Prüfer ausgewählt wurde, bevor Sie fortfahren. Nach der Zuweisung eines Sitzplatzes kann die Zuweisung nicht selbstständig aufgehoben werden. Wenn eine Aufhebung erforderlich ist, wenden Sie sich bitte an den Kundenservice.",
          acknowledgeLabel: "Ich verstehe",
          showUnassignableLabel: "Nicht zuweisbare Benutzer anzeigen",
          nonAuditorBlockTip: 'Nur "Prüfer"-Benutzer können einen Sitz zugewiesen bekommen. Der ausgewählte Benutzer ist kein Prüfer.',
          seatReplaceWarning: "Der diesem Benutzer aktuell zugewiesene Sitz wird ersetzt.",
          notAuditUserInfo: "Sitze können nur Audit-Benutzern zugewiesen werden. Der ausgewählte Benutzer ist noch nicht als Audit-Benutzer registriert. Möchten Sie ihn automatisch als Audit-Prüfer-Benutzer registrieren?",
          autoRegisterLabel: "Automatisch als Prüfer-Benutzer registrieren"
        }
      },
      assignPage: {
        title: "Prüfer zuweisen",
        subtitle: "Wählen Sie einen Prüfer für diesen Sitz. Die Liste zeigt alle Identitäten des Kontos. Bitte sorgfältig auswählen.",
        backToList: "Zurück",
        seatInfoTitle: "Sitzinformation",
        seatNameLabel: "Sitzname",
        seatStatusLabel: "Aktueller Status",
        seatAssigned: "Zugewiesen",
        seatUnassigned: "Nicht zugewiesen",
        loadingSeat: "Sitzinformationen werden geladen",
        seatNotFound: "Sitz nicht gefunden. Bitte kehren Sie zur Liste zurück und versuchen es erneut.",
        confirmAssign: "Zuweisung bestätigen",
        cancel: "Abbrechen"
      }
    },
    accountInfo: {
      title: "Konto",
      subtitle: "Kontodetails und Organisationsinformationen anzeigen.",
      accountDetails: "Kontodetails",
      accountId: "Konto-ID",
      accountType: "Kontotyp",
      creationTime: "Erstellungszeit",
      administrator: "Administrator",
      organizationInfo: "Organisationsinformationen",
      loadError: "Kontoinformationen konnten nicht geladen werden.",
      accountIdError: "Konto-ID konnte nicht abgerufen werden.",
      copied: "Kopiert",
      copyFailed: "Kopieren fehlgeschlagen",
      change: "ändern",
      changeAdminTip: "Bitte wenden Sie sich an den Kundenservice, um den Kontoadministrator zu ändern.",
      close: "Schließen",
      organization: {
        name: "Organisationsname",
        legalName: "Rechtlicher Name",
        contactEmail: "Kontakt-E-Mail",
        phoneNumber: "Telefonnummer",
        industries: "Branchen",
        taxIdentificationNumber: "Steuernummer",
        legalRepresentative: "Rechtsvertreter",
        registration: "Registrierung",
        registrationNumber: "Registrierungsnummer",
        registrationType: "Registrierungstyp",
        registrationDocument: "Registrierungsdokument",
        countryOrRegion: "Land/Region",
        stateOrProvince: "Bundesland/Provinz",
        city: "Stadt",
        postalCode: "Postleitzahl",
        address: "Adresse",
        addressLine1: "Adresszeile 1",
        addressLine2: "Adresszeile 2"
      },
      invoiceInfo: {
        title: "Rechnungsinformationen",
        addButton: "Rechnungsinformationen hinzufügen",
        empty: "Noch keine Rechnungsinformationen",
        dialogTitleAdd: "Rechnungsinformationen hinzufügen",
        dialogTitleEdit: "Rechnungsinformationen bearbeiten",
        fields: {
          title: "Firmenname",
          invoiceType: "Rechnungstyp",
          taxId: "Steuernummer",
          address: "Adresse",
          phone: "Telefon",
          bankName: "Bankname",
          bankAccount: "Bankkonto",
          bankAddresses: "Bankadressen"
        },
        addBankAddress: "Bankadresse hinzufügen",
        edit: "Bearbeiten",
        default: "Standard",
        setDefault: "Als Standard festlegen",
        delete: "Löschen",
        save: "Speichern",
        cancel: "Abbrechen",
        deleteConfirm: "Diese Rechnungsinformationen löschen?",
        loadError: "Rechnungsinformationen konnten nicht geladen werden.",
        saveSuccess: "Rechnungsinformationen gespeichert.",
        deleteSuccess: "Rechnungsinformationen gelöscht.",
        saveFailed: "Rechnungsinformationen konnten nicht gespeichert werden.",
        deleteFailed: "Rechnungsinformationen konnten nicht gelöscht werden.",
        titleRequired: "Bitte geben Sie den Rechnungstitel ein."
      }
    }
  },
  newFeatures: {
    title: "Neue Funktionen",
    sectionTitle: "Innovative Audit-Lösungen",
    sectionSubtitle: "Stärken Sie Unternehmen mit modernster Audit-Technologie und umfassendem Compliance-Management",
    features: [
      {
        icon: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#0991d3\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"11\" cy=\"11\" r=\"8\"/><line x1=\"21\" y1=\"21\" x2=\"16.65\" y2=\"16.65\"/></svg>",
        title: "Intelligente Analytik",
        desc: "Fortschrittliche, leistungsstarke Analysen zur Identifizierung von Risiken und Anomalien in Ihren Prüfprozessen mit beispielloser Genauigkeit."
      },
      {
        icon: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#0991d3\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><line x1=\"18\" y1=\"20\" x2=\"18\" y2=\"10\"/><line x1=\"12\" y1=\"20\" x2=\"12\" y2=\"4\"/><line x1=\"6\" y1=\"20\" x2=\"6\" y2=\"14\"/></svg>",
        title: "Echtzeit-Reporting",
        desc: "Erstellen Sie umfassende Auditberichte in Echtzeit mit interaktiven Dashboards und anpassbaren Metriken."
      },
      {
        icon: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#0991d3\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z\"/></svg>",
        title: "Compliance-Management",
        desc: "Bleiben Sie durch automatisierte Überwachungs- und Warnsysteme konform mit Industriestandards und -vorschriften."
      },
      {
        icon: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#0991d3\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2\"/><circle cx=\"9\" cy=\"7\" r=\"4\"/><path d=\"M23 21v-2a4 4 0 0 0-3-3.87\"/><path d=\"M16 3.13a4 4 0 0 1 0 7.75\"/></svg>",
        title: "Kollaborative Plattform",
        desc: "Ermöglichen Sie eine nahtlose Zusammenarbeit zwischen Prüfungsteams mit integrierten Kommunikations- und Workflow-Management-Tools."
      }
    ]
  },
  newServices: {
    sectionTitle: "Professionelle Professionelle Audit-Service",
    sectionSubtitle: "Umfassende Audit-Lösungen, die auf die individuellen Betriebs-, Compliance- und Risikomanagementanforderungen Ihres Unternehmens zugeschnitten sind",
    learnMore: "Erfahren Sie mehr",
    cards: [
      {
        icon: "<img src=\"/img/3d-icons/financial.png\" alt=\"Symbol für Finanzprüfung\" />",
        title: "Finanzprüfung",
        desc: "Optimieren Sie die Geschäftsprozesse und die betriebliche Effizienz Ihrer Lieferanten oder Ihrer Lieferanten durch detaillierte Betriebsprüfungen und Empfehlungen."
      },
      {
        icon: "<img src=\"/img/3d-icons/it-security.png\" alt=\"IT-Sicherheitsaudit-Symbol\" />",
        title: "IT-Sicherheitsaudit",
        desc: "Gründliche Bewertung Ihrer IT-Infrastruktur, Identifizierung von Schwachstellen und Gewährleistung robuster Cybersicherheitsmaßnahmen."
      },
      {
        icon: "<img src=\"/img/3d-icons/security.png\" alt=\"Compliance-Audit-Symbol\" />",
        title: "Compliance-Audit",
        desc: "Stellen Sie mit unseren spezialisierten Compliance-Audit-Services die Einhaltung von Branchenvorschriften und -standards sicher."
      },
      {
        icon: "<img src=\"/img/3d-icons/compliance.png\" alt=\"Symbol für Betriebsprüfung\" />",
        title: "Betriebsprüfung",
        desc: "Optimieren Sie Ihre Geschäftsprozesse und betriebliche Effizienz durch detaillierte Betriebsprüfungen und Empfehlungen."
      }
    ]
  },
  home: {
    banner: {
      title: "Industry Brain-Plattform",
      description: "Datengesteuerte Informationsplattform, die Regierung und Markt verbindet und eine hochwertige industrielle Entwicklung ermöglicht",
      title1: "Audit-Plattform der nächsten Generation",
      title2: "Transformieren Sie Ihren Prüfungsprozess mit gesteuerter Technologie und Echtzeit-Compliance-Überwachung",
      subtitle1: "Intelligente Risikobewertung",
      subtitle2: "Fortschrittliche Analysen und maschinelles Lernen zur Vorhersage, Identifizierung und Minderung von Risiken, bevor sie sich auf Ihr Unternehmen auswirken",
      button: "Kostenlose Testversion starten",
      features: [
        "Unterstützte Audit-Analysen",
        "Compliance-Überwachung in Echtzeit",
        "Automatisierte Risikobewertung",
        "Umfassendes Reporting-Dashboard"
      ]
    },
    carousel: {
      items: [
        {
          kicker: "AUDIT-SOFTWARE",
          description: "Audit-Vorlagen, Standards und Durchführung übersichtlich in einem vernetzten Arbeitsbereich verwalten.",
          metrics: [
            { value: "12+", label: "Vorlagen" },
            { value: "1-2 J.", label: "Lizenzierung" },
            { value: "Cloud", label: "Bereitstellung" }
          ]
        },
        {
          kicker: "COMPLIANCE-PLATTFORM",
          description: "Für moderne Qualitätsteams, die einfachere Kontrolle, schnellere Zusammenarbeit und nachvollziehbare Aufzeichnungen benötigen.",
          metrics: [
            { value: "ISO", label: "Bereit" },
            { value: "Team", label: "Gemeinsame Nutzung" },
            { value: "Live", label: "Aufzeichnungen" }
          ]
        }
      ]
    },
    introduction: {
      title: "Was ist Industry Brain?",
      subtitle: "Datenzentrierte, szenariogesteuerte und serviceorientierte industrielle digitale Infrastruktur"
    },
    sections: {
      government: {
        title: "Regierungsseite",
        desc: "Makroüberwachung, Richtlinienbewertung, Industrieprofilierung, Standortauswahl und Präzisionsdienste"
      },
      market: {
        title: "Marktseite",
        desc: "Unternehmenseinblicke, Wettbewerbsanalysen, Investitionsabgleich, Vermittlung von Angebot und Nachfrage und betriebliche Ermöglichung"
      }
    },
    coreScenes: {
      title: "Kernszenarien",
      subtitle: "Von der Überwachung, Bewertung und Kartierung bis hin zur Investition, die den gesamten Prozess abdeckt"
    },
    advantages: {
      title: "Unsere Vorteile"
    }
  },
  news: {
    title: "Neuigkeiten und Updates",
    items: [
      {
        plate: "Unternehmensnachrichten",
        title: "Unsere Gruppe erzielt Rekordwachstum",
        desc: "Wir sind stolz, eine bemerkenswerte Wachstumsphase für unser Unternehmen ankündigen zu können."
      },
      {
        plate: "Neue Funktionen/Updates",
        title: "Automatisierung mehrerer Prüfschritte",
        desc: "Unsere neuen Features verbessern die zielgerichtete Prüfung einzelner Standards."
      },
      {
        plate: "Neue Vorlagen",
        title: "Mehr Variation führt zu mehr Effizienz und Effektivität",
        desc: "Durch die Erweiterung unserer Templates können unsere Kunden ein breites Spektrum an Standards abdecken."
      },
      {
        plate: "Informationssicherheit und Datenschutz",
        title: "Informationssicherheit und Datenschutz durch Berechtigungsmanagement",
        desc: "Informationssicherheit und Datensicherheit wird durch unsere Software gewährleistet. Sämtliche Informationen und Daten des Auditmanagements verbleiben bei der Organisation."
      },
      {
        plate: "Neue ISO 14001",
        title: "Neue ISO 14001",
        desc: "Neue ISO 14001"
      }
    ]
  },
  growth: {
    title: "Unsere Gruppe erzielt Rekordwachstum",
    tags: { innovation: "Innovation", excellence: "Exzellenz", global: "Globales Wachstum" },
    content: "Wir sind stolz, eine bemerkenswerte Wachstumsphase für unser Unternehmen ankündigen zu können. In den letzten Monaten haben wir in allen Bereichen unseres Unternehmens erhebliche Fortschritte erzielt – von der Erweiterung unseres Kundenstamms und der Steigerung des Umsatzes bis hin zur Einführung innovativer Produkte und der Vergrößerung unseres Teams. Dieses Wachstum ist ein direktes Ergebnis des Engagements, der Zusammenarbeit und der Vision unseres unglaublichen Teams sowie der kontinuierlichen Unterstützung unserer geschätzten Kunden und Partner."
  },
  automation: {
    title: "Automatisierung mehrerer Prüfschritte",
    content: "Unsere neuen Features verbessern die zielgerichtete Prüfung der einzelnen Standards. Eine Erhöhung der Kontinuität des Prüfungsmanagements ermöglicht dem Prüfer eine intuitive und professionelle Handhabung des Prüfungsprozesses. Die Automatisierung mehrerer Schritte im Prüfungsprozess unter Berücksichtigung des Plan-Do-Check-Act (PDCA)-Ansatzes ermöglicht deutliche Verbesserungen der Prüfungsqualität sowie eine vereinfachte Umsetzung."
  },
  variation: {
    title: "Mehr Variation führt zu mehr Effizienz und Effektivität",
    content: "Durch die Erweiterung unserer Templates können unsere Kunden ein breites Spektrum an Standards abdecken. Die Vorlagen wurden mit internationalen Experten und externen Prüfern verschiedener Standards entwickelt. Dies ermöglicht eine optimale Gestaltung der gesamten Audit-Software nach den Prinzipien des Lean Managements. Ein professionelles Auditmanagement ist ein entscheidender Baustein für den Erfolg einer Organisation. Bei der Entwicklung unserer Audit-Software wurde die Integration der gesamten Lieferkette berücksichtigt. Unsere Software und die individuellen Vorlagen unterstützen die Steigerung der Effektivität und Effizienz der Audits unserer Kunden."
  },
  security: {
    title: "Informationssicherheit und Datenschutz durch Berechtigungsmanagement",
    content: "Informationssicherheit sowie Datensicherheit wird durch unsere Software gewährleistet. Sämtliche Informationen und Daten des Auditmanagements verbleiben bei der Organisation. Die verwendete Cloud basiert auf den Standards TISAX und ISO 2700X. Ein von der Organisation gesteuertes Berechtigungsmanagementsystem definiert den Zugriff anderer Parteien auf die gespeicherten Informationen und Daten. Auf diese Weise kann der Zugriff durch die Organisation so geregelt werden, dass die Informationen und Daten stets im Organisationsbereich verbleiben."
  },
  newiso: {
    title: "Neue ISO 14001",
    content: "Wir freuen uns, Ihnen mitteilen zu können, dass wir Ihnen bereits die neue aktualisierte ISO 14001-Auditvorlage zur Verfügung stellen können. Selbstverständlich steht Ihnen weiterhin die alte Audit-Version der ISO 14001 zur Verfügung. Für unsere bestehenden Kunden, die über die Audit-ISO 14001-Vorlage verfügen, fallen keine zusätzlichen Kosten an und sie können beide Audit-Vorlagen verwenden."
  },
  coreCompetence: {
    title: "Warum LPT-Technologie",
    subtitle: "Führend bei der Transformation der Prüfungspraxis durch Innovation, Fachwissen und Technologie",
    technology: {
      title: "Spitzentechnologie",
      description: "Basierend auf fortschrittlicher Technologie und Standards bieten Ihnen unsere Lösungen eine höhere Integration, mehr Automatisierung und schlankes Denken für beispiellose Genauigkeit und Effizienz",
      pointsTitle: "Innovative Audit-Management-Technologie",
      points: [
        "Intelligente Audit-Automatisierung, die die Arbeitseffizienz deutlich verbessert",
        "Identifizieren Sie Compliance-Risiken genau und stellen Sie so einen robusten Geschäftsbetrieb sicher",
        "Auf Big Data basierende Erkenntnisse, die die wissenschaftliche Entscheidungsfindung unterstützen",
        "Echtzeitüberwachung ungewöhnlicher Transaktionen, Warnung vor potenziellen Risiken"
      ],
      features: [
        "Exzellente Finanzdienstleistungsprüfung",
        "Compliance im Gesundheitswesen und in den Biowissenschaften",
        "Prüfung der Fertigungs- und Lieferkette",
        "Prüfung von Technik und Software",
        "Compliance im Energie- und Versorgungsbereich",
        "Immobilien- und Bauprüfung",
        "Einzelhandels- und E-Commerce-Audit",
        "Prüfung der Regierung und des öffentlichen Sektors",
        "Non-Profit- und NGO-Audit"
      ]
    },
    experience: {
      title: "Expertenerfahrung",
      description: "Reichhaltige europäische und internationale Prüfungserfahrung mit tiefem Verständnis der Branchen-Compliance-Anforderungen",
      globalDataTitle: "Globales Audit-Datenzentrum",
      globalDataDesc: "Weltweit <span>über 10.000</span> offizielle Datenquellen <span>über 10</span>",
      statistics: [
        {
          title: "≥10",
          desc: "Prüfungsstandards"
        },
        {
          title: "20.000+",
          desc: "Risikoindikatoren"
        },
        {
          title: "≥12",
          desc: "Audit-Tools"
        },
        {
          title: "55+",
          desc: "Länder"
        },
        {
          title: "1.000+",
          desc: "Kunden"
        },
        {
          title: "25+",
          desc: "Audit-Experten"
        },
        {
          title: "10.000+",
          desc: "Audit-Aufzeichnungen"
        }
      ]
    },
    team: {
      title: "Mehr als Auditmanagement",
      description: "Internationales Team bestehend aus erfahrenen Revisionsexperten und technischen Spezialisten",
      upgradeTitle: "Unterstützung der intelligenten Aktualisierung von Prüfdaten",
      capabilities: [
        {
          title: "Innovative Wirtschaftsprüfung",
          description: "Gehen Sie in der Wirtschaftsprüfung voran, indem Sie den digitalen Vorteil unserer Auditmanagement-Software nutzen"
        },
        {
          title: "Professionelles Tech-Team",
          description: "Sicherstellung der Kontinuität des Auditmanagements durch automatisierte Prozesse"
        },
        {
          title: "Decken Sie die Standard-Prüfungsanforderungen mit einer Software ab",
          description: "Unsere Software wird mit mehreren internationalen externen Prüfern und Unternehmen auf der ganzen Welt getestet und entwickelt, um die Anforderungen verschiedener Standards für das Prüfungsmanagement abzudecken. Profitieren Sie von dieser Expertise."
        },
        {
          title: "Mehr als Wirtschaftsprüfung",
          description: "Verbinden Sie Ihr Netzwerk mit der Audit-Management-Welt Ihrer Organisation. Legen Sie Ihre eigenen Berechtigungsanforderungen für Ihre Netzwerkzugriffe fest."
        }
      ]
    }
  },
  footer: {
    government: "Zentrale Volksregierung",
    ministryIndustry: "Ministerium für Industrie und Informationstechnologie",
    ministryForeign: "Außenministerium",
    products: "Produkte",
    audit: "Prüfung",
    contentCenter: "Inhaltscenter",
    industryReports: "Branchenberichte",
    contactUs: "Kontaktieren Sie uns",
    cityZhuhai: "Zhuhai",
    addressDetail: "Gebäude 02, 21. Etage, Nr. 2103, Meixi Commercial Plaza, 168 Lvyou Road, Bezirk Xiangzhou, Stadt Zhuhai, China",
    email: "Customer Service",
    copyright: "Copyright © 2026 Lucky Phoenix (Zhuhai) Technology Co. Limited. Alle Rechte vorbehalten.",
    icp: "粤 ICP 备 2025411415 号",
    emailHint: "Bitte geben Sie Ihr Konto ein."
  },
  company: {
    name: "LPT-Technologie",
    fullName: "Lucky Phoenix (Zhuhai) Technology Co., Ltd.",
    description: "Ein führendes Technologieunternehmen, das sich auf die Bereitstellung innovativer Audit- und Managementsystemlösungen einschließlich Dienstleistungen für lokale und globale Organisationen konzentriert",
    tagline: "",
    aboutUs: "Über uns",
    subtitle: "Innovationen in der Audit-Management-Technologie vorantreiben.",
    missionTitle: "Unsere Mission",
    missionDesc: "Um Organisationen weltweit mit intelligenten, sicheren und effizienten Audit-Management-Lösungen auszustatten.",
    visionTitle: "Unsere Vision",
    visionDesc: "Wir werden zum globalen Standard für digitale Audit-Compliance und Risikomanagement.",
    galleryTitle: "Leben bei LPT",
    galleryDesc: "Ein Einblick in unseren Arbeitsbereich, unsere Teamkultur und unsere täglichen Abläufe.",
    whoWeAre: "Wer wir sind",
    introText: "LPT ist bestrebt, modernste Audit-Management-Lösungen anzubieten, die auf globale Unternehmen zugeschnitten sind.",
    ourHistory: "Unsere Geschichte",
    history: {
      events: [
        "Gegründet in der neuen Technologie-Geschäftszone von Zhuhai",
        "Beginnen Sie im Büro in Zhuhai Hengqin mit dem neuen Geschäftsbereich Technologie",
        "Unser erster Software-Launch in China",
        "Unsere Softwareeinführung in anderen Regionen Asiens",
        "Einführung zusätzlicher Audit-Tools",
        "Start unseres neuen Softwareprojekts",
        "Wir sind stolz darauf, dass unser Wachstum und Erfolg uns zu einem neuen Büro mit neuem Technologielabor im Herzen der Stadt Zhuhai führen.",
        "Einführung unserer neuen Software-Management-Plattform",
        "Die Zukunft wartet"
      ]
    },
    joinUsTitle: "Treten Sie unserem Team bei",
    joinUsDesc: "Entdecken Sie Ihr Potenzial und wachsen Sie mit uns. Wir sind immer auf der Suche nach leidenschaftlichen Talenten für unser dynamisches Team.",
    exploreJobs: "Entdecken Sie offene Stellen",
    customersTitle: "Unsere Kunden",
    customersDescription: "Wir schaffen kontinuierlich einzigartigen Mehrwert für unsere Nutzer",
    customerStats: {
      provinceCount: "22", cityCount: "40+", parkCount: "150+", companyCount: "10.000+",
      provinces: "Provinzen", cities: "Städte", parks: "Industrieparks", companies: "Unternehmen"
    }
  },
  jobs: {
    title: "Offene Stellen",
    intro: "Die LPT Company ist Teil der globalen Infinity Source Group. Durch unsere Mitgliedschaft haben wir Zugriff auf ein breites Spektrum an Ressourcen. LPT hat seinen Hauptsitz im Herzen der Stadt Zhuhai, China. Die Geschäftsfelder umfassen Anwendungen und Software sowie proaktive Beratung mit Schwerpunkt auf der IT-Branche. LPT baut ein professionelles und dynamisches Team neuen Typs auf. Wir setzen auf innovative und visionäre Arbeitsmethoden.",
    advantagesTitle: "Welche Vorteile bieten wir Ihnen als Mitglied unseres Teams:",
    advantages: [
      "Sie können im Büro oder von überall auf der Welt arbeiten (es gibt keinen festen Arbeitsbereich)",
      "Zugriff auf die neueste Technologie und Ausrüstung",
      "Verschiedene Bonusprogramme",
      "Kostenloses Wasser im Büro",
      "Überdurchschnittlich viele Urlaubstage",
      "Kostenloser Zugang zu unserem Gaming-Bereich im Büro",
      "Arbeiten Sie mit einem ambitionierten, professionellen und aufgeschlossenen Team",
      "Offenes, dynamisches und professionelles Arbeitsumfeld",
      "Vollvergütete Arbeitsausrüstung für zu Hause und am Arbeitsplatz",
      "Innovative und zukunftsweisende Projekte"
    ],
    positionsTitle: "Aktuelle Stellenangebote",
    positions: [
      {
        title: "UX/Interaktionsdesigner",
        overview: "Verantwortlich für UI-Design für Web, App und H5",
        expectTitle: "Was wir erwarten:",
        expectations: [
          "Offene und zielorientierte Kommunikation",
          "Arbeiten Sie selbstständig und professionell",
          "Seien Sie aufgeschlossen gegenüber neuen Lösungen und Herausforderungen",
          "Chinesische Sprachkenntnisse",
          "Schriftliche Kommunikation in englischer Sprache (die Verwendung einer Übersetzungssoftware ist ausreichend)",
          "Erfahrung im Design von Mensch-Computer-Interaktionen (HCI).",
          "Nutzen Sie die Designsprache, um Design und Interaktion zu verbessern",
          "Erfahrung in der Bereitstellung hochwertiger Lösungen in den Bereichen Anwendungs-, Software- und Webdesign",
          "Fähigkeit zur Designerfahrung, die in der Lage ist, Produktabsichten durch Designlösungen effektiv zu vermitteln",
          "Mehr als 2 Jahre Erfahrung als UX-Designer oder Interaktionsdesigner"
        ],
        softwareTitle: "Vertraut mit designbezogener Software und Plattformen, wie zum Beispiel:",
        software: [
          "Lanhu",
          "Figma",
          "Photoshop",
          "Illustrator",
          "Azurblau",
          "Skizzieren",
          "InVision",
          "XMIND",
          "Visio",
          "oder ähnliches"
        ],
        responsibilitiesTitle: "",
        responsibilities: []
      },
      {
        title: "Marketingspezialist",
        overview: "Wir suchen einen Marketingspezialisten",
        expectTitle: "Was wir erwarten:",
        expectations: [
          "Offene und zielorientierte Kommunikation",
          "Arbeiten Sie selbstständig und professionell",
          "Seien Sie aufgeschlossen gegenüber neuen Lösungen und Herausforderungen",
          "Chinesische Sprachkenntnisse",
          "Schriftliche Kommunikation in englischer Sprache (die Verwendung einer Übersetzungssoftware ist ausreichend)",
          "Erfahrung im Technologiemarketing",
          "Erfahrung mit sozialen Medien",
          "Erfahrung in der Bereitstellung hochwertiger Marketinglösungen einschließlich sozialer Medien",
          "Offen für Reisen (falls relevant)",
          "Mehr als 3 Jahre Erfahrung im Marketing"
        ],
        softwareTitle: "",
        software: [],
        responsibilitiesTitle: "Verantwortlich für den Web- und Social-Media-Auftritt:",
        responsibilities: [
          "Marketingbezogenes Webdesign",
          "Social-Media-Auftritt",
          "Marketingveranstaltungen"
        ]
      },
      {
        title: "Backend Entwickler",
        overview: "Wir suchen einen Softwareentwickler",
        expectTitle: "Was wir erwarten:",
        expectations: [
          "Offene und zielorientierte Kommunikation",
          "Arbeiten Sie selbstständig und professionell",
          "Seien Sie aufgeschlossen gegenüber neuen Lösungen und Herausforderungen",
          "Chinesische Sprachkenntnisse",
          "Schriftliche Kommunikation in englischer Sprache (die Verwendung einer Übersetzungssoftware ist ausreichend)",
          "Erfahrung in der Bereitstellung hochwertiger Backend-Lösungen in Anwendung und Software",
          "Mehr als 2 Jahre Erfahrung als Backend-Entwickler",
          "Vertraut mit RESTful API-Designmustern und Best Practices",
          "Erfahrung mit Versionskontrolle und Code-Review-Prozessen",
          "Starke Problemlösungsfähigkeiten und Liebe zum Detail"
        ],
        softwareTitle: "Wenn Sie in einigen der genannten oder ähnlichen Bereiche über Fähigkeiten verfügen, sind Sie hier genau richtig.",
        software: [
          "Backend-APIs (Application Programming Interfaces)",
          "VUE",
          "MySQL",
          "Nginx",
          "MyBatis",
          "JavaScript",
          "Docker",
          "GitHub, GitLab",
          "PHPStorm oder WebStorm",
          "Postman",
          "JSON",
          "Laravel 9 oder ähnlich",
          "PHP 8 oder ähnlich",
          "Progressive Web Applications (PWA)",
          "Datenstrukturen und Algorithmen (DSA)",
          "Azure Cloud oder Alibaba Cloud Erfahrung"
        ],
        responsibilitiesTitle: "Verantwortlich für:",
        responsibilities: [
          "Backend-Infrastruktur",
          "Schnittstelle zwischen Backend und Frontend-Cloud-Entwicklung",
          "Backend-Framework",
          "API-Entwicklung und -Integration",
          "Datenbank"
        ]
      },
      {
        title: "Frontend Entwickler",
        overview: "Wir suchen einen Softwareentwickler",
        expectTitle: "Was wir erwarten:",
        expectations: [
          "Offene und zielorientierte Kommunikation",
          "Arbeiten Sie selbstständig und professionell",
          "Seien Sie aufgeschlossen gegenüber neuen Lösungen und Herausforderungen",
          "Chinesische Sprachkenntnisse",
          "Schriftliche Kommunikation in englischer Sprache (die Verwendung einer Übersetzungssoftware ist ausreichend)",
          "Erfahrung in der Bereitstellung hochwertiger Frontend-Lösungen in Anwendung und Software",
          "Mehr als 2 Jahre Erfahrung als Frontend-Entwickler",
          "Vertraut mit modernen Webstandards, Barrierefreiheit und responsivem Design",
          "Erfahrung mit Versionskontrolle und Code-Review-Prozessen",
          "Starke Problemlösungsfähigkeiten und Liebe zum Detail"
        ],
        softwareTitle: "Wenn Sie in einigen der genannten oder ähnlichen Bereiche über Fähigkeiten verfügen, sind Sie hier genau richtig.",
        software: [
          "HTML",
          "JavaScript",
          "GitLab Repository",
          "GitLab CI/CD Automatisierte Bereitstellung",
          "React",
          "Angular",
          "Document Object Model (DOM)",
          "Jest, Mocha oder ähnlich",
          "CSS",
          "Vue",
          "Azure Cloud oder Alibaba Cloud Erfahrung"
        ],
        responsibilitiesTitle: "Verantwortlich für:",
        responsibilities: [
          "Frontend-Infrastruktur",
          "Schnittstelle zwischen Frontend und Backend",
          "Cloud-Entwicklung",
          "Frontend-Framework",
          "API-Entwicklung und -Integration",
          "Datenbank"
        ]
      }
    ],
    applyNow: "Bewerbung einreichen"
  },
  buy: {
    hero: {
      title: "Audit-Management-Lösung",
      subtitle: "Überblick über Ihre Audit-Management-Lösung für mehr Flexibilität, mehr Automatisierung und höhere Effizienz."
    },
    steps: {
      badge: {
        step1: 'Schritt 1 / 6: Paket auswählen',
        step2: 'Schritt 2 / 6: Sprache auswählen',
        step3: 'Schritt 3 / 6: Prüfungsstandards',
        step4: 'Schritt 4 / 6: Auditor-Lizenzen',
        step5: 'Schritt 5 / 6: Bestellung prüfen',
        step6: 'Schritt 6 / 6: Zahlung'
      },
      plan: {
        title: "Paket auswählen",
        subtitle: "Wählen Sie Ihr Abonnement"
      },
      languages: {
        title: "Sprache auswählen",
        subtitle: "Audit-Systemsprachen auswählen"
      },
      standards: {
        title: "Prüfungsstandards",
        subtitle: "Wählen Sie Vorlagen aus"
      },
      seats: {
        title: "Auditor-Lizenzen",
        subtitle: "Teamgröße konfigurieren"
      },
      confirm: {
        title: "Überprüfen Sie die Bestellung",
        subtitle: "Überprüfen und bezahlen"
      },
      payment: {
        title: "Zahlung",
        subtitle: "Kaufabwicklung abschließen"
      }
    },
    currency: {
      label: "Währung"
    },
    summary: {
      projectSummary: "Projektübersicht",
      priceSummary: "Preisübersicht",
      selectedPlan: "Ausgewähltes Paket",
      billingCycle: "Abonnementperiode",
      year1: "1 Jahr",
      year2: "2 Jahre",
      year3: "3 Jahre",
      selectedLanguages: "Ausgewählte Sprachen",
      selectedStandards: "Ausgewählte Standards",
      auditorSeats: "Auditor-Lizenzen",
      adminSeats: "Admin-Lizenzen",
      supplierSeats: "Lieferanten-Lizenzen",
      unlimited: "Unbegrenzt",
      estimatedTotal: "Geschätzter Gesamtbetrag",
      amountToPay: "Zu zahlender Betrag"
    },
    languages: {
      title: "Sprachen auswählen",
      subtitle: "Wählen Sie die im Paket enthaltenen Audit-Systemsprachen aus.",
      selectedCount: "{count} Sprachen ausgewählt",
      limitCount: "Bis zu {count} Sprachen",
      limitUnlimited: "Unbegrenzte Sprachen",
      infoLimited: "Dieses Paket enthält bis zu {count} Sprachen. Sie können die Auswahl vor der Zahlung ändern.",
      infoUnlimited: "Das Enterprise-Paket enthält alle verfügbaren Audit-Systemsprachen.",
      limitReached: "Dieses Paket erlaubt bis zu {count} Sprachen.",
      minimumRequired: "Bitte behalten Sie mindestens eine Sprache ausgewählt.",
      items: {
        english: "Englisch",
        french: "Französisch",
        spanish: "Spanisch",
        chinese: "Chinesisch",
        german: "Deutsch",
        polish: "Polnisch",
        czech: "Tschechisch",
        slovak: "Slowakisch",
        hungarian: "Ungarisch",
        romanian: "Rumänisch",
        bulgarian: "Bulgarisch",
        serbian: "Serbisch",
        croatian: "Kroatisch",
        slovenian: "Slowenisch"
      }
    },
    nav: {
      prev: "Vorherige",
      next: "Nächste",
      completePurchase: "Kaufabwicklung abschließen",
      processing: "Verarbeitung...",
      purchaseSuccess: "Kauf erfolgreich!",
      purchaseError: "Der Kauf ist fehlgeschlagen. Bitte versuchen Sie es erneut."
    },
    trust: {
      secure: "256-Bit-SSL-Verschlüsselung",
      moneyBack: "30-tägige Geld-zurück-Garantie",
      support: "Expertenunterstützung rund um die Uhr",
      cancel: "Jederzeit kündbar"
    },
    plan: {
      monthly: "1 Jahr",
      yearly: "2 Jahre",
      perMonth: "Jahr",
      perYear: "3 Jahre",
      savePercent: "Sparen Sie {percent}%",
      billedAnnually: "Jährliche Abrechnung",
      billedForTwoYears: "Abrechnung für 2 Jahre",
      mostPopular: "Am beliebtesten",
      selectPlan: "Wählen Sie Planen aus",
      selected: "Ausgewählt",
      compareFeatures: "Vergleichen Sie alle Funktionen",
      feature: "Besonderheit",
      noPlans: "Keine Tarife verfügbar",
      plans: {
        starter: {
          name: "Starter-Paket",
          desc: "Perfekt für kleine Teams, die mit formalisierter Prüfung beginnen.",
          features: [
            "1 Wirtschaftsprüferlizenz",
            "Mehrere Audit-Vorlagen",
            "Zugang zum Lieferantenportal",
            "Eine Sprache",
            "Online-/Offline-Modus",
            "Risikobewertung",
            "SSO und erweiterte Sicherheit"
          ]
        },
        professional: {
          name: "Professional-Paket",
          desc: "Für wachsende Unternehmen mit erweiterten Prüfungsanforderungen.",
          features: [
            "Mehrere Auditorenlizenzen",
            "Mehrere Audit-Vorlagen",
            "Zugang zum Lieferantenportal",
            "Mehrere Sprachen",
            "Unternehmensberichterstattung",
            "Online-/Offline-Modus",
            "Risikobewertung",
            "SSO und erweiterte Sicherheit"
          ]
        },
        enterprise: {
          name: "Enterprise-Paket",
          desc: "Vollständige Audit-Governance für große Organisationen.",
          features: [
            "Mehrere Auditorenlizenzen",
            "Mehrere Audit-Vorlagen",
            "Zugang zum Lieferantenportal",
            "Mehrere Sprachen",
            "Unternehmensberichterstattung",
            "Unternehmensunterstützung",
            "Online-/Offline-Modus",
            "Risikobewertung",
            "SSO und erweiterte Sicherheit"
          ]
        }
      },
      comparison: {
        auditorSeats: "Mehrere Auditorenlizenzen",
        auditStandards: "Mehrere Audit-Vorlagen",
        supplierPortal: "Zugang zum Lieferantenportal",
        customTemplates: "Mehrere Sprachen",
        aiRiskAssessment: "Unternehmensberichterstattung",
        apiAccess: "Unternehmensunterstützung",
        ssoIntegration: "Online-/Offline-Modus",
        dedicatedSupport: "Engagierte Unterstützung",
        dataRetention: "Datenaufbewahrung",
        storage: "Cloud-Speicher",
        clientSupper: "Zugang zum Kundenportal",
        ssl: "SSL-Verschlüsselung"
      },
      comparisonValues: {
        unlimited: "Unbegrenzt",
        sixMonths: "6 Monate",
        oneYear: "1 Jahr"
      }
    },
    standards: {
      perYear: "Jahr",
      title: "Wählen Sie Audit-Standards aus",
      subtitle: "Wählen Sie die Audit-Standardvorlagen aus, die am besten zu den Anforderungen Ihres Unternehmens passen",
      categories: {
        all: "Alle",
        quality: "Qualität",
        energy: "Energie",
        product: "Produkt",
        environment: "Umfeld",
        process: "Verfahren",
        security: "Informationssicherheit",
        medical: "Medizinisch",
        healthSafety: "Gesundheit/Sicherheit",
        creator: "Schöpfer"
      },
      selectedCount: "{count} Standards ausgewählt",
      moduleCost: "Modulkosten",
      perMonth: "Monat",
      included: "Im Lieferumfang enthalten",
      free: "Frei",
      clauses: "Klauseln",
      infoBanner: "Sie können später in Ihrer Konsole zusätzliche Standards, Sprachen und Lizenzen erwerben.",
      items: {
        iso9001: {
          fullname: "Qualitätsmanagementsysteme (ISO 9001)",
          desc: "Systemische Bewertung des Qualitätsmanagementsystems für alle Branchen und Branchen"
        },
        iatf16949: {
          fullname: "Automobil-Qualitätsmanagementsystem (IATF 16949)",
          desc: "Systemische Bewertung des Qualitätsmanagementsystems in der Automobilindustrie"
        },
        vda63: {
          fullname: "Prozessaudit (VDA 6.3)",
          desc: "Prozessbewertungsverfahren für alle Branchen und Branchen"
        },
        vda65: {
          fullname: "Produktaudit (VDA 6.5)",
          desc: "Systematische Bewertung des Qualitätsstandards der hergestellten Produkte."
        },
        iso14001: {
          fullname: "Umweltmanagement (ISO 14001)",
          desc: "Systemische Bewertung des Umweltmanagementsystems"
        },
        iso140012026: {
          fullname: "Umweltmanagement (ISO 14001)",
          desc: "Systemische Bewertung des Umweltmanagementsystems"
        },
        iso45001: {
          fullname: "Arbeitssicherheit und Gesundheitsschutz (ISO 45001)",
          desc: "Systemische Bewertung des Umweltmanagementsystems"
        },
        iso27001: {
          fullname: "Informationssicherheit (ISO 27001)",
          desc: "Systemische Bewertung des Informationssicherheitsmanagementsystems"
        },
        tisax: {
          fullname: "Informationssicherheit (TISAX ISA)",
          desc: "Systemische Bewertung des Informationssicherheitsmanagementsystems"
        },
        iso13485: {
          fullname: "Medizinisches Management (ISO 13485)",
          desc: "Systemische Bewertung des medizinischen Managementsystems"
        },
        iso50001: {
          fullname: "Energie (ISO 50001)",
          desc: "Systemische Bewertung des Energiemanagementsystems"
        },
        'ISO-9001-2015': {
          fullname: "Qualitätsmanagementsysteme (ISO 9001)",
          desc: "Systemische Bewertung des Qualitätsmanagementsystems"
        },
        'ISO-14001-2026': {
          fullname: "Umweltmanagement (ISO 14001)",
          desc: "Systemische Bewertung des Umweltmanagementsystems"
        },
        'ISO-13485-2016': {
          fullname: "Medizinproduktemanagement (ISO 13485)",
          desc: "Systemische Bewertung des Qualitätsmanagementsystems für Medizinprodukte"
        },
        'ISO-45001-2018': {
          fullname: "Arbeitssicherheit und Gesundheitsschutz (ISO 45001)",
          desc: "Systemische Bewertung des Arbeitsschutzmanagementsystems"
        },
        'ISO-50001-2018': {
          fullname: "Energie (ISO 50001)",
          desc: "Systemische Bewertung des Energiemanagementsystems"
        },
        'ISO-27001-2023': {
          fullname: "Informationssicherheit (ISO 27001)",
          desc: "Systemische Bewertung des Informationssicherheitsmanagementsystems"
        },
        'ISO-14971-2019': {
          fullname: "Risikomanagement für Medizinprodukte (ISO 14971)",
          desc: "Systemische Bewertung des Risikomanagementprozesses für Medizinprodukte"
        },
        'ISO-22163-2023': {
          fullname: "Bahnspezifisches Qualitätsmanagementsystem (ISO 22163)",
          desc: "Systemische Bewertung des Qualitätsmanagementsystems im Bahnsektor"
        },
        'ISO-31000-2018': {
          fullname: "Risikomanagement (ISO 31000)",
          desc: "Systemische Bewertung des Risikomanagementrahmens und -prozesses"
        },
        customTemplate: {
          fullname: "Benutzerdefinierter Vorlagenersteller",
          desc: "Erstellen Sie Ihre eigenen Audit-Vorlagen mit flexibler Checklistenkonfiguration und benutzerdefinierter Bewertung."
        }
      }
    },
    licences: {
      title: "Auditor-Lizenzen konfigurieren",
      subtitle: "Legen Sie die Anzahl ihrer Auditor-Lizenzen fest",
      perSeatYear: "Lizenzen/Jahr",
      perYear: "Jahr",
      perMonth: "Monat",
      totalSeats: "Gesamtzahl der Benutzer",
      users: "Benutzer",
      seatsCost: "Auditor-Lizenzen",
      contactMore: "Kontaktieren Sie uns für mehr",
      auditor: {
        title: "Auditor-Lizenzen",
        desc: "Lizenzierte Benutzer, die Audits durchführen, Feststellungen und Berichte erstellen",
        seats: "Lizenzen"
      },
      admin: {
        title: "Zusätzliche Auditor-Lizenzen",
        desc: "Lizenzierte Benutzer, die Audits durchführen, Feststellungen und Berichte erstellen",
        includedCount: "{count} Lizenzen im Plan enthalten",
        extraSeats: "zusätzliche Lizenzen",
        extraLabel: "Zusätzliche Auditor-Lizenzen"
      },
      supplier: {
        title: "Lieferantenportal",
        desc: "Unbegrenzter Lieferantenzugang ohne zusätzliche Kosten in allen Paketen enthalten",
        unlimited: "Unbegrenzter Zugang",
        note: "Lieferantenaktivitäten",
        features: [
          "Audits ansehen",
          "Laden Sie Akten und Beweise hoch",
          "Verwalten Sie das Maßnahmenmanagement",
          "Erhalten Sie Benachrichtigungen"
        ]
      },
      client: {
        title: "Kundenportal",
        desc: "Unbegrenzter Kundenzugang ohne zusätzliche Kosten in allen Paketen enthalten",
        unlimited: "Unbegrenzter Zugang",
        note: "Kunden können Auditberichte einsehen, Fortschritte verfolgen und Compliance-Dokumente verwalten",
        features: [
          "Kundenaktivitäten",
          "Verfolgen Sie den Audit-Fortschritt",
          "Audits ansehen",
          "Gemeinsame Dokumente verwalten"
        ]
      },
      planChangePrompt: "Bitte ändern Sie den Plan, um dies zu ändern"
    },
    order: {
      title: "Überprüfen Sie Ihre Bestellung",
      subtitle: "Überprüfen Sie Ihre Auswahl, bevor Sie den Kauf abschließen",
      planDetails: "Audit-Paket",
      selectedPlan: "Ausgewähltes Paket",
      billingCycle: "Abrechnungszyklus",
      planPrice: "Preis",
      package: "Paket",
      languagesDetails: "Sprachen",
      standardsDetails: "Audit-Standardvorlagen",
      seatsDetails: "Lizenzkonfiguration",
      seatsPrice: "Auditor-Lizenzen",
      standardsPrice: "Audit-Vorlage",
      promoPlaceholder: "Geben Sie den Aktionscode ein",
      applyPromo: "Anwenden",
      promoApplied: "{discount}% Rabatt angewendet!",
      promoSuccess: "Aktionscode erfolgreich angewendet!",
      promoInvalid: "Ungültiger Aktionscode",
      promoDiscount: "Aktionsrabatt",
      orderSummary: "Bestellübersicht",
      totalMonthly: "Gesamt",
      vatNote: "* Preise exklusive Mehrwertsteuer",
      agreePrefix: "Ich akzeptiere die",
      termsOfService: "Nutzungsbedingungen",
      agreeAnd: "und die",
      privacyPolicy: "Datenschutzrichtlinie",
      agreementRequired: "Bitte lesen und akzeptieren Sie die Nutzungsbedingungen und die Datenschutzrichtlinie, um Ihren Kauf abzuschließen",
      encrypted: "Verschlüsselt",
      sslEncrypted: "SSL-verschlüsselt",
      licenceCount: "Keine Lizenzen | {count} Lizenz | {count} Lizenzen",
      guarantee: "30-tägige Geld-zurück-Garantie",
      storage: {
        title: "Speicher",
        desc: "Speicher und Volumen.",
        included: "Enthalten",
        free: "Kostenlos",
        excluded: "Ausgeschlossen",
        payAsYouGo: "Bezahlung nach Bedarf"
      },
      termsContent: [
        "幸运丹鸟（珠海）科技有限公司Vereinbarungen, Allgemeine Geschäftsbedingungen",
        "VEREINBARUNGEN, GESCHÄFTSBEDINGUNGEN DES UNTERNEHMENS LPT „PRIVATE LIMITED LIABILITY COMPANY“Wir begrüßen Sie auf unserer Website, unseren Einrichtungen, Plattformen, Softwares, Anwendungen und anderen. LPT (im Folgenden „LPT“ „幸运丹鸟（珠海）科技有限公司“ genannt) und seine Tochtergesellschaften (zusammen „Wir“, „Unser“ oder „Uns“). Diese Vereinbarungen und Allgemeinen Geschäftsbedingungen gelten für diese Website, für jede Software oder Anwendung von uns, für jede Website von uns oder für Websites, Software und Anwendungen Dritter (online oder offline), jedoch nicht für andere Produkte oder Dienstleistungen von uns, sofern nicht ausdrücklich etwas anderes von uns angegeben wird (z. B. durch Einfügen eines Links zu diesen Vereinbarungen, Allgemeinen Geschäftsbedingungen auf anderen Websites, in der Software von uns oder in mobilen Anwendungen von uns). VEREINBARUNGEN, GESCHÄFTSBEDINGUNGEN AS GEÄNDERT AM 01.04.2026Wichtig – bitte lesen Sie diese Vereinbarungen und Geschäftsbedingungen sorgfältig durch, bevor Sie diese Vereinbarungen akzeptieren. Speichern Sie dann diese Vereinbarungen und Geschäftsbedingungen und bewahren Sie sie zusammen mit allen Bestätigungs-E-Mails, SMS-Nachrichten, Nachrichten, zusätzlichen Bedingungen, Datenschutzrichtlinien, anderen Richtlinien usw. auf. usw., die für Ihre Nutzung der Plattformen und/oder Einrichtungen und/oder Software und/oder Anwendungen relevant sind. Wir werden unseren Vertrag nicht bei Ihnen einreichen. Bewahren Sie ihn daher bitte für Ihre Unterlagen auf. Diese Vereinbarungen und Allgemeinen Geschäftsbedingungen können geändert werden (wie unten dargelegt). Sie akzeptieren, dass Sie an diesen Vertrag gebunden sind, indem Sie auf „Anmelden“ oder „Anmelden“ oder „Senden“ oder „Zustimmen“ oder auf etwas anderes klicken und/oder indem Sie die Einrichtungen nutzen (wie dieser Begriff im Folgenden definiert wird). Nachdem Sie (wie dieser Begriff im Folgenden definiert wird) auf „Senden“ oder „Ich stimme zu“ klicken oder wenn Sie die Einrichtungen nutzen, kommt eine rechtsverbindliche Vereinbarung zu diesen Vereinbarungen und Geschäftsbedingungen zwischen (a) Ihnen, dem Endbenutzer („Sie“), und (b) 幸运丹鸟（珠海）科技有限公司, registriert im Handelsregister unter Nr. 91440400MACD90ME4A, mit eingetragener Adresse im Gebäude 02, 21. Etage, Nr. 2103, Meixi Commercial Plaza, 168 Lvyou Road, Bezirk Xiangzhou, Stadt Zhuhai. LPT wird je nach Bedarf als „Wir“, „Uns“ oder „Unser“ definiert. Wir unterliegen den Gesetzen Chinas. Wir stellen Einrichtungen auf den von uns bereitgestellten Websites, Softwares und/oder Anwendungen sowie auf anderen von uns bereitgestellten Online- oder mobilen Plattformen bereit (jede einzelne Website ist eine „Plattform“), über die Sie über Ihr Konto auf unsere Einrichtungen zugreifen, wie unten definiert (Einrichtungen). Für den Fall, dass Sie Beschwerden, Ansprüche oder Streitigkeiten im Hinblick auf ein Ergebnis in Bezug auf die Einrichtungen oder eine andere von uns durchgeführte Aktivität haben, sollten Sie sich zunächst gemäß und in unseren Vereinbarungen an uns wenden. Allgemeine Geschäftsbedingungen.",
        "Diese Vereinbarungen, Allgemeinen Geschäftsbedingungen stellen zusammen mit der Datenschutzrichtlinie, allen zusätzlichen Regeln oder Richtlinien und allen anderen zusätzlichen Regeln, Richtlinien, Bedingungen und anderen, die auf den Plattformen und/oder Softwares und/oder Anwendungen veröffentlicht und Ihnen auf den Plattformen, Websites, Softwares oder Anwendungen mitgeteilt werden und die sich speziell auf bestimmte Ereignisse, Software, Werbeaktionen oder andere beziehen und diese regeln, eine rechtsverbindliche Vereinbarung zwischen Ihnen und uns dar („Vereinbarungen“). Sobald Ihnen eine Änderung der Regeln oder Bedingungen der Vereinbarungen mitgeteilt wird, haben Sie die Möglichkeit, gemäß unseren Vereinbarungen und Geschäftsbedingungen zu kündigen. Sie sollten alle diese Dokumente sorgfältig lesen, da jedes einzelne Teil der rechtsverbindlichen Vereinbarung zwischen Ihnen und uns ist. Wenn diese Vereinbarungen in eine andere Sprache übersetzt werden, hat die chinesische Sprachversion im Falle eines Konflikts zwischen der Übersetzung und der anderen Sprachversion Vorrang. Bitte beachten Sie, dass diese Vereinbarungen und Geschäftsbedingungen Vorrang haben, wenn ein Konflikt zwischen diesen Vereinbarungen, Geschäftsbedingungen und anderen Dokumenten, auf die in diesen Vereinbarungen und Geschäftsbedingungen Bezug genommen wird, vorliegt. Klicken Sie auf „Anmelden“, „Anmelden“ oder „Senden“ oder Wenn Sie mit „Zustimmen“ oder einer anderen Vereinbarung diese Vereinbarungen und Allgemeinen Geschäftsbedingungen akzeptieren, erkennen Sie auch diese Vereinbarungen an und akzeptieren sie. Der Zugang zu und die Nutzung unserer Einrichtungen unterliegen diesen Vereinbarungen. Wenn Sie Fragen zu diesen Vereinbarungen haben, empfehlen wir Ihnen, unabhängige Rechtsberatung einzuholen. Die Einrichtungen und interaktiven Funktionen können je nach Plattform oder Software oder Anwendungen oder anderen, die Sie für den Zugriff verwenden, variieren. Wir verweisen auf unsere Datenschutzrichtlinie, in der beschrieben wird, wie wir mit Ihren personenbezogenen Daten umgehen und diese schützen. Indem Sie diese Vereinbarungen und Allgemeinen Geschäftsbedingungen akzeptieren, erkennen Sie auch die Datenschutzrichtlinie und alle anderen an und akzeptieren diese Website-Einrichtungen müssen Sie dies in Übereinstimmung mit und in unseren Vereinbarungen und Geschäftsbedingungen tun.",
        "VERTRAGSGRUNDLAGE Entgegenstehende oder von unseren Allgemeinen Geschäftsbedingungen abweichende Bedingungen des Kunden erkennen wir nicht an, es sei denn, wir hätten ausdrücklich schriftlich ihrer Geltung zugestimmt. Die stillschweigende Erbringung von Lieferungen oder Leistungen o.ä. unsererseits bedeutet kein Einverständnis mit entgegenstehenden Bedingungen des Kunden. Das Rechtsgeschäft (Lieferung, Abrechnung etc.) führt LPT im eigenen Namen für Rechnung Dritter durch. BESTELLUNG UND VERTRAGSABSCHLUSS Die Darstellung der Produkte, Software, Anwendungen oder dergleichen im Online-Shop stellt kein rechtlich bindendes Angebot unsererseits dar, sondern einen unverbindlichen Online-Katalog (nachfolgend Bestellangebot genannt). Der Kunde kann die Produkte, Software, Anwendungen oder Ähnliches aus dem Online-Shop zunächst unverbindlich in den Warenkorb legen und die Eingaben vor Absenden der Bestellung jederzeit korrigieren. Durch Anklicken des Buttons „Kaufen“ gibt der Kunde eine verbindliche (zahlungspflichtige) Bestellung (Angebot) der im Warenkorb enthaltenen Waren, Software, Anwendungen o.ä. ab. Die Bestätigung des Zugangs der Bestellung erfolgt nach dem Absenden der Bestellung und stellt noch keine Vertragsannahme dar. Wir können die Bestellung des Kunden durch Zusendung einer Auftragsbestätigung oder sonst innerhalb von 10 Werktagen annehmen. Wir akzeptieren die Nutzung unserer Waren, Software, Anwendungen oder Ähnlichem nur für geschäftliche und nicht private Zwecke. Dem Vertragsabschluss durch den Verbraucher wird hiermit widersprochen. Verbraucherschutzbestimmungen finden keine Anwendung. Der Vertrag wird nicht gespeichert. LIEFERUNG Bei Verfügbarkeit werden die bestellten Produkte, Software, Anwendungen, Bücher oder Ähnliches unverzüglich (innerhalb der Bestellfrist von ca. 10 Werktagen) geliefert, zum Download angeboten oder der entsprechende Online-Zugang zur Verfügung gestellt. Wir behalten uns das Recht vor, von der Ausführung einer Bestellung abzusehen, wenn das Produkt, die Software, Anwendungen oder Ähnliches nicht mehr auf Lager, ausverkauft oder verfügbar ist oder auf andere Weise verhindert wird. In diesem Fall wird der Kunde über die Nichtverfügbarkeit informiert.UPDATESollten von LPT entsprechende Dienste, Produkte, Software, Anwendungen oder Ähnliches zur Verfügung gestellt werden, die das Update beinhalten, kann diese wahlweise kostenpflichtig oder kostenfrei zur Verfügung gestellt werden. Sie erheben keinen Anspruch auf Richtigkeit oder Vollständigkeit und stellen keine verbindliche, rechtliche oder vergleichbare Verpflichtung für LPT dar.",
        "DRITTANBIETER Der Kunde hat teilweise die Möglichkeit, auf Inhalte von Drittanbietern zuzugreifen. Zu diesem Zweck kann es zu einer Weiterleitung auf Server, Clouds o.ä. dieser Drittanbieter kommen. Sollten für die Drittinhalte zusätzliche Kosten anfallen (z.B. Pay-per-Document o.ä.), wird der Kunde hierüber vom Drittanbieter informiert. Unterbleibt die Bereitstellung dieser Informationen durch den Dritten, kann der Kunde gegenüber LPT keine rechtlichen oder vergleichbaren Ansprüche geltend machen. Für den Fall, dass der Kunde unsere Dienstleistungen, Produkte, Websites, Software, Anwendungen oder ähnliches als SaaS nutzt, gilt das Kapitel „SaaS (Software as a Service)“. SICHTZEITRAUM/TESTPHASEWird ein Besichtigungszeitraum/Testphase angeboten oder angegeben, steht dem Kunden beim erstmaligen Kauf ein angebotsabhängiger Besichtigungszeitraum/Testphase zur Verfügung. Der Testanspruch beginnt mit dem Tag der Bestellung. Entscheidet sich der Kunde für eine langfristige Nutzung der Software, kann er bei ausdrücklicher Erwähnung direkt mit allen eingegebenen Daten weiterarbeiten. Mit der Bestellung erhält er die Rechnung in seinem registrierten Konto. Diese wird erst nach Ablauf des Testzeitraums fällig. Entscheidet sich der Kunde gegen den Service, die Software, Anwendungen o.ä. von LPT, erfolgt nach Ablauf des Betrachtungszeitraums/Testphase automatisch eine Deaktivierung o.ä. Die Kosten für die Nutzung der Dienste Dritter (z. B. SaaS etc.) sind in unseren Preisen nicht enthalten und werden dem Kunden gesondert in Rechnung gestellt. Der Gesamtpreis inklusive Steuern und Versandkosten wird dem Kunden vor Abgabe der Bestellung auf der Bestellübersichtsseite (Warenkorb) angezeigt. Sofern von LPT angeboten, hat der Kunde im Warenkorb die Möglichkeit, zwischen verschiedenen Zahlungsarten zu wählen. Die Zahlung ist mit Vertragsschluss fällig.ZAHLUNGSARTEN UND FÄLLIGKEITENWir bieten verschiedene Zahlungsarten an, die vom Kunden ausgewählt werden können. Die jeweiligen Fälligkeitstermine sind vorgegeben bzw. richten sich nach den jeweiligen gesetzlichen Bestimmungen. Eine Bestellung, Rechnungen und Mahnungen werden dem Kunden entsprechend zugesandt (z. B. per E-Mail, im Konto o.ä.).",
        "ZAHLUNGSVERZUG UND SPERRUNG DES ZUGANGS Im Falle eines Zahlungsverzugs ist LPT berechtigt, den Zugang zu unseren Diensten, Produkten, Websites, Software, Anwendungen oder Ähnlichem zu sperren, zu löschen oder dergleichen. Für die Sperrung oder Löschung ist beim LPT keine Frist festgelegt. In diesem Fall bleibt der Kunde zur Zahlung der vereinbarten Preise verpflichtet. In diesem Fall ist LPT berechtigt, die Zahlung des gesamten vereinbarten Jahresbetrages zu verlangen und die offenen Forderungen zur Betreibung an ein Inkassobüro o.ä. zu übergeben. Insbesondere hat der Kunde die Kosten des Inkassodienstleisters o.ä. zu tragen. Wird der Zugang aus Gründen, die der Kunde zu vertreten hat, von LPT gesperrt, gelöscht oder vergleichbar, hat der Kunde die Kosten der Sperrung, die Kosten des Zahlungsverzugs und ähnliche Kosten zu tragen. Darüber hinaus hat der Kunde in diesem Fall keinen Anspruch und Anspruch darauf, LPT etwaig entstandene oder mögliche Kosten oder vergleichbare Kosten jeglicher Art in Rechnung zu stellen. In diesem Fall behalten wir uns das Recht vor, dem Kunden den Zugang oder die Nutzung unserer Dienste, Produkte, Websites, Software, Anwendungen oder Ähnliches dauerhaft zu verweigern oder zu sperren und sein Konto (sofort) zu löschen. Sofern in der Entscheidung des LPT vorgesehen ist, dass die Sperrung, Blockade o.ä. nach Begleichung der offenen Forderungen aufgehoben wird, kann die Aufhebung einige Arbeitstage in Anspruch nehmen. PREISANPASSUNG UND ANDERE ANPASSUNGEN Wir sind berechtigt, während der Vertragslaufzeit Kosten-, Preis-, Angebots- und ähnliche Anpassungen vorzunehmen und vorzunehmen. Diese Anpassungen werden dem Kunden beispielsweise per E-Mail, über Websites, Konten, Software, Anwendungen oder ähnliches mitgeteilt. Die Kündigungsfristen bleiben hiervon unberührt. ZURÜCKZUBEHALTEN Der Kunde ist nicht berechtigt, Zahlungen zurückzuhalten, es sei denn, ihm steht aus demselben Vertragsverhältnis ein gesetzliches Zurückbehaltungsrecht zu. Eine Aufrechnung ist nur zulässig, wenn die aufzurechnende Forderung unbestritten oder rechtskräftig festgestellt ist. Kosten für unberechtigte Rücklastschriften sind vom Kunden zu tragen. LIEFERKOSTEN Sollten bei Lieferungen Kosten anfallen, werden diese dem Kunden bei der Bestellung in Rechnung gestellt und sind vom Kunden zu tragen. Diese Kosten können je nach Versandart und Lieferung variieren. VERTRAGSLAUFZEIT UND KÜNDIGUNG VERTRAGSLAUFZEIT In den Abonnements, Paketen, Services, Produkten, Software, Anwendungen o.ä. wird eine Mindestvertragslaufzeit vereinbart. Sofern keine Kündigung ausgesprochen wird, verlängert sich der Vertrag automatisch.",
        "KÜNDIGUNG: Bei Abonnements, Paketen, Dienstleistungen, Produkten, Software, Anwendungen oder Ähnlichem ist eine Kündigung des Vertrages mit Wirkung zum Ende der Laufzeit möglich, sofern der Vertrag keine ausdrücklich vereinbarte Kündigungsfrist enthält. Die Kündigung kann bis zum letzten Tag der Laufzeit erklärt werden. Nach Vertragsbeendigung noch erhaltene Lieferungen sind zurückzusenden. Nach Vertragsende besteht für LPT keine Verpflichtung zur Speicherung oder Aufbewahrung von Daten, Informationen oder Ähnlichem. Durch die Kündigung des Vertrages entbindet der Kunde LPT von jeglicher Verpflichtung zur Aufbewahrung, Archivierung oder Ähnlichem. Der Kunde ermächtigt LPT auch zur Vornahme einer Löschung jeglicher Art. KÜNDIGUNGSFORM Jede Art der Kündigung bedarf der Schriftform unter Verwendung der von LPT vorgegebenen Kündigungsart/-form. In den meisten Fällen erfolgt dies über ein Formular.KÜNDIGUNG AUS WICHTIGEM GRUNDDas Recht beider Parteien zur Kündigung aus wichtigem Grund bleibt unberührt. Wir sind insbesondere berechtigt, diesen Vertrag außerordentlich fristlos zu kündigen, wenn:der Kunde mit der Zahlung eines Betrages für eine bestimmte Zeit in Verzug ist,das Benutzerkonto übertragen oder die Zugangsdaten ohne unsere vorherige Zustimmung Dritten zugänglich gemacht wurden oderder Kunde gegen seine sonstigen Pflichten aus diesem Vertrag verstoßen hat. Inwieweit eine Fristsetzung mit Ablehnungsandrohung der Vertragsverletzung erforderlich ist, richtet sich nach dem anwendbaren Recht. Soweit dies nicht gesetzlich geregelt ist, steht LPT das Recht zur außerordentlichen Kündigung mit sofortiger Wirkung ohne Fristsetzung zu.MEIN KONTO UND ZUGANGMEIN KONTODer registrierte Kunde kann über das Kundenkonto sämtliche Aktivitäten selbst durchführen. Dies dient dem Kunden unter anderem dazu, Dienstleistungen, Software, Produkte, Anwendungen oder Ähnliches zu erwerben. REGISTRIERUNG Die Nutzung des Kundenkontos erfordert eine Registrierung. Die Registrierung einer juristischen Person darf nur durch eine bevollmächtigte natürliche Person erfolgen, die namentlich genannt werden muss. Wir können die Annahme von Anmeldungen verweigern, wenn dafür ein sachlicher Grund vorliegt, z.B. falsche Angaben gemacht werden oder die Befürchtung besteht, dass Zahlungsverpflichtungen voraussichtlich nicht eingehalten werden. Wir behalten uns außerdem das Recht vor, die Registrierung ohne Angabe von Gründen abzulehnen.",
        "URHEBERRECHTE UND WARENZEICHEN Die Begriffe LPT-Logo und alle anderen von der LPT verwendeten Marken sind Marken, Dienstleistungsmarken und/oder Handelsnamen der LPT oder einer ihrer Tochtergesellschaften oder verbundenen Unternehmen oder ihrer Lizenzgeber. Darüber hinaus sind alle anderen von LPT verwendeten Materialien, einschließlich, aber nicht beschränkt auf Software, Bilder, Bilder, Grafiken, Fotografien, Animationen, Videos, Musik, Audio, Texte (und alle geistigen Eigentumsrechte an diesen), Eigentum von LPT oder einer seiner Tochtergesellschaften oder verbundenen LPT-Unternehmen und/oder Lizenzgebern und durch Urheberrechte und/oder andere geistige Eigentumsrechte geschützt. Sie erwerben keinerlei Rechte an solchen urheberrechtlich geschützten Materialien oder Handels- oder Dienstleistungsmarken und dürfen diese nicht ohne die schriftliche Genehmigung des LPT verwenden. URHEBERRECHTE / NUTZUNGSRECHTEUMFANG DER NUTZUNGSRECHTEKunden werden für einen begrenzten Zeitraum und für die Dauer der vereinbarten Laufzeit des Nutzungsvertrags lediglich nicht übertragbare und nicht ausschließliche Nutzungsrechte an unserem Service, unseren Websites, unserer Software, unseren Produkten, Anwendungen oder Ähnlichem eingeräumt. Das Nutzungsrecht ist auf die nachfolgend beschriebene Nutzung beschränkt. SERVICE, WEBSITES, SOFTWARES, PRODUKTE, ANWENDUNGEN, ANWENDUNGEN ODER ÄHNLICHER UMFANG DER NUTZUNGSRECHTE (NUTZUNGSRECHTE) Der Kunde hat das Recht, unsere Dienste, Websites, Software, Produkte, Anwendungen oder Ähnliches in dem im Vertrag vereinbarten Umfang (Anzahl der erworbenen Lizenzen, Dauer des Nutzungsrechts) zu nutzen. Unsere Dienste, Websites, Software, Produkte, Anwendungen oder Ähnliches dürfen pro Lizenz nur einmal installiert und von einer Person genutzt werden. Im Falle eines Vertrages über eine Netzwerkversion/Mehrfachlizenzen ist der Kunde berechtigt, unsere Dienste, Websites, Software, Produkte, Anwendungen oder Ähnliches durch eine der Anzahl der erworbenen Lizenzen entsprechende Anzahl von Personen zu nutzen. Die Dauer des Nutzungsrechts richtet sich nach dem jeweiligen Angebot.",
        "SaaS (Software-as-a-Service) Wir nutzen SaaS auch in einigen unserer Dienste, Websites, Software, Produkte, Anwendungen oder Ähnlichem. Daher ist der Kunde dafür verantwortlich, einen kompatiblen Zugang und die erforderliche Hardware- und Softwareumgebung sicherzustellen. Die Speicherung der Daten und Informationen kann bei Drittanbietern erfolgen. Durch die Nutzung unserer Dienste, Websites, Software, Produkte, Anwendungen oder Ähnlichem akzeptiert der Kunde die Geschäftsbedingungen dieser Drittanbieter. Der Kunde ist dafür verantwortlich, diese Allgemeinen Geschäftsbedingungen einzusehen, bevor er unsere Dienste, Websites, Software, Produkte, Anwendungen oder Ähnliches nutzt. Die Kosten für die Nutzung der Dienste Dritter sind im Kapitel „Preise und Zahlungsbedingungen“ festgelegt. Im Falle von Störungen oder Ähnlichem ist der Kunde verpflichtet, diese Informationen direkt an unseren Kundendienst weiterzugeben. Nähere Einzelheiten finden Sie in den Kapiteln „Übergabepunkt und Verfügbarkeit“ und „Servicelevel und Support“. Der Kunde darf die vertragsgegenständlichen Leistungen nur vertragsgemäß nutzen. Es dürfen nur Daten übermittelt werden, die frei von Computerviren oder anderen schädlichen Codes sind. Weder die Software noch andere Techniken oder Methoden im Zusammenhang mit der Nutzung der SaaS-Lösung dürfen in einer Weise verwendet werden, die deren Betrieb, Sicherheit oder Verfügbarkeit beeinträchtigen könnte. Der Zugriff auf Lexware Office erfolgt über Standard-Webbrowser. Wenn Sie zusätzliche Technologien wie Add-Ons, Plug-Ins, VPNs oder ähnliches nutzen, kann es dazu kommen, dass Lexware Office nicht oder nur teilweise verfügbar ist. In solchen Fällen übernehmen wir keine Haftung für die Verfügbarkeit. Die Nutzung von Schnittstellen, die nicht über die Public API oder Partner API angeboten werden und nicht dokumentiert sind, ist untersagt. Der Kunde wird die vertragsgegenständlichen Leistungen nur im vertraglich vereinbarten Umfang und unter Einhaltung der geltenden Richtlinien (AGB) nutzen. Die Haftung von LPT liegt bei der Nutzung der SaaS-Lösungen durch den Kunden. Die Haftung der LPT pro Kalenderjahr ist auf den zum Zeitpunkt des Vertragsschlusses vorhersehbaren Schaden begrenzt, insgesamt jedoch für alle Ansprüche pro Kalenderjahr auf 60 % der vom Kunden in diesem Kalenderjahr gezahlten Vergütung. Diese Haftungsbeschränkung gilt auch bei Datenverlust oder Datenbeschädigung.",
        "Vertragliche Nutzung von KI-Funktionen (Künstliche Intelligenz) oder KI-Funktionen, die von LP implementiert werden, ist der Kunde berechtigt, diese KI zu nutzen, ohne gegen geltende gesetzliche oder behördliche Anforderungen zu verstoßen. Darüber hinaus ist die Nutzung der KI-Funktion nur im Rahmen und unter Einhaltung unserer Geschäftsbedingungen gestattet. Der Einsatz von KI, der ein Risiko darstellt, ist strengstens untersagt. Es wird nicht nach der Art des Risikos unterschieden. Inhaltsfilter oder Sicherheitssysteme, die Teil der KI-Funktionen sind, dürfen vom Kunden nicht deaktiviert, umgangen, gestört oder beeinträchtigt werden. Hierzu zählen auch direkte oder indirekte Prompt-Injection- oder Adversarial-Inputs. Darüber hinaus ist dem Kunden bekannt, dass die Ergebnisse keine Rechtsberatung im Einzelfall darstellen und nicht die Beratung durch Personen des jeweiligen Berufsstandes (z. B. Wirtschaftsprüfungsexperten, Steuerberater, Rechtsanwälte etc.) ersetzen. Die Ergebnisse und Konsequenzen des Einsatzes von KI liegen ausschließlich in der Verantwortung des Kunden. LPT ist in keiner Weise haftbar oder verantwortlich für die Nutzung, Folgen oder Ergebnisse, die sich aus der Anwendung von KI ergeben. Hierzu zählen auch die Anforderungen und Regelungen der geltenden Datenschutzgesetze, Eigentumsrechte und Ähnliches. Der Kunde stellt uns von sämtlichen Ansprüchen Dritter (einschließlich derjenigen seiner Nutzer) auf erstes Anfordern frei, die sich aus seiner Nutzung der KI-Funktionen oder deren Nutzung durch seine berechtigten Nutzer ergeben. Darin sind Gerichts- und Anwaltskosten enthalten. Ein Anspruch des Kunden auf gesetzliche oder sonstige Schadensersatzansprüche gegenüber LPT besteht nicht. NUTZUNGSZWECK Der Kunde ist berechtigt, unsere Dienste, Websites, Software, Produkte, Anwendungen oder Ähnliches ausschließlich für eigene Zwecke zu nutzen. Die kostenlose oder kostenpflichtige Nutzung unserer Dienste, Websites, Software, Produkte, Anwendungen oder Ähnliches im Namen Dritter und deren Weitergabe an Dritte ist nicht gestattet.",
        "ANZAHL DER INSTALLATIONEN Die Berechtigung beschränkt sich darauf, dass die ausgewählten Dienste, Websites, Software, Produkte, Anwendungen oder Ähnliches in dem von uns beschriebenen Umfang genutzt werden können. Der Kunde ist nicht berechtigt, unsere Dienste, Websites, Software, Produkte, Anwendungen oder Ähnliches auf seinen Geräten oder ähnlichem in größerem Umfang zu installieren, zu vervielfältigen oder zu vergleichen. Jede Vervielfältigung oder jeder Missbrauch zu vergleichbaren Zwecken hat strafrechtliche und rechtliche Folgen. Darüber hinaus ist es dem Kunden nicht gestattet, den Dienst, Websites, Software, Produkte, Anwendungen oder vergleichbare Gegenstände oder Bestandteile davon, die gelieferten Bilder, das Handbuch, Begleittexte oder ähnliche Gegenstände oder die dazugehörige Dokumentation durch Fotokopie oder Mikroverfilmung, elektronische Sicherung oder eine andere von dem Dienst verwendete Methode zu vervielfältigen, Websites, Software, Produkte, Anwendungen oder ähnliche Produkte und/oder die dazugehörige Dokumentation nicht zu verbreiten, zu vermieten, an Dritte zu unterlizenzieren oder auf andere Weise Dritten zugänglich zu machen. Der Kunde ist nicht berechtigt, Zugangscodes und/oder Passwörter sowie sonstige Informationen, Daten oder vergleichbare Gegenstände für den Dienst, Websites, Software, Produkte, Anwendungen oder Ähnliches oder für Datenbankzugriffe zu verwenden, die im Zusammenhang mit dem Dienst, Websites, Software, Produkten, Anwendungen oder Vergleichbaren Gegenständen in diesem Zusammenhang an Dritte weitergegeben werden. Der Kunde ist nicht berechtigt, den Dienst, Websites, Software, Produkte, Anwendungen oder Ähnliches und/oder die dazugehörige Dokumentation ganz oder teilweise zu verändern, zu modifizieren, anzupassen, zu dekompilieren oder Ähnliches. URHEBERRECHT UND ÄHNLICHES",
        "URHEBERRECHT: Die Informationsbanken, Datenbanken, Clouds und Vergleichsobjekte (online und offline) für unsere Dienste, Websites, Software, Produkte, Anwendungen oder Ähnliches sind urheberrechtlich geschützt. Darüber hinaus sind die Inhalte, insbesondere Checklisten, Dokumente, dokumentierte Informationen und Ähnliches, urheberrechtlich geschützt. Unsere Dienste, Websites, Software, Produkte, Anwendungen oder Ähnliches sind urheberrechtlich geschützt und unterliegen dem jeweiligen Urheberrecht. Der Kunde ist berechtigt, sie für geschäftliche Zwecke zu den definierten Zwecken zu nutzen. Sofern die tatsächliche Nutzung unsere berechtigten Interessen unzumutbar beeinträchtigt oder wir dies vermuten, sind wir berechtigt, den Zugriff einzuschränken oder zu sperren. Dies gilt insbesondere für die Vervielfältigung, Verbreitung oder öffentliche Wiedergabe wesentlicher Bestandteile oder die wiederholte und systematische Vervielfältigung, Verbreitung oder öffentliche Wiedergabe und Zugänglichmachung unserer Dienste, Websites, Software, Produkte, Anwendungen oder vergleichbarer Bestandteile sowie unwesentlicher Bestandteile davon. Alle Urheberrechte, Nutzungsrechte und sonstigen geistigen Eigentumsrechte an den Informationsbanken, Datenbanken, Clouds und Ähnlichem (online und offline) für unsere Dienste, Websites, Software, Produkte, Anwendungen oder Ähnliches, die nachfolgend nicht ausdrücklich aufgeführt sind, verbleiben bei uns als Inhaber aller Nutzungs- und Eigentumsrechte. UMFANG DES NUTZUNGSRECHTS (NUTZUNGSRECHTE) Der Kunde erwirbt das Recht, auf die Informationsbanken, Datenbanken, Clouds und Ähnliches (online und offline) für unsere Dienste, Websites, Software, Produkte, Anwendungen oder Ähnliches zuzugreifen, die für diese Zwecke verwendet werden und unter Einhaltung der vereinbarten Vorschriften, Richtlinien und Vereinbarungen geeignet ist. Die Dauer des Nutzungsrechts bestimmt sich nach der dem Vertragsverhältnis zugrunde liegenden Vereinbarung.",
        "NUTZUNGSBESCHRÄNKUNGEN Der Kunde verpflichtet sich, die Informationsbanken, Datenbanken, Clouds und Vergleichbares (online und offline) für unsere Dienste, Websites, Software, Produkte, Anwendungen oder Vergleichbares nur für eigene Zwecke zu nutzen und Dritten keinen gesonderten Zugang dazu zu gewähren, weder unentgeltlich noch gegen Entgelt, um die Informationsbanken, Datenbanken, Clouds und Ähnliches (online und offline) für unsere Dienste, Websites, Software, Produkte, Anwendungen oder Ähnliches zu ermöglichen. Die Informationsbanken, Datenbanken, Clouds und Vergleichsdateien (online und offline) für unsere Dienste, Websites, Software, Produkte, Anwendungen oder Vergleichsdateien dürfen nur von einer Person oder der von LPT pro Lizenz festgelegten Anzahl von Personen genutzt werden. Der Kunde verpflichtet sich, Informationen, Daten oder vergleichbare Informationen, Daten oder vergleichbare Informationen, Websites, Software, Produkte, Anwendungen oder vergleichbare Informationen ohne unsere schriftliche Zustimmung nicht ganz, teilweise oder in vergleichbarer Form zu vervielfältigen, zu verändern, anzupassen oder Dritten zugänglich zu machen, damit diese darauf zugreifen können, ohne lizenzierte Nutzer zu sein (indirekte Nutzung). Darüber hinaus ist eine Weitergabe von Informationen, Daten oder vergleichbaren Gegenständen an Dritte, die nicht im Rahmen der genutzten Dienste, Websites, Software, Produkte, Anwendungen oder Ähnlichem liegen, ohne unsere schriftliche Zustimmung nicht gestattet. NUTZUNGSBESCHRÄNKUNGENDie Nutzung ist nur auf den von uns unterstützten Diensten, Websites, Software, Produkten, Anwendungen oder Ähnlichem gestattet. Dem Kunden ist es untersagt, Urheberrechtsvermerke, Markenzeichen, Warenzeichen und/oder Eigentumsinformationen an den Diensten, Websites, Software, Produkten, Anwendungen oder ähnlichen Gegenständen zu ändern. GEWÄHRLEISTUNG RECHT AUF AKTUALISIERUNG: Unsere Dienste, Websites, Software, Produkte, Anwendungen oder Ähnliches werden regelmäßig mit der erwarteten Sorgfalt erstellt, überarbeitet und aktualisiert. Trotz aller Vorsicht und Sorgfalt sollte bei der Nutzung der Dienste, Websites, Software, Produkte, Anwendungen oder vergleichbarer Gegenstände stets darauf geachtet werden, dass eine Gesetzesänderung oder sonstige Änderungen eine Änderung o.ä. erforderlich machen können. Reklamationen sind unverzüglich schriftlich an LPT (Kundendienst) zu richten. Ein Anspruch des Kunden auf Schadensersatz seitens LPT besteht insoweit nicht. RECHTSMITTELRECHT Der Kunde kann innerhalb der gesetzlichen Gewährleistungsfrist eine Reparatur verlangen. Sind wir zur Nachbesserung oder Ähnlichem nicht bereit oder nicht in der Lage oder schlägt diese aus sonstigen Gründen fehl, ist der Kunde nach seiner Wahl berechtigt, den Rücktritt vom Vertrag zu verlangen.",
        "HAFTUNG UND HAFTUNG ÄHNLICHER HAFTUNG Bei fahrlässiger Verletzung einer Pflicht, deren Erfüllung die ordnungsgemäße Durchführung des Vertrages überhaupt erst ermöglicht und deren Verletzung die Erreichung des Vertragszwecks gefährdet, ist unsere Haftung auf die Höhe des nach der Art des jeweiligen Geschäfts vorhersehbaren und typischen Schadens begrenzt. Entgangener Gewinn oder Ähnliches. Die Haftung für entgangenen Gewinn und vergebliche Aufwendungen oder Ähnliches ist ausgeschlossen. Eine weitergehende Haftung von HAFTUNGSAUSSCHLUSS besteht nicht oder etwas Vergleichbares. DATA BACKUP DUTYLPT sichert die notwendigen Informationen, Daten oder Ähnliches im Umfang der genutzten Dienste, Websites, Software, Produkte, Anwendungen oder Ähnliches, die zu deren Nutzung erforderlich sind. LPT ist nicht verpflichtet, die Informationen, Daten oder Ähnliches vollständig zu sichern. PERSÖNLICHE HAFTUNG Die vorstehende Haftungsbeschränkung gilt auch für die persönliche Haftung von Mitarbeitern, Vertretern und Organen, Partnern oder ähnlichen Personen von LPT Während des Vertragsverhältnisses erlangte Informationen über Angelegenheiten technischer, kaufmännischer, organisatorischer oder vergleichbarer Art sind vertraulich zu behandeln und sind für die Dauer und nach Beendigung des Vertrages nicht verpflichtet, diese ohne vorherige schriftliche Zustimmung von LPT zu verwerten oder Dritten zugänglich zu machen oder dergleichen. Der Kunde stellt sicher, dass Mitarbeiter, Tochtergesellschaften, Partner o.ä. auf entsprechende Geheimhaltungspflichten verpflichtet sind. Die Nutzung dieser Informationen ist ausschließlich auf die Durchführung dieses Vertrages beschränkt. Der Kunde wird LPT unverzüglich schriftlich informieren, wenn ihm eine unbefugte Weitergabe oder ein möglicher Verlust vertraulicher Informationen oder Ähnliches bekannt wird.",
        "GESETZLICHE OFFENLEGUNGSPFLICHT Das Offenlegungsverbot gilt nicht, soweit der Kunde gesetzlich oder aufgrund gerichtlicher oder behördlicher Anordnungen zur Offenlegung der Informationen verpflichtet ist. In diesem Fall ist der zur Offenlegung verpflichtete Kunde jedoch verpflichtet, LPT die Offenlegung der Informationen vorab mitzuteilen, damit LPT die Möglichkeit hat, sich gegen eine solche Offenlegung zu wehren und diese zu verhindern oder einzuschränken. Der zur Offenlegung verpflichtete Kunde wird sich nach besten Kräften darum bemühen, dass alle vertraulichen Informationen, die offengelegt werden sollen, von den die Offenlegung anordnenden Behörden vertraulich behandelt werden. FORTSETZUNG DER VERTRAULICHKEIT Die Geheimhaltungsverpflichtungen des Kunden aus diesem Vertrag bestehen auch nach Beendigung dieses Vertrages auf unbestimmte Zeit fort. Sofern sich hierzu bestimmte gesetzliche Regelungen ergeben, gelten diese nicht. VERTRAGSÜBERNAHME Wir sind berechtigt, Rechte und Pflichten aus diesem Vertragsverhältnis nach Mitteilung ganz oder teilweise auf einen Dritten zu übertragen. Diese Bekanntmachung erfolgt über einen der Kommunikationskanäle der LPT (z. B. aber nicht beschränkt auf E-Mail, Konto, Website, Software, Anwendungen etc.). ÜBERGABEPUNKT UND VERFÜGBARKEIT Für die Anbindung an das Internet oder andere Anschlussmöglichkeiten, die Bereitstellung oder Aufrechterhaltung der Netzwerkverbindung zur Nutzung unserer Dienste, Webseiten, Software, Produkte, Anwendungen oder Ähnliches sowie die Beschaffung und Bereitstellung von Netzwerkzugangskomponenten für das Internet oder andere Anschlussmöglichkeiten auf Kundenseite hat der Kunde selbst zu sorgen. Der Kunde trägt die alleinige Verantwortung für einen solchen Ausfall, eine Störung, Nichtnutzung oder Ähnliches unseres Dienstes, unserer Websites, Software, Produkte, Anwendungen oder Ähnlichem. SERVICELEISTUNGSGRAD UND SUPPORTIn manchen Fällen ist die Nutzung unseres Dienstes, unserer Websites, Software, Produkte, Anwendungen oder Ähnlichem außerhalb der Betriebszeiten (Anwendungen ca. 365 Tage, 24 Stunden) möglich, es besteht jedoch kein Anspruch darauf. Sollten aus dringenden technischen oder vergleichbaren Gründen während der Betriebszeiten ausnahmsweise Wartungsarbeiten erforderlich sein, mit der Folge, dass unsere Dienste, Websites, Software, Produkte, Anwendungen oder vergleichbare Artikel in dieser Zeit nicht verfügbar sind, werden wir dies unseren Kunden nach Möglichkeit rechtzeitig mitteilen. Diese Ankündigung erfolgt über einen der Kommunikationskanäle des LPT (z. B., aber nicht beschränkt auf E-Mail, Konto, Website, Software, Anwendungen usw.). Der LPT und/oder ein Partner stehen zur Unterstützung des Kunden zur Verfügung und sind über die Kommunikationskanäle des LPT (z. B., aber nicht beschränkt auf E-Mail, Konto, Website, Software, Anwendungen usw.) erreichbar. LPT hat das Recht, darauf zuzugreifen",
        "Daten und Informationen, die für den Support erforderlich sind. In den meisten Fällen werden die Reparaturen kostenlos vom LPT und/oder einem Partner durchgeführt. Entstehen dem Kunden Kosten für die Fehlerbehebung, wird LPT den Kunden vor der Behebung schriftlich über etwaige anfallende Kosten informieren. Im Hinblick auf die Fehlerbehebung werden Fehler, Ausfälle, Störungen und dergleichen durch LPT und/oder einen Partner von LPT analysiert und behoben. Für die erfolgreiche Behebung dieser Probleme wird keine Garantie oder Haltbarkeitsgarantie übernommen. Reproduzierbare Fehler können vom Kunden über den Kundendienst an LPT gemeldet werden. Für den Verlust oder ähnlichen Verlust von Informationen oder Daten übernimmt LPT keine Gewähr und kann in diesem Zusammenhang auch nicht strafrechtlich verfolgt werden. Die Reaktionszeit in Bezug auf die Behebung von Fehlern, Ausfällen, Störungen oder Ähnlichem ist zeitnah und situativ. Eine detaillierte Abschätzung der Reaktionszeit wird daher nicht gegeben. Ein Anspruch des Kunden auf die Behebung von Fehlern, Ausfällen, Störungen oder Ähnlichem besteht nicht. Diese werden vom LPT und/oder einem Partner analysiert, bewertet und anschließend entsprechend behandelt. Der LPT und/oder ein Partner sind nicht verpflichtet, Einzelheiten zur Behebung von Fehlern, Ausfällen, Störungen oder Ähnlichem offenzulegen. Dies dient unter anderem der Sicherheit, die zu einer möglichen Gefährdung durch Offenlegung führen könnte. MITWIRKUNGSPFLICHT Die zur Erbringung der vertraglichen Leistungen erforderlichen Mitwirkungsleistungen sind vom Kunden vollständig und rechtzeitig zu erbringen. Zu den Mitwirkungspflichten zählen insbesondere folgende Tätigkeiten des Kunden: •Alle geltenden Gesetze und sonstigen Rechtsvorschriften sind zu beachten. Es ist untersagt, Daten oder Inhalte auf unsere Server zu übertragen, die gegen gesetzliche Vorschriften verstoßen oder Schutzrechte oder Urheberrechte oder sonstige Rechte Dritter verletzen. Sollten diese dennoch übertragen werden, sind die einschlägigen Bestimmungen dieser Allgemeinen Geschäftsbedingungen zu berücksichtigen uns. Der Kunde trägt hierfür die Verantwortung.•Im Zusammenhang mit der Nutzung unserer Dienste, Websites, Software, Produkte, Anwendungen oder dürfen keine Software oder andere Techniken oder Verfahren eingesetzt werden",
        "Sperrung von Daten, Informationen und Ähnlichem. Für den Fall, dass ein Dritter eine Rechtsverletzung oder Ähnliches gegenüber LPT durch Daten, Inhalte, Informationen oder Ähnliches geltend macht, die uns vom Kunden übermittelt, übermittelt, überlassen oder dergleichen übermittelt wurden, ist LPT berechtigt, die entsprechenden Daten, Inhalte, Informationen oder Vergleichbares vorübergehend zu sperren, wenn der Dritte den Rechtsverstoß schlüssig dargelegt hat. In einem solchen Fall wird LPT den Kunden auffordern, die Rechtsverletzung innerhalb einer angemessenen Frist abzustellen oder die Rechtmäßigkeit der Inhalte nachzuweisen. Kommt der Kunde dieser Aufforderung nicht oder nur unzureichend nach (nach Wahl der LPT oder des Gesetzgebers), sind wir unbeschadet sonstiger Rechte und Ansprüche berechtigt, den Vertrag aus wichtigem Grund ohne Einhaltung einer Frist zu kündigen. Soweit der Kunde die Rechtsverletzung zu vertreten hat, ist er außerdem zum Ersatz des daraus entstehenden Schadens verpflichtet und hat LPT und/oder deren Partner von etwaigen Ansprüchen Dritter auf erstes Anfordern freizustellen. Weitergehende Rechte bleiben vorbehalten. ÄNDERUNGEN, ANPASSUNGEN ODER ÄHNLICHES Die LPT und/oder ein Partner ist jederzeit berechtigt, Teile unserer Dienste, Websites, Software, Produkte, Anwendungen oder vergleichbarer Gegenstände ganz oder teilweise weiterzuentwickeln, zu ändern, anzupassen, zu ergänzen, zu löschen, zu verkaufen, zu beenden oder ähnliches vorzunehmen. Diese werden mit ihrem Inkrafttreten Vertragsbestandteil des Vertrags mit dem Kunden. Hierzu bedarf es keiner Ankündigung, Meldung oder Ähnlichem gegenüber dem Kunden. Erfolgt eine Ankündigung, Nachricht oder Ähnliches an den Kunden, erfolgt dies über einen der Kommunikationskanäle von LPT (z. B. E-Mail, Konto, Website, Software, Anwendungen etc.). INDIVIDUELLE ANFORDERUNGEN / WÜNSCHE Wenn ein Kunde bestimmte Anpassungen oder etwas Vergleichbares wünscht, kann dies über den Kundenservice angefragt werden. LPT ist nicht verpflichtet, kundenspezifische Anforderungen oder Ähnliches zu akzeptieren oder umzusetzen. Die Anfragen werden vom LPT analysiert und entsprechend bewertet. Entscheidet sich die LPT für die Umsetzung des Wunsches und würden dem Kunden damit Kosten entstehen, wird vor der Umsetzung eine schriftliche Vereinbarung mit dem Kunden getroffen. Für derartige Anpassungen, Weiterentwicklungen und ähnliches gelten die in diesen Allgemeinen Geschäftsbedingungen festgelegten Bedingungen (z. B. Urheberrecht, Nutzungsbedingungen etc.).",
        "RECHTE BEI ​​MÄNGELN UND ÄHNLICHEN MÄNGELN Im Falle nicht vertragsgemäßer Leistung hat LPT und/oder ein Partner Anspruch auf Nacherfüllung und ist dazu verpflichtet, soweit gesetzlich vorgeschrieben. Erfolgt die Nacherfüllung nicht innerhalb einer angemessenen Frist, kann eine angemessene Nachfrist mit Ablehnungsandrohung gesetzt werden. Nach fruchtlosem Ablauf dieser Frist ist der Kunde berechtigt, den Vertrag fristlos zu kündigen. Der Kunde kann von LPT Schadensersatz bis maximal zur Höhe der Vertragskosten verlangen (sofern der Mangel berechtigterweise gerügt wurde). Darüber hinausgehende Schadensersatzansprüche bestehen nicht, es sei denn, es besteht diesbezüglich ein gesetzlicher Anspruch. Der Anspruch des Kunden wegen solcher Mängel verjährt in 6 Monaten, sofern hierfür keine gesetzliche Regelung besteht. SCHUTZRECHTE DRITTERFOLGEN EINER SCHUTZRECHTSVERLETZUNGSollte die vertragsgemäße Nutzung unserer Dienste, Websites, Software, Produkte, Anwendungen oder Ähnliches zu einer Verletzung von gewerblichen Schutzrechten und Urheberrechten Dritter führen und Dritte wegen einer solchen Verletzung Ansprüche gegen den Kunden erheben, ist LPT und/oder ein Partner nach unserer Wahl nach eigener Wahl verantwortlich auf Kosten entweder • das Recht zur Nutzung der Dienste, Websites, Software, Produkte, Anwendungen oder Ähnliches zu erlangen oder • unsere Dienste, Websites, Software, Produkte, Anwendungen oder Ähnliches so umzuarbeiten, anzupassen, zu ändern oder vergleichbar zu machen, dass kein Rechtsverstoß mehr vorliegt und eine akzeptable Eigenschaft der mit dem Kunden vertraglich vereinbarten Beschaffenheit aufweist. Ist eine solche Antragstellung wirkungslos oder wird sie von Dritten abgelehnt, wird LPT den Kunden im anwendungsgerechten Rahmen und nach eigenem Ermessen verteidigen. Liegt kein Verschulden des Kunden im Sinne dieser Vereinbarung oder eines Vergleichbaren bei LPT oder einem Partner vor und kann dies nachgewiesen werden, so stellt LPT gegenüber dem Kunden keinen Schadensersatzanspruch her.",
        "INFORMATIONSPFLICHT DES KUNDEN Der Kunde ist verpflichtet, uns unverzüglich zu benachrichtigen, wenn Dritte gegen ihn Schutzrechtsverletzungen geltend machen. Zu Maßnahmen, insbesondere zur gerichtlichen Abwehr der Ansprüche oder zur Befriedigung von Rechtsansprüchen Dritter unter Vorbehalt, ist der Kunde nur dann berechtigt, wenn wir zuvor mitgeteilt haben, dass wir den Kunden nicht gegen die Ansprüche verteidigen werden. HAFTUNG Eine verschuldensunabhängige Haftung auf Schadensersatz für bei Vertragsschluss bestehende Mängel ist ausgeschlossen ähnlich. Für den Fall, dass eine Online-Schulung ausgebucht ist oder aus anderen Gründen nicht stattfinden kann, wird der Kunde darüber über einen der Kommunikationskanäle von LPT (z. B., aber nicht beschränkt auf E-Mail, Konto, Website, Software, Anwendungen usw.) informiert. Die Rechnung wird unmittelbar nach Abschluss der Schulung ausgestellt und ist vom Kunden innerhalb der auf der Rechnung genannten Frist zu bezahlen. STORNIERUNG EINER ONLINE-SCHULUNGDer Kunde ist berechtigt, eine Online-Schulung bis zu 7 Kalendertage vor Beginn der Online-Schulung kostenfrei zu stornieren. Eine spätere Stornierung durch den Kunden ist ausgeschlossen.",
        "STORNIERUNG ODER ÄHNLICHES EINER ONLINE-SCHULUNG DURCH LPTLPT behält sich das Recht vor, eine Online-Schulung jederzeit aufgrund unzureichender Teilnahme oder aus anderen für uns nicht vorhersehbaren Gründen (z. B. plötzliche Erkrankung des Referenten, höhere Gewalt usw.) oder ähnliches abzusagen, abzusagen. Zur Angabe von Gründen ist LPT nicht verpflichtet. Der Kunde wird hierüber von LPT über einen der Kommunikationskanäle von LPT (z. B., aber nicht beschränkt auf E-Mail, Konto, Website, Software, Anwendungen usw.) informiert. In diesem Fall wird das Online-Training nicht verrechnet. Ein Anspruch des Kunden auf einen Ersatztermin oder etwas Vergleichbares besteht nicht. Wird eine Schulung innerhalb der Vertragslaufzeit gebucht, findet diese aber erst nach Ablauf der gekündigten Vertragslaufzeit statt, kann diese nicht mehr besucht werden. ÄNDERUNGSVORBEHALTEN PT ist berechtigt, vor, während oder nach der Online-Schulung notwendige inhaltliche, methodische, organisatorische oder vergleichbare Änderungen, Anpassungen, Abweichungen und Ähnliches vorzunehmen. Darüber hinaus sind wir jederzeit berechtigt, Referenten oder ähnliche Referenten ohne Angabe oder Mitteilung von Gründen zu wechseln. Die im Rahmen der Fortbildung zur Verfügung gestellten Unterlagen, Informationen oder vergleichbare Gegenstände werden nach bestem Wissen und Kenntnisstand erstellt. Eine Haftung und Garantie für die Richtigkeit, Aktualität, Vollständigkeit, Qualität oder Vergleichbarkeit der Daten, Inhalte, Informationen oder Vergleichbares ist ausgeschlossen.",
        "Der Eigentums- und Nutzungsvorbehalt behält sich das uneingeschränkte Eigentum an sämtlichen Lieferungen von Lehrmaterialien, Daten, Informationen und ähnlichen Gegenständen bis zur vollständigen Erfüllung sämtlicher Zahlungsverpflichtungen des Kunden vor. Der Kunde erhält das nicht ausschließliche, zeitlich und räumlich unbeschränkte Recht zur Nutzung der Lehrmaterialien, Daten, Informationen und dergleichen. Eine Weitergabe an Dritte, also an Personen, Arbeitskollegen, Mitarbeiter des Kunden, Partner o.ä., oder die öffentliche Verbreitung oder Zugänglichmachung von Lehrmaterialien, Daten, Informationen o.ä. ist nicht gestattet. Insbesondere ist die Veröffentlichung von Audio- oder Videodaten, digitalen Präsentationen oder Skripten sowie dergleichen in öffentlich zugänglichen Internetportalen (Sharing) oder Ähnlichem untersagt. Gleiches gilt für die Bearbeitung, Änderung, Anpassung oder Vergleichbares der Lehrmaterialien, Daten, Informationen oder Vergleichbares der Online-Schulung. Die Lehrmaterialien, Daten, Informationen und vergleichbare Gegenstände, insbesondere Aufzeichnungen und Dokumente und vergleichbare Gegenstände, stehen dem Kunden bis zum Ende der Vertragslaufzeit zur Verfügung. Der Kunde ist ohne vorherige schriftliche Zustimmung von LPT nicht berechtigt, Lehrmaterialien, Daten, Informationen oder ähnliches vor Ort aufzubewahren. Soweit der Kunde bei Vertragsende rechtmäßig Lehrmaterialien, Daten, Informationen und ähnliches gespeichert hat, erlischt dieses Recht mit Vertragsende und ist vom Kunden ohne gesonderte Aufforderung durch LPT vollständig zu löschen. Nachdem der Kunde die vollständige Löschung durchgeführt hat, muss er LPT schriftlich über die vollständige Löschung informieren. Eine unvollständige Löschung durch den Kunden ist, auch nach schriftlicher Aufforderung des Kunden, nicht zulässig.",
        "KundendienstDer Kundendienst stellt die grundlegende Kontaktstelle zwischen jeder Person, unabhängig davon, ob es sich um einen Kunden handelt oder nicht, und dem Unternehmen dar. Daher sollten alle Ihre Anfragen an den Kundendienst gerichtet werden. Bitte beachten Sie, dass der Kundendienst Ihren Anfragen die gebührende Bedeutung und Berücksichtigung beimisst. Wir geben unser Bestes, um Ihre Fragen so schnell wie möglich zu beantworten. Wenn Sie Fragen haben, schauen Sie sich bitte unsere Vereinbarungen und Geschäftsbedingungen an. E-Mail-Adresse des Kundendienstes: Customer ServiceÄnderungen an unseren Vereinbarungen und Geschäftsbedingungen Wir behalten uns das Recht vor, unsere Vereinbarungen und Geschäftsbedingungen jederzeit zu ändern, indem wir Änderungen auf unserer Website und/oder Plattformen und/oder Software und/oder mobilen Anwendungen oder anderen von uns veröffentlichen. Solche Änderungen werden mit der Veröffentlichung oder dem Hochladen wirksam. Ungültig oder nicht durchsetzbar. Wenn eine der Bestimmungen dieser Vereinbarung ungültig oder nicht durchsetzbar wird oder wird: Alle anderen Bestimmungen dieser Vereinbarung bleiben in vollem Umfang in Kraft und wirksam; undDie ungültige oder nicht durchsetzbare Bestimmung gilt automatisch als geändert und durch eine gültige oder durchsetzbare Bestimmung ersetzt, die den Zweck und die Absicht der ungültigen und nicht durchsetzbaren Bestimmung wirtschaftlich so weit wie möglich erfüllt. Die gleichen Regeln gelten für unbeabsichtigte Auslassungen (falls vorhanden).",
        "DATENSCHUTZRICHTLINIEN (COOKIES UND DATENSCHUTZ) Wir begrüßen Sie auf unserer Website, unseren Einrichtungen, Plattformen, Softwares, Anwendungen und anderen. LPT (im Folgenden „LPT“, „幸运丹鸟（珠海）科技有限公司“ genannt) und seine verbundenen Unternehmen (zusammen „Wir“, „Unser“ oder „Uns“) respektieren die Privatsphäre unserer Benutzer und sind dem Schutz der Privatsphäre der Benutzer nachdrücklich verpflichtet. Diese Datenschutzrichtlinie gilt für diese Website, für jede Software oder Anwendung von uns, für jede Website von uns oder für Websites Dritter, für Software, Dienste und Anwendungen sowie für die gesammelten (online oder offline) und uns zur Verfügung gestellten Informationen, gilt jedoch nicht für andere Produkte oder Dienste von uns, sofern wir nicht ausdrücklich etwas anderes angeben (z. B. durch Einfügen eines Links zu dieser Datenschutzrichtlinie auf anderen Websites von uns oder in Software oder mobilen Anwendungen von uns). SPEICHERUNG IHRER IP-ADRESSE Wir speichern die von uns übermittelte IP-Adresse Ihr Webbrowser ausschließlich zum Zweck der Identifizierung, Einschränkung und Beseitigung von Angriffen auf unsere Website, Software oder mobilen Anwendungen oder auf unsere Dienste, Einrichtungen und andere von uns oder Dritten, die wir möglicherweise akzeptiert haben. Wir speichern Ihre IP-Adresse so lange, wie es für die Erbringung unseres Dienstes oder anderer von uns erforderlich ist und der Löschung keine Aufbewahrungsfristen entgegenstehen.",
        "ERFASSUNG IHRER PERSONENBEZOGENEN DATEN Wir oder gegebenenfalls ein benannter Dienstanbieter erfassen personenbezogene Informationen und Daten, die Sie freiwillig auf unserer Website, Software, mobilen Anwendungen, auf Websites, Software und Anwendungen Dritter (online oder offline) angeben. Dazu können Ihr Name, Ihre Adresse, E-Mail-Adresse, Kontaktinformationen, Kreditkartennummer, Rechnungsinformationen, Ihr Passwort, Ihr Alter usw. gehören. Beispielsweise erfassen wir oder ein benannter Dienstanbieter solche Informationen, wenn Sie sich auf unserer Website, Software, mobilen Anwendungen usw. registrieren. Wir erfassen personenbezogene Daten Sie übermitteln uns, wenn Sie unsere Websites, Software, mobilen Anwendungen, Dienstleistungen, Produkte nutzen oder sich für ein Konto bei uns registrieren. Dazu können Vor- und Nachname, Geburtsdatum, Kreditkarteninformationen, Benutzername und Passwort, Alters- und Identitätsnachweis, Rechnungsadresse, Privatadresse, E-Mail-Adresse, Telefonnummer oder andere Kontaktinformationen gehören. Darüber hinaus erfassen wir technische Informationen über Ihr Gerät und die Plattform, wie z. B. Verwaltungs- und Verkehrsinformationen, einschließlich, aber nicht beschränkt auf: Quell-IP-Adresse, Zugriffszeit, Zugriffsdatum, Gerätetyp, besuchte Webseite(n), Sprachgebrauch, Ihren Standort, Roaming-Tracking, Software-Absturzberichte und Art des verwendeten Browsers. Diese Informationen sind für die Bereitstellung und Qualität der Dienste und anderer Dienste von wesentlicher Bedeutung. Wir erfassen Ihr öffentliches Profil, einschließlich Name, Foto und andere Informationen, die Sie uns zur Verfügung stellen, wenn Sie unsere Social-Media-Seiten oder andere Dienste und Produkte mögen, posten oder anderweitig damit interagieren. Wir können Aufzeichnungen über die Kommunikation führen, wenn Sie uns kontaktieren oder anderweitig mit uns interagieren, einschließlich per E-Mail, Brief, Textnachricht (SMS), online, über Software, Messaging-Anwendungen wie WhatsApp-Anwendungen und Skype, Telefon oder Live-Chat-Funktion auf unserer Website und andere. Wir sammeln auch andere Informationen aus Datenbanken Dritter, um unseren gesetzlichen und behördlichen Verpflichtungen nachzukommen. Wir erhalten Ihre personenbezogenen Daten möglicherweise auch von Online-Anbietern und Dienstleistern wie Finanz- und Shared-Liquidity-Diensten sowie aus Kundenlisten, die rechtmäßig von Drittanbietern erworben wurden. Wir können zusätzliche Informationen über Sie sammeln, wenn Sie uns diese Informationen durch Ihre Nutzung unserer Dienste, Websites, Software, mobilen Anwendungen oder Produkte zur Verfügung stellen. Wenn Sie bestimmte personenbezogene Daten nicht angeben, sind nicht alle Funktionen unserer Websites, Software oder mobilen Anwendungen verfügbar.",
        "VON IHNEN BEREITGESTELLTE INFORMATIONEN ÜBER ANDERE Bitte geben Sie keine Informationen über andere weiter, es sei denn, Sie sind dazu berechtigt und stimmen zu, dass alle Informationen gemäß dieser Datenschutzrichtlinie verwendet, offengelegt und übertragen werden. Wenn Sie solche Informationen über andere übermitteln, erklären und garantieren Sie, dass Sie dazu berechtigt sind. Dazu gehört auch, dass Sie die Genehmigung von der Person erhalten haben, über die Sie Informationen bereitstellen, über die Sie diese Informationen bereitstellen und dass die Person zugestimmt hat, dass alle Informationen gemäß dieser Datenschutzrichtlinie verwendet, offengelegt und übertragen werden. Bitte beachten Sie die Regeln für das Hochladen von Inhalten Dritter auf unsere Websites, Software, mobilen Anwendungen, Dienste, Produkte oder andere. Bitte beachten Sie, dass diese Datenschutzrichtlinie zwischen Ihnen und uns vereinbart wird und Teil Ihrer Vereinbarungen mit uns ist. Wir können in regelmäßigen Abständen Änderungen an dieser Datenschutzrichtlinie vornehmen und empfehlen Ihnen dringend, diese Datenschutzrichtlinie regelmäßig erneut zu lesen. Bitte beachten Sie die folgenden Allgemeinen Geschäftsbedingungen:Wir beanspruchen keine Eigentumsrechte an Inhalten Dritter, die Sie auf unseren Websites, Softwares, mobilen Anwendungen, Diensten, Produkten oder anderen Inhalten veröffentlichen. Sie erklären sich damit einverstanden, dass Sie allein für alle von Ihnen unter Ihrer Benutzer-ID veröffentlichten Inhalte Dritter verantwortlich sind.Sie gewähren uns hiermit eine nicht ausschließliche, gebührenfreie, weltweite, unbefristete Lizenz (einschließlich des Rechts zur Unterlizenzierung) zur Nutzung (und zur Anfertigung solcher Kopien, die wir für notwendig erachten, um die Veröffentlichung und Speicherung Ihrer Inhalte Dritter auf unseren Websites, Software, mobilen Anwendungen, Dienstleistungen, Produkten und anderen oder in Verbindung mit Werbeaktionen in allen derzeit bekannten Medien zu erleichtern). im Folgenden entwickelt.Sie garantieren uns, dass Sie die volle Macht und Autorität haben, die Lizenz gemäß 2) oben zu erteilen, und dass die von Ihnen geposteten Inhalte Dritter nicht die geistigen Eigentumsrechte, andere Eigentumsrechte oder Rechte auf Veröffentlichung oder Privatsphäre Dritter verletzen; nicht gegen Gesetze, Satzungen, Verordnungen oder Vorschriften verstoßen;nicht verleumderisch, handelsverleumderisch, rechtswidrig bedrohlich oder rechtswidrig sind belästigend ist;nicht obszön oder pornographisch ist und keine Kinderpornografie enthält;verstößt nicht gegen Gesetze bezüglich unlauterem Wettbewerb, Antidiskriminierung oder falscher Werbung;stellt keine der Arten verbotener Dritter dar",
        "Der Inhalt enthält keine Viren, Trojaner, Würmer, Zeitbomben, Cancel-Bots oder andere Computerprogrammierungsroutinen, die darauf abzielen, Systeme, Daten oder persönliche Informationen zu beschädigen, schädlich zu beeinträchtigen, heimlich abzufangen oder zu enteignen. Sie erklären sich damit einverstanden, alle Lizenzgebühren, Gebühren oder sonstigen Gelder zu zahlen, die Dritten geschuldet werden, wenn Sie Inhalte Dritter auf einer unserer Websites, Software, mobilen Anwendungen veröffentlichen. Dienstleistungen, Produkte oder sonstiges.Sie erkennen an, dass Folgendes (aber nicht ausschließlich) verbotene Inhalte Dritter darstellt: Inhalte Dritter, die:beleidigend sind, Rassismus, Bigotterie, Hass oder körperliche Schädigung jeglicher Art gegen einen LPT oder eine Einzelperson fördern oder eine Person ausbeuten, belästigen oder deren Belästigung befürworten; Informationen darstellen, von denen Sie wissen, dass sie falsch oder irreführend sind oder illegale Aktivitäten oder Verhaltensweisen fördern, die beleidigend, bedrohlich, obszön, verleumderisch oder verleumderisch sind; enthält Nacktheit, übermäßige Gewalt oder anstößige Inhalte oder Links zu solchen Inhalten; fordert personenbezogene Daten von Personen unter achtzehn Jahren oder unter einem anderen höheren oder niedrigeren gesetzlichen Mindestalter in Ihrer Gerichtsbarkeit ein; Informationen enthalten, die ein Datenschutz- oder Sicherheitsrisiko für eine Person darstellen oder schaffen; eine nicht autorisierte Kopie des urheberrechtlich geschützten Werks einer anderen Person enthält; und ein Foto oder Video einer anderen Person enthält, das Sie ohne die Zustimmung dieser Person gepostet haben. VERWENDUNG IHRER PERSÖNLICHEN DATEN UND INFORMATIONSVERWENDUNG Wir verwenden die Informationen für wohlüberlegte Geschäftszwecke, die auch Kunden zugute kommen und einige oder alle der folgenden und möglicherweise noch mehr umfassen, um:Unsere Dienstleistungen und Produkte bereitzustellen;Hilfe und Unterstützung bei der Verbesserung unserer Dienstleistungen und Produkte;Neue Dienstleistungen und Produkte zu entwickeln;Mit Ihnen und Ihren Kunden zu kommunizieren;Interne Qualitätskontrollzwecke bereitzustellen;Sie mit Informationen zu versorgen.Sie mit Angeboten und Werbeaktionen zu Dienstleistungen zu versorgen und",
        "Produkte von uns oder anderen Parteien, die für Sie oder Kunden von Interesse sein könnten.Verbessern Sie Ihr Erlebnis mit den Websites, Softwares oder mobilen Anwendungen, einschließlich der Speicherung Ihrer Präferenzen, Anmeldeinformationen usw Uns.Bereitstellung von Kundensupport- und Servicenachrichten, einschließlich Nachrichten, in denen Sie um Ihr Feedback zu unseren Diensten gebeten werden, und um Sie möglicherweise über Änderungen an unserer Website, unseren Diensten oder Änderungen unserer Allgemeinen Geschäftsbedingungen und Richtlinien zu informieren. Um jederzeit Sicherheitsüberprüfungen durchzuführen, um Ihre Identität, Ihr Alter und die von Ihnen bereitgestellten Registrierungsinformationen zu überprüfen und Ihre Nutzung unserer Dienste und Ihre Finanztransaktionen auf mögliche Verstöße gegen unsere Allgemeinen Vereinbarungen, Geschäftsbedingungen und geltendes Recht zu überprüfen. Sicherheitsüberprüfungen können beispielsweise die Bestellung einer Kreditauskunft und/oder die anderweitige Überprüfung der von Ihnen bereitgestellten Informationen anhand von Datenbanken Dritter umfassen. Um Ihre Online-Transaktionen und Zahlungen zu verarbeiten (einschließlich der Offenlegung Ihrer persönlichen Daten an externe Zahlungsabwickler und ggf. andere Finanzinstitute).Um Sie bei der Teilnahme an Werbeaktionen, Marktforschungen und Veranstaltungen Dritter zu unterstützen. Kundentelefon- und Chatgespräche können aufgezeichnet werden, damit wir die Qualität unseres Kundendienstes und unserer Produkte verbessern, Mitarbeiter schulen und im Falle einer späteren Beschwerde aufzeichnen können, was gesagt wird. Um Ihnen Werbeangebote und Informationen zur Verfügung zu stellen, wenn Sie Interesse an unseren Produkten angegeben haben oder wir daraus schließen. Wir überwachen die Nutzung unserer Websites, Software, mobilen Anwendungen, Online-Dienste und Produkte und nutzen Ihre",
        "personenbezogene Daten, die uns dabei helfen, unsere Inhalte, Dienste und Websites sowohl online als auch offline zu verbessern und zu schützen. Wir verwenden personenbezogene Daten, um unsere Website, Software, mobilen Anwendungen, Dienste und Produkte für Sie zu personalisieren. Wir überwachen Kundenkonten, um den Einsatz unlauterer Praktiken auf unserer Website, Software, mobilen Anwendungen, Dienstleistungen und Produkten zu verhindern. Wir verwenden personenbezogene Daten, um Beschwerden von Ihnen oder anderen über unsere Websites, Software, mobilen Anwendungen, Dienstleistungen oder Produkte zu untersuchen. Es kann erforderlich sein, dass wir Ihre Daten an vertrauenswürdige Dritte weitergeben, die uns Dienstleistungen erbringen, die für unsere Bereitstellung unserer Einrichtungen relevant sind, einschließlich Kundensupport, Informationssicherheit, Zahlungen, Marketing, Datenanalyse, Forschung und Umfragen. Wir werden personenbezogene Daten im Zusammenhang mit rechtlichen Ansprüchen und bei Bedarf für Compliance-, Regulierungs- und Ermittlungszwecke verwenden (einschließlich der Offenlegung solcher Informationen im Zusammenhang mit rechtlichen Verfahren oder Rechtsstreitigkeiten). Wir verwenden Ihre persönlichen Daten, um ein Profil Ihrer demografischen Merkmale, wahrscheinlichen Verhaltensweisen und Vorlieben zu erstellen. Dies wird verwendet, um die Entscheidungen zu treffen, die wir in Bezug auf die von uns angebotenen Dienste, Inhalte und Werbeaktionen treffen. Wir berichten auch über den unterschiedlichen Beitrag verschiedener Kundenprofile zu unserer Geschäftsleistung. Wir erstellen Profile durch manuelle oder automatisierte Prozesse, auch von Drittanbietern.Vorbehaltlich Ihrer Marketingpräferenzen (falls zutreffend) verwenden wir Ihre persönlichen Daten, um Marketingmitteilungen zu übermitteln, die für verschiedene Plattformen von Interesse sein können, wie z. B. E-Mail, SMS, Telefon, Post, online, Posteingangsnachrichten, Push-Benachrichtigungen oder andere verfügbare Kanäle, um Sie mit Informationen zu unseren Produkten, Dienstleistungen und Werbeaktionen, einschließlich anderer, zu versorgen. Um Ihre Kontaktdaten an ausgewählte Medienpartner und verbundene Unternehmen weiterzugeben, damit diese Ihnen ihre eigenen Marketingdienstleistungen anbieten können. Wir tun dies nur, wenn wir Ihr Einverständnis haben und im Einklang mit Ihren Marketingpräferenzen.",
        "Um Sie an Umfragen oder Werbeaktionen teilhaben zu lassen, denen Sie zugestimmt haben.Wir platzieren Cookies und verwenden ähnliche Technologien in Übereinstimmung mit unseren Richtlinien/Richtlinien.In anderen Fällen, in denen wir Sie um Ihre Erlaubnis bitten, werden wir Ihre persönlichen Daten für den Zweck verwenden, den wir zu diesem Zeitpunkt erläutern. Als Reaktion auf Anfragen von Regierungs- oder Strafverfolgungsbehörden, die eine Untersuchung durchführen. Betrug, Terrorismus, Falschdarstellungen, Sicherheitsvorfälle oder Straftaten gemäß geltendem Recht untersuchen und/oder melden. Wir verwenden alle Kreditkarten- oder Zahlungsinformationen, die wir von Ihnen erhalten, um Dienstleistungen, Produkte oder andere Zwecke zu erfüllen. Sie können Ihre Einstellungen aktualisieren. Bitte beachten Sie, dass Sie bei Änderungen Ihrer Einstellungen in einer bestimmten Weise weiterhin einige Informationen zu Ihrem Konto, den von Ihnen angeforderten Diensten und Produkten sowie als Antwort auf alle von Ihnen angeforderten Informationen erhalten. Bitte beachten Sie, dass einige spezifische Änderungen Ihrer Einstellungen möglicherweise Auswirkungen auf die Funktionalitäten haben und Ihnen möglicherweise nicht alle Funktionalitäten zur Verfügung stehen. Bitte beachten Sie, dass bei der Nutzung der Opt-Out-Funktion die Bearbeitung gemäß geltendem Recht einige Zeit in Anspruch nehmen kann. Aus Sicherheits- oder anderen geschäftlichen Gründen sowie zur Aufnahme in das Personenverzeichnis dürfen wir Videos oder Fotos anfertigen. DATENSICHERUNGSPFLICHT Wir sichern alle Daten, Informationen und vergleichbare Gegenstände wirksam gegen unbefugten Zugriff, Veränderung, Zerstörung oder Verlust, unbefugte Weitergabe, sonstige unbefugte Verarbeitung und sonstigen Missbrauch, soweit dies mit technisch und wirtschaftlich vertretbarem Aufwand möglich ist. Sofern eine Gefährdung von Daten, Informationen oder vergleichbaren Gegenständen auf andere Weise mit technisch und wirtschaftlich angemessenem Aufwand nicht behoben werden kann oder nicht erfolgversprechend ist, ist LPT berechtigt, Daten, Informationen oder vergleichbare Gegenstände mit schädigendem Inhalt zu löschen.",
        "FOLGEN DER VERTRAGSKÜNDIGUNG Wird das Vertragsverhältnis, gleich aus welchem ​​Rechtsgrund, beendet, sind die Parteien zur ordnungsgemäßen Durchführung des Vertragsverhältnisses verpflichtet. In diesem Zusammenhang ist LPT berechtigt, sämtliche Daten, Informationen oder vergleichbare Gegenstände des Kunden unverzüglich zu löschen. Bei Vertragsbeendigung werden die Zugänge, Accounts und Ähnliches des Kunden automatisch gesperrt, gesperrt, gelöscht o.ä. LPT ist nicht verpflichtet, Daten, Informationen oder ähnliches an den Kunden weiterzugeben. VERWENDUNG VON COOKIES UND ANDEREN ELEKTRONISCHEN WERKZEUGEN Wir und die Parteien, mit denen wir zusammenarbeiten (wie Dienstanbieter, Werbetreibende, Werbeserver, Geschäftspartner usw.), können „Cookies“, Web Beacons, Webserver-Protokolle oder andere elektronische Werkzeuge platzieren, verwenden, anzeigen usw., um statistische und andere Informationen über Sie und Ihre Nutzung der Websites, anderer Websites, Software oder mobiler Anwendungen zu sammeln. Diese Informationen können Informationen über Ihre IP-Adresse, IP-Adresse Ihres Computers, Browsertyp, Betriebssystem, Ihr Mobilgerät, Einstellungen, Browsertyp, Geräte-ID, Geostandortdaten, das Bundesland, die Stadt, das Dorf oder das Land, von dem aus Sie auf diese Websites, Software oder mobilen Anwendungen zugreifen oder sich registrieren, die von Ihnen besuchten Webseiten, die Daten, die Besuchszeit, die Websites, die Sie unmittelbar vor und nach dem Besuch dieser Website besucht haben, die Anzahl der Links, die Sie auf diesen Websites, Software oder mobilen Anwendungen anklicken, Funktionen, die Sie auf diesen Websites verwenden, umfassen. Datenbanken für Software oder mobile Anwendungen, die Sie ansehen, durchsuchen, die Sie auf diesen Websites, Software oder mobilen Anwendungen anfordern, Daten und Informationen, die Sie auf diesen Websites, Software oder mobilen Anwendungen speichern oder von diesen herunterladen, und die Häufigkeit, mit der Sie Werbung ansehen (auf Websites, Software oder mobilen Anwendungen usw.) usw. Wir und die Parteien, mit denen wir zusammenarbeiten, können die gesammelten Informationen und Daten aus verschiedenen Gründen verwenden, entweder in unserem Namen oder für die eigenen Zwecke der anderen Parteien, einschließlich beispielsweise Verbesserung, Forschung, Analyse usw., um Benutzer, Besucher oder Kunden dieser Websites besser zu bedienen Websites, Software oder mobilen Anwendungen (z. B. durch Registrierung, Ermöglichung der Anmeldung, Bereitstellung des Zugriffs auf Seiten, Dienste, Produkte der Websites, Software oder mobilen Anwendungen, Bereitstellung von benutzerdefinierten oder anderen Inhalten, Präsentation von Online- oder Offline-Werbung auf den Websites, Software oder mobilen Anwendungen), um aggregierte und anonyme Informationen und Daten über die Nutzung usw. dieser Websites, Software oder mobilen Anwendungen, andere Statistiken usw. zusammenzustellen",
        "Wenn Sie uns bei den in dieser Datenschutzrichtlinie beschriebenen Verwendungen usw. unterstützen möchten, können Informationen und Daten, die über Sie und Ihre Nutzung dieser Websites, Software oder mobilen Anwendungen erfasst, analysiert usw. werden, aggregiert, analysiert oder mit persönlichen oder anderen Informationen und Daten über Sie und Ihre Nutzung aus anderen Online- oder Offline-Quellen kombiniert werden. Falls Sie nicht möchten, dass wir nicht-personenbezogene Informationen und Daten, die usw. durch Cookies über Sie und Ihre Nutzung usw. dieser Websites, Software oder mobilen Anwendungen gesammelt wurden, mit persönlichen oder anderen Informationen oder Daten über Sie und Ihre Nutzung usw. kombinieren, löschen und deaktivieren Sie bitte Cookies für jeden Browser, auf jedem Computer, Mobilgerät, Laptop oder jedem anderen Gerät, mit dem Sie im Internet surfen. Bitte beachten Sie, dass die meisten Browser standardmäßig so eingestellt sind, dass sie Cookies akzeptieren. Wenn Sie möchten, können Sie Ihren Browser normalerweise so einstellen, dass er Sie benachrichtigt, wenn Cookies gesendet werden, oder Cookies deaktiviert. Bei den meisten Mobilgeräten können Sie die Erfassung von Standortinformationen und -daten von Ihrem Mobilgerät aus deaktivieren. Die meisten Browser, mobilen Geräte oder andere verfügen über eine Hilfe- oder Supportfunktion, die Anweisungen dazu enthält, wie Sie Ihren Browser, Ihr mobiles Gerät oder andere so einstellen, dass Sie vor der Annahme benachrichtigt, Cookies deaktiviert oder die Erfassung von Geostandortdaten und -informationen deaktiviert werden. Sie müssen Ihre Präferenzen auf jedem Gerät festlegen, mit dem Sie im Internet surfen. Wenn Sie jedoch Cookies deaktivieren oder die Annahme einer Anfrage zum Platzieren von Cookies oder eines Cookies ablehnen, ist es möglich, dass dieselben Funktionen oder Teile der Website, Software, mobilen Anwendungen oder anderen, wie z. B. Umfragen, Inhalte, Umfragen, Produktverkäufe, Mai-Updates oder andere, sowie bestimmte Bereiche der Website, des Mobilgeräts oder anderer, für die Sie sich anmelden müssen, nicht ordnungsgemäß funktionieren und die Werbung oder andere, die Sie möglicherweise erhalten, wenn Sie die Websites, Mobilgeräte oder andere besuchen, möglicherweise nicht auf Ihre Interessen oder Ihre Arbeit zugeschnitten ist.",
        "WERBUNGWir, unsere benannten Dienstleister oder Drittanbieter oder Werbeserver können Cookies auf Ihrem oder unserem Computer, Laptop, Mobilgerät, Software, mobilen Anwendungen oder anderen elektronischen Werkzeugen oder anderen Geräten platzieren oder erkennen. Diese unterstützen oder helfen jedoch bei der Anzeige von Werbung, die Sie auf unseren Websites, Mobilgeräten, Software, mobilen Anwendungen oder anderen sehen können. Daten und Informationen über Ihre Besuche auf oder von und Aktivitäten auf unseren Websites, Mobilgeräten, Softwares, mobilen Anwendungen oder anderen, eine IP-Adresse, die Häufigkeit, mit der Sie eine Werbung angesehen haben, und andere solche Daten und Informationen werden allein oder in jeglicher Kombination mit anderen Daten und Informationen verwendet, um Werbung auf Ihrem Display, Bildschirm, Mobilgerät oder anderen Geräten anzuzeigen, die für Sie von besonderem Interesse sein könnten. Wir oder andere Dritte können Web-Beacons verwenden, die von externen Werbefirmen oder anderen Unternehmen bereitgestellt werden, um unsere Online- und Offline-Werbung und Produktleistung oder ähnliches zu verwalten und zu optimieren. Web-Beacons ermöglichen es uns, das Cookie eines Browsers zu erkennen, wenn ein Browser unsere Websites oder Mobilgeräte, Software, Mobilanwendungen oder andere besucht, und geben uns die Möglichkeit zu erfahren, welche Bannerwerbung oder andere Werbebanner Benutzer auf unsere Websites, Mobilgeräte, Software, Mobilanwendungen oder andere führen. Diese Datenschutzrichtlinie deckt nicht die Nutzung und Erfassung Ihrer Daten und Informationen durch diese Drittanbieter sowie Drittanbieter und deren Werbeserver ab. Wenn Sie dies nicht akzeptieren, besuchen und/oder nutzen Sie bitte unsere Websites, mobilen Geräte, mobilen Anwendungen, Softwares, Einrichtungen, Anwendungen oder andere nicht. Selbst wenn Sie sich für gezielte Werbung entscheiden, erhalten Sie möglicherweise weiterhin Online- oder Offline-Werbung.",
        "OFFENLEGUNG IHRER PERSÖNLICHEN INFORMATIONEN UND DATEN Wir können Ihre persönlichen Informationen und Daten an andere verbundene Unternehmen (einschließlich verbundener Websites unter gemeinsamer Eigentümerschaft oder Kontrolle), Tochtergesellschaften und benannte Dienstleister weitergeben, auch für die in unserer Datenschutzrichtlinie oder anderen von uns dargelegten Zwecke. Wir können Daten und Informationen über unsere Website-Benutzer, Benutzer mobiler Geräte, Software, Benutzer mobiler Anwendungen oder andere Produktbenutzer von uns an andere Dritte weitergeben, wie z. B. Ihre Nutzung unserer Websites oder anderer Websites, Software, mobiler Anwendungen und Dienste, die auf den Websites, mobilen Geräten, Software, mobilen Anwendungen oder anderen von uns bereitgestellt werden. Wir geben möglicherweise Daten und Informationen (einschließlich personenbezogener Daten) an einen Sponsor, Drittanbieter oder einen anderen Dritten weiter, der Ihnen Werbeaktionen, Angebote oder andere Informationen und Daten bereitstellt, die für Sie von Interesse sein könnten. Wenn Sie uns anweisen, Ihre personenbezogenen Daten, die unserer Datenschutzrichtlinie unterliegen, nicht an solche Drittanbieter weiterzugeben, nutzen Sie bitte die Opt-out-Funktion. Bitte beachten Sie: Wenn Sie sich für die Nutzung dieser Opt-out-Funktion entscheiden, beachten Sie bitte, dass einige Funktionen der Websites, Software, mobilen Anwendungen oder anderer von uns möglicherweise nicht funktionieren. Bitte beachten Sie außerdem, dass dieser Opt-out-Prozess einige Zeit in Anspruch nehmen kann. Auch nach Abschluss eines solchen Opt-out-Prozesses können Ihre persönlichen Daten und personenbezogenen Daten weiterhin an unsere verbundenen Unternehmen und Tochtergesellschaften (einschließlich Partner-Websites, Software im gemeinsamen Eigentum oder unter gemeinsamer Kontrolle oder mobile Anwendungen im gemeinsamen Eigentum oder unter gemeinsamer Kontrolle oder ähnliche andere) und benannte Dienstanbieter weitergegeben werden. Wenn Sie sich für die Teilnahme an bestimmten Funktionen unserer Websites, mobilen Anwendungen oder anderen entscheiden, beachten Sie bitte, dass alle Daten und Informationen (mit Ausnahme von Sicherheitsdaten und Informationen wie Passwörtern), die Sie oder andere durch die Nutzung dieser Funktionen freiwillig offenlegen, für uns und die anderen zugänglich gemacht werden öffentliche und/oder andere Benutzer, die Sie benannt haben oder nicht. Wenn Sie sich dafür entscheiden, bestimmten Benutzern oder Einzelpersonen Zugriff zu gewähren, beachten Sie bitte, dass die von Ihnen geposteten Informationen für diese Benutzer oder Einzelpersonen und möglicherweise auch für uns sichtbar sind. Wir sind nicht verantwortlich für Daten oder Informationen, die Sie oder andere auf unseren Websites, in unserer Software, in mobilen Anwendungen oder anderen von uns öffentlich offenlegen oder bestimmten Personen Zugriff gewähren, und die Nutzung dieser Daten und Informationen durch uns oder andere unterliegt nicht dieser Datenschutzrichtlinie. Wir können Ihre personenbezogenen Daten und Informationen an nicht verbundene Dritte weitergeben, wenn wir in gutem Glauben davon ausgehen, dass eine solche Offenlegung erforderlich oder notwendig ist, um:die Interessen, Rechte, Sicherheit oder das Eigentum von uns zu schützen",
        "andere;  Alle geltenden Gesetze, Vorschriften, Regeln einhalten oder als Reaktion auf einen Gerichtsbeschluss oder ein anderes rechtliches Verfahren, das uns unterliegt;  Weitergabe an Strafverfolgungs- und Behörden, um einer gesetzlichen Verpflichtung nachzukommen oder wenn wir glauben, dass wir verpflichtet sind, einer Verpflichtung nachzukommen.  Weitergabe an Dritte, um unsere Nutzungsbedingungen und andere Vereinbarungen durchzusetzen; oder um die Rechte, das Eigentum oder die Sicherheit von uns, Dritten oder der Öffentlichkeit zu schützen; Weitergabe an andere Online-Sites, Banken, Kreditkartenunternehmen und entsprechende Agenturen, wenn festgestellt wird, dass Sie uns oder einen anderen Nutzer unserer Dienste betrogen oder versucht haben, ihn zu betrügen, was unter anderem Manipulation, Zahlungsbetrug oder verbotene Transaktionen umfassen kann; Weitergabe an Dritte im Falle eines Verkaufs, Kaufs von Vermögenswerten, einer Fusion, eines Konkurses oder eines Umstrukturierungsverfahrens;Weitergabe an Drittanbieter, die die Daten in unserem Namen für die oben genannten Zwecke verarbeiten. Zu diesen Dritten gehören Anbieter von Website-Hosting, Wartung, Callcenter-Betrieb, Identitätsprüfung, Informationsverifizierungsdiensten, Marketing, Datenanalyse, Forschung und Umfragen, externe Zahlungsabwickler und/oder Finanzinstitute zur Abwicklung von Finanztransaktionen sowie andere Organisationen, die technischen Support leisten, Ihre Online-Transaktionen verarbeiten und Ihr Konto pflegen; Käufer von uns oder unserer Abteilung oder Tochtergesellschaften oder anderen, um Sie weiterhin zu bedienen)Bereitstellung und Durchführung anderer Aktivitäten im Zusammenhang mit solchen Dienstleistungen, Produkten, Softwares, Anwendungen und anderen (einschließlich beispielsweise Abrechnung und Inkasso)Bereitstellung von Werbeaktionen oder Angeboten von uns oder anderen DrittenBetreiben Sie die Systeme, die unsere Dienstleistungen, Produkte, Software, Anwendungen und andere bereitstellen und ausführen, ordnungsgemäß.",
        "Die Erhebung, weitere Nutzung und/oder Weitergabe Ihrer personenbezogenen Daten und Informationen durch Drittanbieter oder sonstige Dritte liegt nicht in unserem Verantwortungsbereich. Vielmehr unterliegen solche Erhebungen, Nutzungen und/oder Offenlegungen den Datenschutzbestimmungen Dritter. GENAUIGKEIT, SICHERHEIT UND AUFBEWAHRUNG IHRER PERSÖNLICHEN DATEN Wir sind uns der Bedeutung der Informationssicherheit und der zum Schutz von Informationen erforderlichen Techniken bewusst. Alle Daten und Informationen, die Sie uns zur Verfügung stellen, werden an sicheren Orten aufbewahrt. Wir können Speicher, Clouds, Server oder andere Drittanbieter nutzen. Wir können angemessene organisatorische, technische und administrative Maßnahmen ergreifen, um Ihre personenbezogenen Daten vor unbefugtem Zugriff oder unbefugter Änderung, Offenlegung oder Zerstörung von Informationen, die wir beispielsweise besitzen, zu schützen. Um uns dabei zu helfen, Ihre Privatsphäre zu schützen, sollten Sie die Anmelde-ID und das Passwort geheim halten, die Sie möglicherweise im Zusammenhang mit Ihrer Teilnahme an unseren Websites, Diensten, Produkten, Softwares, mobilen Anwendungen oder anderen von uns eingerichtet haben. Der Zeitraum, für den wir Daten über Sie aufbewahren dürfen, hängt von den Zwecken ab, für die die Daten erfasst wurden, davon, ob Sie die Löschung der Daten beantragt haben und ob gesetzliche Verpflichtungen die Aufbewahrung der Daten erfordern (z. B. zur Einhaltung gesetzlicher Vorschriften). Persönliche Daten werden so lange aufbewahrt, wie es für den Zweck, für den sie erfasst werden, erforderlich ist, einschließlich legitimer geschäftlicher Gründe und/oder Anforderungen. SCHUTZ UND SICHERUNG IHRER KONTOINFORMATIONEN Dies sind einige Möglichkeiten, die Sie in Betracht ziehen sollten, um Anmeldeinformationen sicher aufzubewahren:  Teilen Sie niemals ein Computerkonto Telefon, E-Mail oder Instant Messaging.Achten Sie darauf, sich abzumelden, bevor Sie einen Computer unbeaufsichtigt lassen.Ändern Sie Passwörter, wenn der Verdacht besteht, dass sie möglicherweise kompromittiert wurden.Halten Sie Betriebssystem-, Software- und Anwendungspasswörter unterschiedlich.Passwörter sollten alphanumerisch sein.Machen Sie Passwörter zufällig, aber leicht zu merken.Achten Sie auf aktuelle Antivirensoftware",
        "Achten Sie auf eine aktuelle persönliche Firewall. Vermeiden Sie die Nutzung Ihres Kontos auf Computern, die für die Öffentlichkeit zugänglich sind, z. InternetcafésÄndern Sie Ihr Passwort regelmäßig.Halten Sie Ihr Betriebssystem, Ihren Browser und Ihre Browser-Plugins auf dem neuesten Stand.Deaktivieren oder deinstallieren Sie alle Software oder Browser-Plugins, die Sie nicht verwenden. Dies verringert Ihre Anfälligkeit. Bitte wählen Sie Ihr Passwort mit Bedacht aus, indem Sie beispielsweise Groß- und Kleinbuchstaben, eine oder mehrere Ziffern usw. hinzufügen. Möglicherweise erhalten Sie eine Benachrichtigung, wenn beispielsweise Ihr Passwort abgelaufen ist oder geändert werden sollte. RECHTE IN BEZUG AUF IHRE PERSÖNLICHEN DATEN INFORMATIONEN Abhängig von der Gerichtsbarkeit:Sie haben möglicherweise das Recht, auf bestimmte personenbezogene Daten und Informationen zuzugreifen, diese zu korrigieren, zu löschen oder deren Nutzung einzuschränken, die unter unsere Datenschutzrichtlinie fallen. Bei Fragen zu Ihren persönlichen Daten nehmen Sie bitte Kontakt mit uns auf. Wenn wir Ihre personenbezogenen Daten zur Erfüllung unserer gesetzlichen Verpflichtungen verarbeiten, werden wir dies in Übereinstimmung mit allen im geltenden Recht festgelegten Aufbewahrungsfristen tun. Obwohl wir angemessene Anstrengungen unternehmen, um solchen Anfragen nachzukommen, behalten wir uns das Recht vor, bestimmte Einschränkungen und Anforderungen für solche Anfragen aufzuerlegen, sofern dies zulässig oder erforderlich ist. Bitte beachten Sie, dass solche Anfragen einige Zeit in Anspruch nehmen können.",
        "GLOBALE ÜBERTRAGUNGEN (ÜBERTRAGUNG IHRER PERSÖNLICHEN DATEN IN ANDERE LÄNDER) Wie bei jeder multinationalen Organisation sind wir häufig verpflichtet, Daten international zu übertragen. Dementsprechend können Daten über Sie weltweit übertragen werden (wenn Ihre Daten innerhalb des Europäischen Wirtschaftsraums erfasst werden, bedeutet dies, dass Ihre Daten möglicherweise auch außerhalb dieses Raums übertragen werden). Wir können Ihre in unserer Datenschutzrichtlinie genannten personenbezogenen Daten und Informationen in und in verschiedene Länder übermitteln und verarbeiten, in denen möglicherweise ein anderes Datenschutzniveau herrscht als in Ihrem Land. Darüber hinaus können einige der in unserer Datenschutzrichtlinie erwähnten Nutzungen und/oder Offenlegungen die Übertragung und Verarbeitung Ihrer personenbezogenen Daten und Informationen in und in verschiedenen Ländern beinhalten, die möglicherweise ein anderes Datenschutzniveau als Ihr Land haben. Indem Sie unsere Websites, Mobilgeräte oder andere Websites besuchen und/oder unsere Dienste, Produkte, Software, mobilen Anwendungen oder andere nutzen, stimmen Sie einer solchen Übertragung und Verarbeitung zu, auch in die und in den Vereinigten Staaten oder einem anderen Land. Darüber hinaus erklären Sie sich durch den Zugriff auf unsere Websites, Mobilgeräte oder andere und/oder die Nutzung unserer Dienste, Produkte, Software, mobilen Anwendungen oder anderen damit einverstanden, dass der Schutz Ihrer personenbezogenen Daten und Informationen in dem Land erfolgt, in das diese personenbezogenen Daten und Informationen übermittelt wurden und in dem sie verarbeitet werden. Mit Ihrer Registrierung beim Unternehmen erklären Sie, dass Sie das gemäß der jeweiligen nationalen Rechtsordnung erforderliche Mindestalter erreicht haben. Darüber hinaus erklären Sie sich mit den Allgemeinen Vereinbarungen, Geschäftsbedingungen, die sich mit der Anmeldung, der Ein- und Auszahlung sowie weiteren Dienstleistungen in vollem Umfang befassen, einverstanden und akzeptieren diese. Ihre Vertragsformeln (Anmeldung, Ein- und Auszahlung sowie jede einzelne Leistung) werden vollständig vom Unternehmen oder von beauftragten Dritten gespeichert. Aus Sicherheitsgründen können bestimmte Auszüge dieser Daten in Ihrem persönlichen Konto eingesehen und geändert werden. Wenn Sie einige Ihrer persönlichen Daten, die Sie bei der Registrierung angegeben haben, ändern möchten, können Sie dies in den Einstellungen Ihres Kontos tun. In Ihrem Konto können Sie Ihr Passwort auch ändern, indem Sie auf „Passwort ändern“ klicken.",
        "LINKS ZU WEBSITES, SOFTWARE, MOBILEN ANWENDUNGEN UND ANDEREM VON DRITTANBIETERN Bitte beachten Sie, dass wir möglicherweise Links zu Websites, Software, mobilen Anwendungen oder anderem von Drittanbietern, einschließlich Websites sozialer Netzwerke, bereitstellen. Da wir keine Kontrolle über Websites, Softwareprogramme, mobile Anwendungen oder andere Drittparteien haben und nicht für Daten oder Informationen verantwortlich sind, die Sie auf solchen Websites, Websites, Softwareprogrammen, mobilen Anwendungen oder anderen Websites, Softwareprogrammen, mobilen Anwendungen usw. bereitstellen, empfehlen wir Ihnen, die Datenschutzrichtlinien auf diesen Websites, Websites, Softwareprogrammen, mobilen Anwendungen oder anderen Websites, Websites, Softwareprogrammen, mobilen Anwendungen usw. zu lesen, bevor Sie Ihre Daten und Informationen auf solchen Websites, Plattformen, Softwareprogrammen, mobilen Anwendungen oder anderen Websites, Plattformen, Softwareprogrammen, mobilen Anwendungen oder anderen Websites, Plattformen, Softwareprogrammen oder anderen bereitstellen. BILDRECHTE Wir können Fotos, Videos oder andere Informationen von verschiedenen Anbietern erwerben Quellen. KONTAKT GEMÄSS UNSERER DATENSCHUTZRICHTLINIE UND DEN ERWÄHNTEN OPT_OUT-FUNKTIONEN ODER ANDEREN Bitte wenden Sie sich an die folgende Adresse (unter „WEN SIE KONTAKTIEREN KÖNNEN“), falls Sie sich gemäß unserer Datenschutzrichtlinie abmelden möchten. Bitte beachten Sie, dass solche Anfragen einige Zeit in Anspruch nehmen können. WER SIE KONTAKTIEREN KÖNNEN: LPT ist in China unter der Firmennummer 91440400MACD90ME4A registriert. Wenn Sie Fragen haben oder eines Ihrer Rechte ausüben möchten, kontaktieren Sie uns bitte unter Customer Service. ÄNDERUNG UNSERER DATENSCHUTZRICHTLINIE Wir behalten uns das Recht vor, unsere Datenschutzrichtlinie jederzeit zu ändern, indem wir Überarbeitungen auf unserer Website und/oder unseren Plattformen veröffentlichen Software und/oder mobile Anwendungen oder andere von uns. Solche Änderungen werden mit der Veröffentlichung oder dem Hochladen wirksam. Wir empfehlen Ihnen, diese Datenschutzrichtlinie regelmäßig erneut durchzulesen. UNGÜLTIG ODER NICHT DURCHSETZBAR Wenn eine der Bestimmungen dieser Vereinbarung ungültig oder nicht durchsetzbar wird oder wird: Alle anderen Bestimmungen dieser Vereinbarung bleiben in vollem Umfang in Kraft und wirksam; undDie ungültige oder undurchführbare Bestimmung gilt automatisch als geändert und durch eine gültige oder durchsetzbare Bestimmung ersetzt, die dem Zweck und der Absicht der ungültigen und undurchführbaren Bestimmung wirtschaftlich am nächsten kommt.",
        "Die gleichen Regeln gelten für unbeabsichtigte Auslassungen (falls vorhanden). BENUTZERRICHTLINIEWir heißen Sie auf unserer Website, unseren Einrichtungen, Plattformen, Softwares, Anwendungen und anderen willkommen. LPT (im Folgenden „LPT“, „幸运丹鸟（珠海）科技有限公司“ genannt) und seine Tochtergesellschaften (zusammen „Wir“, „Unser“ oder „Uns“). Diese Benutzerrichtlinie gilt für diese Website, für jegliche Software oder Anwendungen von uns, jede Website von uns oder für uns auf Websites, Software und Anwendungen Dritter (online oder offline), gilt jedoch nicht für andere Produkte oder Dienstleistungen von uns, sofern wir nicht ausdrücklich etwas anderes angeben (z. B. durch Einfügen eines Links zu dieser Benutzerrichtlinie auf anderen Websites, Software von uns oder in mobilen Anwendungen von uns). NUTZUNG DER WEBSITE, SOFTWAREN, MOBILEN ANWENDUNGEN UND ANDEREN DIENSTLEISTUNGEN ODER PRODUKTE Die Nutzung unserer Websites, Software, mobilen Anwendungen oder anderer Dienste und Produkte von uns ist nur für persönliche, nichtkommerzielle und kommerzielle Zwecke gestattet. Jegliche andere Nutzung ist strengstens untersagt. Wenn Sie unsere Websites, Softwares, mobilen Anwendungen oder anderen Dienste und Produkte von uns betreten, darauf zugreifen, sich anmelden oder registrieren, erklären Sie sich damit einverstanden:  keine Informationen, Daten oder Materialien unserer Websites, Softwares, mobilen Anwendungen, Dienste oder Produkte von uns zu sammeln, zu kopieren, zu extrahieren und/oder auf anderen Websites, Softwares, mobilen Anwendungen (online oder offline) zu kopieren, zu kopieren, zu extrahieren und/oder zu reproduzieren (online oder offline), sei es unter Verwendung irgendeiner Methode;  unsere Websites, Softwares, mobilen Anwendungen und Dienste nicht zu nutzen oder Produkte, um Informationen oder Daten in Bezug auf uns, unsere verbundenen Unternehmen oder unsere Tochtergesellschaften an Dritte weiterzugeben, außer für Ihre eigenen persönlichen, nicht kommerziellen und kommerziellen Zwecke, wie in den Vereinbarungen und Verträgen mit LPT definiert;  unsere Namen, Marken oder Inhalte unserer Websites, Software, mobilen Anwendungen, Dienstleistungen oder Produkte nicht für andere Zwecke als Ihre eigenen persönlichen, nicht kommerziellen und kommerziellen Zwecke zu verwenden;  unsere Leistungen, Dienstleistungen, Produkte, Plattformen und unser Web nicht zu nutzen",
        "Websites, Software, Anwendungen oder anderes für Geldwäsche; um rechtlich an die Bedingungen unserer Benutzerrichtlinien, Anforderungen, Geschäftsbedingungen oder andere Richtlinien von uns gebunden zu sein. ÄNDERUNG UNSERER BENUTZERRICHTLINIEN Wir behalten uns das Recht vor, unsere Benutzerrichtlinien jederzeit zu ändern, indem wir Überarbeitungen auf unserer Website und/oder Plattformen und/oder Software und/oder mobilen Anwendungen oder anderen von uns veröffentlichen. Solche Änderungen werden mit der Veröffentlichung oder dem Hochladen wirksam. UNGÜLTIG ODER NICHT DURCHSETZBAR Wenn eine der Bestimmungen dieser Vereinbarung ungültig oder nicht durchsetzbar wird oder wird: Alle anderen Bestimmungen dieser Vereinbarung bleiben in vollem Umfang in Kraft und wirksam; undDie ungültige oder nicht durchsetzbare Bestimmung gilt als automatisch geändert und durch eine gültige oder durchsetzbare Bestimmung ersetzt, die den Zweck und die Absicht der ungültigen und nicht durchsetzbaren Bestimmung wirtschaftlich so weit wie möglich erfüllt. Die gleichen Regeln gelten für unbeabsichtigte Auslassungen (falls vorhanden). VERWENDUNG VON SOCIAL-MEDIA-PLUG-INS UND ANDEREN Auf unseren Plattformen, Einrichtungen, Websites, Softwareprogrammen, Anwendungen und anderen von uns finden Sie möglicherweise Links und/oder Data-Matrix-Codes und/oder jede andere Verbindung („Link“) zu den Social-Media-Diensten von YouTube, Myvideo, Facebook, Linkedin, Xing, Twitter, WeChat und anderen. Wenn Sie diesen Links folgen, gelangen Sie zu deren Plattformen, Einrichtungen, Diensten und anderen und/oder geben Ihnen die Möglichkeit, diese zu teilen, einschließlich, aber nicht beschränkt auf, eine Seite, ein Video, ein Bild und andere, wofür möglicherweise ein Konto beim Social-Media-Dienst erforderlich ist. Durch Anklicken des Links zu einem Social-Media-Dienst wird ggf. eine Verbindung zum Server oder anderen Servern des Social-Media-Dienstes hergestellt. Dadurch können die Informationen und/oder Daten, die Sie auf unserer Website, Plattform, Dienstleistung, Einrichtung, Software, Anwendungen oder anderen Seiten besucht haben, an den oder andere Server des Social-Media-Dienstes übertragen werden. Eventuell werden weitere Informationen an den Anbieter des Social-Media-Dienstes übermittelt. Dazu gehören unter anderem: Adresse der Website, auf der sich der aktivierte Link befindet, Datum und Uhrzeit des Zugriffs auf die Website oder der Aktivierung des Links",
        "Informationen über den verwendeten Browser und das verwendete Betriebssystem. IP-Adresse etc. Sofern Sie zum Zeitpunkt der Aktivierung des Links bereits bei dem jeweiligen Social-Media-Dienst eingeloggt sind, kann der Anbieter des Social-Media-Dienstes aus den übermittelten Daten ggf. Ihren Benutzernamen und ggf. Ihren echten Namen ermitteln und diese Informationen Ihrem persönlichen Benutzerkonto beim Social-Media-Dienst zuordnen. Dies können Sie durch vorheriges Ausloggen aus Ihrem Benutzerkonto ausschließen. Die Server der Social-Media-Dienste können sich in Europa und/oder in den USA und/oder anderen Ländern außerhalb der Europäischen Union befinden. Die Daten können daher durch den Anbieter des Social-Media-Dienstes auch in Ländern außerhalb der Europäischen Union verarbeitet werden. Bitte beachten Sie, dass Unternehmen in diesen Ländern einem Datenschutzgesetz unterliegen, das personenbezogene Daten grundsätzlich nicht in dem gleichen Umfang schützt wie in den Mitgliedstaaten der Europäischen Union. Weitere Informationen entnehmen Sie bitte der Datenschutzerklärung des jeweiligen Social-Media-Dienstes. Soweit gesetzlich zulässig, haften wir für solche Handlungen nicht. ÄNDERUNGEN AN UNSEREN SOCIAL-MEDIA-PLUG-INS UND ANDEREN Wir behalten uns das Recht vor, unsere Social-Media-Plug-ins und andere jederzeit zu ändern, indem wir Überarbeitungen auf unserer Website und/oder Plattformen und/oder Software und/oder mobilen Anwendungen oder anderen von uns veröffentlichen. Solche Änderungen werden mit der Veröffentlichung oder dem Hochladen wirksam. UNGÜLTIG ODER NICHT DURCHSETZBAR Wenn eine der Bestimmungen dieser Vereinbarung ungültig oder nicht durchsetzbar wird oder wird: Alle anderen Bestimmungen dieser Vereinbarung bleiben in vollem Umfang in Kraft und wirksam; undDie ungültige oder nicht durchsetzbare Bestimmung gilt automatisch als geändert und durch eine gültige oder durchsetzbare Bestimmung ersetzt, die den Zweck und die Absicht der ungültigen und nicht durchsetzbaren Bestimmung wirtschaftlich so weit wie möglich erfüllt. Die gleichen Regeln gelten für unbeabsichtigte Auslassungen (falls vorhanden)."
      ],
      privacyContent: "Dies ist die Datenschutzrichtlinie für die LPT-Auditplattform...",
      close: "Schließen"
    },
    payment: {
      innerSteps: {
        "0": "Methode auswählen",
        "1": "Zahlen",
        "2": "Bestätigung"
      },
      modes: {
        oneTime: {
          title: "Einmalzahlung",
          badge: "Einmal zahlen",
          desc: "Einmalig bezahlen und direkt abschließen."
        },
        subscription: {
          title: "Abo",
          badge: "Auto-Verlängerung",
          desc: "Wiederkehrende Abrechnung mit automatischer Verlängerung."
        }
      },
      selectMethod: "Wählen Sie Ihre Zahlungsmethode",
      oneTime: {
        desc: "Wählen Sie eine Methode für die Einmalzahlung."
      },
      amountToPay: "Zu zahlender Betrag",
      recommended: "Empfohlen",
      proceedToPay: "Fahren Sie mit der Zahlung fort",
      methodMeta: {
        processor: "Anbieter",
        flow: "Ablauf"
      },
      alipayProceed: "Zur Alipay-Zahlung",
      alipayRedirectTip: "Sie werden zu einer sicheren Zahlungsseite weitergeleitet (Alipay).",
      alipayMode: {
        title: "Alipay-Ablauf wählen",
        subtitle: "Per Login weiterleiten oder QR-Code scannen.",
        redirect: {
          title: "Login-Zahlung",
          desc: "Offizielle Alipay-Kasse öffnen und nach dem Login bezahlen.",
          tip: "Sie werden zur offiziellen Alipay-Kasse weitergeleitet, um die Zahlung abzuschließen.",
          action: "Weiter zu Alipay"
        },
        qr: {
          title: "QR-Code-Zahlung",
          desc: "Mit der Alipay-App scannen und bezahlen.",
          tip: "Öffnen Sie die Alipay-App und scannen Sie den QR-Code zur Zahlung.",
          generating: "Alipay-QR-Code wird generiert, bitte warten...",
          orderNo: "Bestell-Nr.",
          checkStatus: "Ich habe bezahlt",
          pending: "Zahlungserfolg wurde noch nicht erkannt. Bitte später erneut versuchen."
        }
      },
      scanQrCode: "Öffnen Sie Alipay und scannen Sie den QR-Code, um zu bezahlen",
      qrExpires: "Der QR-Code läuft in {seconds} Sekunden ab",
      qrExpired: "QR-Code abgelaufen. Bitte versuchen Sie es erneut.",
      simulatePay: "Zahlungserfolg simulieren",
      verifying: "Zahlung wird überprüft...",
      changeMethod: "Methode ändern",
      processing: "Zahlung wird bearbeitet...",
      payNow: "Jetzt zahlen {amount}",
      initError: "Zahlung konnte nicht initialisiert werden. Bitte erneut versuchen.",
      formLoadError: "Zahlungsformular konnte nicht geladen werden. Bitte erneut versuchen.",
      cardFailed: "Zahlung fehlgeschlagen. Bitte prüfen Sie Ihre Kartendaten.",
      fillAllFields: "Bitte geben Sie alle Kartendetails ein",
      securityNote: "Ihre Zahlungsinformationen werden verschlüsselt. Wir speichern Ihre Kartendaten nicht.",
      subscription: {
        title: "Abo-Checkout",
        desc: "Ihr Plan verlängert sich automatisch im gewählten Intervall.",
        amountLabel: "Wiederkehrender Betrag",
        start: "Abo starten",
        checkoutMethod: "Stripe Checkout",
        cardTitle: "Abo-Details",
        interval: "Abrechnungszeitraum",
        monthly: "Monatlich",
        yearly: "Jährlich",
        renewal: "Verlängerung",
        autoRenew: "Automatische Verlängerung aktiv",
        paymentMethod: "Zahlungsmethode",
        cardOnly: "Karte über Stripe Checkout",
        checkoutError: "Das Abo konnte nicht gestartet werden. Bitte erneut versuchen."
      },
      wechat: {
        scanQrCode: "Öffnen Sie WeChat und scannen Sie den QR-Code, um zu bezahlen",
        generating: "QR-Code wird generiert, bitte warten..."
      },
      methods: {
        card: {
          name: "Kartenzahlung",
          shortName: "KARTE",
          desc: "Sicher mit Visa, Mastercard oder einer anderen unterstützten Karte bezahlen.",
          badge: "Visa / Mastercard",
          processor: "Sicheres Gateway",
          flow: "Eingebettetes Sicherheitsformular"
        },
        stripe: {
          name: "Stripe"
        },
        alipay: {
          name: "Alipay Direkt",
          desc: "Direkt über Alipay bezahlen und auf der offiziellen Alipay-Checkout-Seite abschließen.",
          badge: "Direktkanal",
          processor: "Alipay",
          flow: "Weiterleitung zu Alipay"
        },
        visa: {
          name: "Visum",
          desc: "Bezahlen Sie mit Visa-Kredit- oder Debitkarte"
        },
        mastercard: {
          name: "MasterCard",
          desc: "Bezahlen Sie mit Mastercard-Kredit- oder Debitkarte"
        },
        wechat: {
          name: "WeChat Pay",
          desc: "Bezahlen Sie mit WeChat Pay, indem Sie einen QR-Code scannen"
        }
      },
      cardForm: {
        kicker: "Sicherer Checkout",
        title: "Kartenzahlung",
        acceptedCards: "Akzeptierte Karten",
        moreCards: "Karten",
        cardDetails: "Kartendetails",
        helper: "Geben Sie Ihre Kartendaten im sicheren verschlüsselten Formular ein.",
        number: "Kartennummer",
        numberPlaceholder: "0000 0000 0000 0000",
        holderName: "Name des Karteninhabers",
        holderNamePlaceholder: "Name auf der Karte",
        expiry: "Verfallsdatum",
        expiryPlaceholder: "MM/JJ",
        cvv: "Sicherheitscode",
        cvvPlaceholder: "•••"
      },
      result: {
        oneTimeSuccessTitle: "Zahlung erfolgreich!",
        oneTimeSuccessDesc: "Ihre Einmalzahlung ist abgeschlossen. Willkommen auf der LPT-Plattform!",
        subscriptionSuccessTitle: "Abo aktiv!",
        subscriptionSuccessDesc: "Ihr Abo ist aktiv und wird automatisch verlängert.",
        failedTitle: "Die Zahlung ist fehlgeschlagen",
        failedDesc: "Bei der Verarbeitung Ihrer Zahlung ist ein Problem aufgetreten. Bitte versuchen Sie es erneut oder verwenden Sie eine andere Methode.",
        orderId: "Bestell-ID",
        amount: "Gezahlter Betrag",
        method: "Zahlungsart",
        time: "Zahlungszeitpunkt",
        downloadShortcut: "LPT-Auditplattform herunterladen",
        shortcutFileName: "LPT-Audit-Plattform",
        viewInvoice: "Rechnung ansehen",
        shortcutDownloaded: "Verknüpfung zur LPT Audit Platform heruntergeladen",
        goToDashboard: "Gehen Sie zum Dashboard",
        retry: "Versuchen Sie es erneut"
      }
    },
    invoice: {
      paymentQr: {
        title: 'Angaben zum Zahlungs-QR-Code',
        alt: 'Zahlungs-QR-Code der MT-Rechnung'
      },
      exportPdf: "PDF exportieren",
      exportingPdf: "Exportieren...",
      exportXml: "XML exportieren",
      exportingXml: "XML wird exportiert...",
      uploadedTitle: "Hochgeladene Rechnung",
      openUploadedInvoice: "Rechnung öffnen",
      downloadUploadedImage: "Rechnungsbild herunterladen",
      downloadUploadedImageFailed: "Das Rechnungsbild konnte nicht heruntergeladen werden.",
      languagesLine: "Sprachen: {languages}",
      tax: "Steuer",
      taxWithRate: "Steuer ({rate})",
      seeInvoice: "siehe Rechnung",
      labels: {
        documentTitle: "RECHNUNG/DEBITORNENNOTIZ", issueDate: "Ausstellungsdatum", clientNo: "Kundennr.", organization: "Organisation", address: "Adresse", name: "Name", email: "E-Mail", phone: "Telefon", taxId: "Steuer-ID", registrationNo: "Registernr.", matter: "Betreff", period: "Zeitraum", currency: "Währung", amount: "Betrag", subtotal: "Zwischensumme", discount: "Rabatt", billingAmount: "Rechnungsbetrag", customerService: "Kundenservice", customerServiceText: "Bitte kontaktieren Sie uns jederzeit über Ihr Konto unter Kundenservice.", paymentInstructions: "Zahlungsanweisungen", paymentText: "Ihr Bankkonto wird innerhalb der nächsten Tage mit dem Rechnungsbetrag belastet. Bitte beachten Sie, dass unsere Belastung netto ohne Überweisungs- oder sonstige Bankgebühren erfolgt. Unsere Allgemeinen Geschäftsbedingungen gelten.", paymentNote: "Die Rechnung ist für einen bestimmten Zeitraum in Ihrer Zahlungshistorie unserer Software verfügbar.", bankInformation: "Unsere Bankverbindung"
      },
      xmlExportSuccess: "XML-Rechnung wurde exportiert.",
      xmlExportFailed: "XML-Rechnung konnte nicht exportiert werden.",
      xmlExportMissingFields: "XML kann nicht exportiert werden. Pflichtfelder fehlen: {fields}.",
      xmlFields: {
        invoiceNumber: "Rechnungsnummer",
        issueDate: "Ausstellungsdatum",
        currency: "Währung",
        supplierName: "Name des Lieferanten",
        customerOrganization: "Kundenorganisation",
        customerAddress: "Kundenadresse",
        invoiceItems: "Rechnungspositionen",
        totalAmount: "Gesamtbetrag"
      }
    },
    errors: {
      loadPurchaseConfig: "Kaufkonfiguration konnte nicht geladen werden. Bitte später erneut versuchen.",
      createOrder: "Bestellung konnte nicht erstellt werden. Bitte prüfen Sie Ihren Anmeldestatus."
    }
  },
  login: {
    backButtonTitle: "Zurück",
    title: "Anmelden",
    subtitle: "Geben Sie Ihre Zugangsdaten ein, um auf Ihr Konto zuzugreifen",
    emailLabel: "E-Mail-Adresse",
    emailPlaceholder: "E-Mail-Adresse eingeben",
    passwordLabel: "Passwort",
    passwordPlaceholder: "Passwort eingeben",
    rememberMe: "Angemeldet bleiben",
    close: "Schließen",
    forgotPassword: "Passwort vergessen?",
    loginButton: "Jetzt anmelden",
    registerPrompt: "Noch kein Konto?",
    registerLink: "Konto erstellen",
    loginSuccess: "Anmeldung erfolgreich",
    loginFailed: "Anmeldung fehlgeschlagen",
    incorrectCredentials: "Falsche E-Mail oder Passwort",
    userNotFound: "Benutzer nicht gefunden",
    formInvalid: "Bitte füllen Sie die Felder korrekt aus",
    validation: {
      emailRequired: "Bitte E-Mail-Adresse eingeben",
      emailInvalid: "Bitte gültige E-Mail-Adresse eingeben",
      passwordRequired: "Bitte Passwort eingeben"
    },
    viewTerms: "Nutzungsbedingungen",
    viewPrivacy: "Datenschutzrichtlinie",
    agreePrefix: "Ich habe die",
    agreeAnd: "und",
    termsOfService: "Nutzungsbedingungen",
    privacyPolicy: "Datenschutzrichtlinie",
    termsClose: "Schließen",
    privacyContent: "Inhalt der Datenschutzrichtlinie.",
    termsContent: [
      "Lucky Phoenix (Zhuhai) Technology Co., Ltd. – Vereinbarungen und Allgemeine Geschäftsbedingungen",
      "Diese Vereinbarungen und Allgemeinen Geschäftsbedingungen, einschließlich der Vereinbarung zur Datenverarbeitung und Datensicherheit, sämtlicher Nachträge, der Service-Level-Vereinbarung und der Richtlinie zur zulässigen Nutzung von LPT Audit in ihrer jeweils gültigen Fassung, bilden einen rechtsverbindlichen Vertrag zwischen Ihnen als Lizenznehmer und Lucky Phoenix (Zhuhai) Technology Co., Ltd., einem Unternehmen der Volksrepublik China (\"LPT\", \"wir\", \"uns\"), über die Nutzung der lizenzierten Materialien. Vor dem Zugriff auf die lizenzierten Materialien müssen Sie die Bedingungen prüfen und ihnen zustimmen. Eine Nutzung unter Verstoß gegen die Vereinbarung oder die Richtlinien ist untersagt. Jede als Lizenznehmer, Kunde, Prüfer oder Prüferkunde bezeichnete Person oder Organisation unterliegt den jeweils anwendbaren Bestimmungen dieser Vereinbarung. Diese Vereinbarung gilt auch für zusätzliche Materialien, Services oder Funktionen, die wir Ihnen von Zeit zu Zeit bereitstellen.\n\nIndem Sie zustimmen und/oder die lizenzierten Materialien nutzen, bestätigen Sie Ihr Einverständnis mit dieser Vereinbarung.\nWenn Sie nicht zustimmen, dürfen Sie die lizenzierten Materialien nicht nutzen und müssen die LPT-Audit-Plattform unverzüglich verlassen.",
      "Begriffsbestimmungen\n\n\"Vereinbarung\" oder \"Vereinbarungen\" bezeichnet diese Vereinbarung und ihre Bedingungen einschließlich sämtlicher Allgemeiner Geschäftsbedingungen, Nachträge, der Service-Level-Vereinbarung, der Datenverarbeitungsvereinbarung, der einbezogenen Richtlinien sowie aller Anlagen und Anhänge in ihrer jeweils geänderten Fassung.\n\"Richtlinie zur zulässigen Nutzung\" bezeichnet die auf der LPT-Website verfügbare und durch Verweis einbezogene Richtlinie.\n\"Verbundenes Unternehmen\" bezeichnet eine Organisation, die eine Partei kontrolliert, von ihr kontrolliert wird oder mit ihr unter gemeinsamer Kontrolle steht.\n\"Autorisierte Benutzer\" sind Mitarbeiter oder unabhängige Auftragnehmer des Lizenznehmers, die nach Maßgabe dieser Vereinbarung zum Zugriff berechtigt wurden.\n\"Inhalte\" umfasst sämtliche über die lizenzierten Materialien verfügbaren Texte, Daten, Darstellungen, Bilder, Marken, Handelsnamen und Logos.\n\"Kunde\" bezeichnet eine Person oder Organisation, die LPT Audit oder einen Prüfer mit einer Prüfung beauftragt hat.\n\"Nachtrag\" bezeichnet eine Vereinbarung über die Nutzung der lizenzierten Materialien für einen Prüfstandard und/oder eine Vorlage, die LPT Audit aktualisieren oder ergänzen kann.\n\"Prüfer\" bezeichnet eine Person oder Organisation, die Prüfungen für einen Kunden durchführt.\n\"Prüferkunde\" bezeichnet eine Person oder Organisation, die einen Prüfer beauftragt hat.\n\"Prüfstandard\" bezeichnet einen in einem einschlägigen Nachtrag festgelegten Prüfstandard.\n\"Autorisierter Zweck\" bezeichnet ausschließlich die Durchführung einer Prüfung oder damit verbundener Tätigkeiten.\n\"Autorisierte Person\" bezeichnet eine zum Zugriff berechtigte Person.\n\"Datenverarbeitungs- und Sicherheitsvereinbarung\" oder \"DPA\" bezeichnet die auf der LPT-Website verfügbare Vereinbarung zur Verarbeitung personenbezogener Daten.\n\"Lizenznehmer\" bezeichnet die Person oder Organisation, der eine Nutzungslizenz erteilt wurde.\n\"Lizenzierte Materialien\" umfasst Audit-Software, Berichtsvorlagen, Nachträge und sonstige bereitgestellte Materialien.\n\"Richtlinien\" bezeichnet die auf der LPT-Website verfügbaren Richtlinien.\n\"Berichtsvorlage\" oder \"Vorlage\" bezeichnet eine Berichtsvorlage.\n\"Service-Level-Vereinbarung\" oder \"SLA\" bezeichnet die Vereinbarung über die Verfügbarkeit der lizenzierten Materialien als Service.\n\"Benutzerhandbuch\" bezeichnet die auf der LPT-Website verfügbaren Nutzungsanweisungen.\n\"Version\" bezeichnet eine Versionsnummer der lizenzierten Materialien.",
      "Bedingungen und Beschränkungen\n\nDie Nutzung der lizenzierten Materialien unterliegt der Vereinbarung.\nWir können die Lizenz jederzeit aussetzen oder beenden, wenn wir nach eigenem Ermessen feststellen, dass der Lizenznehmer gegen diese Vereinbarung verstoßen hat.\nDer Lizenznehmer muss sicherstellen, dass jeder Prüferkunde vor der Nutzung der lizenzierten Materialien den LPT-Audit-Nutzungsbedingungen für Kunden zustimmt.",
      "Datenschutzerklärung\n\nLPT erhebt und verarbeitet personenbezogene Daten gemäß der Datenschutzerklärung.\nAlle Daten werden im Einklang mit den anwendbaren Datenschutzvorschriften verarbeitet.",
      "Lizenzerteilung\n\nVorbehaltlich dieser Vereinbarung gewährt LPT dem Lizenznehmer für den autorisierten Zweck und während der Lizenzlaufzeit eine nicht ausschließliche, nicht übertragbare, weltweite und widerrufliche Lizenz zur Nutzung der lizenzierten Materialien.\nWeitere Rechte werden durch diese Vereinbarung nicht eingeräumt.",
      "Eigentum und geistiges Eigentum\n\nDie lizenzierten Materialien stehen im Eigentum von LPT oder seinen Lizenzgebern.\nSämtliche Rechte an geistigem Eigentum verbleiben ausschließlich bei LPT und seinen Lizenzgebern.",
      "Gebühren und Zahlung\n\nDie Gebühren für die Nutzung der lizenzierten Materialien ergeben sich aus dem jeweiligen Nachtrag oder der Preisliste.\nSofern nicht anders angegeben, sind alle Gebühren nicht erstattungsfähig."
    ]
  },
  resetPassword: {
    backButtonTitle: "Zurück",
    title: "Passwort zurücksetzen",
    subtitle: "Geben Sie E-Mail, Bestätigungscode und neues Passwort ein.",
    emailLabel: "E-Mail-Adresse",
    emailPlaceholder: "E-Mail-Adresse eingeben",
    verificationCodeLabel: "Bestätigungscode",
    verificationCodePlaceholder: "Code eingeben",
    newPasswordLabel: "Neues Passwort",
    newPasswordPlaceholder: "Neues Passwort eingeben",
    confirmPasswordLabel: "Passwort bestätigen",
    confirmPasswordPlaceholder: "Neues Passwort erneut eingeben",
    sendCodeButton: "Code senden",
    codeCountdown: "{seconds}s",
    submitButton: "Passwort zurücksetzen",
    loginPrompt: "Passwort wieder eingefallen?",
    loginLink: "Anmelden",
    codeSent: "Bestätigungscode wurde gesendet",
    codeSendFailed: "Bestätigungscode konnte nicht gesendet werden",
    resetSuccess: "Passwort erfolgreich zurückgesetzt",
    resetFailed: "Passwort konnte nicht zurückgesetzt werden",
    formInvalid: "Bitte füllen Sie die Felder korrekt aus",
    validation: {
      emailRequired: "Bitte E-Mail-Adresse eingeben",
      emailInvalid: "Bitte gültige E-Mail-Adresse eingeben",
      codeRequired: "Bitte Bestätigungscode eingeben",
      passwordRequired: "Bitte neues Passwort eingeben",
      passwordMin: "Das Passwort muss mindestens 8 Zeichen lang sein",
      confirmPasswordRequired: "Bitte neues Passwort bestätigen",
      passwordMismatch: "Die Passwörter stimmen nicht überein"
    }
  },
  register: {
    title: 'Konto erstellen',
    subtitle: 'Füllen Sie die folgenden Informationen aus, um zu beginnen.',
    backButtonTitle: 'Zurück',
    orgInfoSection: 'Organisationsinformationen',
    addressSection: 'Adresse & Kontakt',
    adminSection: 'Administrator-Informationen',
    nameLabel: 'Organisationsname',
    namePlaceholder: 'Organisationsname eingeben',
    legalNameLabel: 'Rechtlicher Name',
    legalNamePlaceholder: 'Rechtlichen Namen eingeben',
    industryLabel: 'Branche',
    industryPlaceholder: 'Branche auswählen (mehrere)',
    regTypeLabel: 'Registrierungsart',
    regTypePlaceholder: 'Art auswählen',
    regNumLabel: 'Registrierungsnummer',
    regNumPlaceholder: 'Registrierungsnummer eingeben',
    regNumTooltip: 'Die offizielle Registrierungsnummer Ihrer lokalen Behörde.',
    taxIdLabel: 'Steueridentifikationsnummer',
    taxIdPlaceholder: 'Steuer-ID eingeben',
    legalRepLastNameLabel: 'Nachname des gesetzlichen Vertreters',
    legalRepLastNamePlaceholder: 'Nachname eingeben',
    legalRepFirstNameLabel: 'Vorname des gesetzlichen Vertreters',
    legalRepFirstNamePlaceholder: 'Vorname eingeben',
    addressLine1Label: 'Adresszeile 1',
    addressLine1Placeholder: 'Straße eingeben',
    addressLine2Label: 'Adresszeile 2',
    addressLine2Placeholder: 'Wohnung, Suite usw. (optional)',
    countryLabel: 'Land/Region',
    countryPlaceholder: 'Land/Region auswählen',
    stateLabel: 'Bundesland/Provinz',
    statePlaceholder: 'Bundesland/Provinz eingeben',
    cityLabel: 'Stadt',
    cityPlaceholder: 'Stadt eingeben',
    postalCodeLabel: 'Postleitzahl',
    postalCodePlaceholder: 'Postleitzahl eingeben',
    contactEmailLabel: 'Kontakt-E-Mail',
    contactEmailPlaceholder: 'Kontakt-E-Mail eingeben',
    phoneLabel: 'Telefonnummer',
    phonePlaceholder: 'Telefonnummer eingeben',
    lastNameLabel: 'Nachname',
    lastNamePlaceholder: 'Nachname eingeben',
    firstNameLabel: 'Vorname',
    firstNamePlaceholder: 'Vorname eingeben',
    adminEmailLabel: 'Admin-E-Mail',
    adminEmailPlaceholder: 'Admin-E-Mail eingeben',
    verificationCodeLabel: 'E-Mail-Bestätigungscode',
    verificationCodePlaceholder: '6-stelligen Code eingeben',
    sendCodeButton: 'Code senden',
    codeCountdown: '{seconds}s',
    codeSent: 'Der Bestätigungscode wurde an die Admin-E-Mail gesendet',
    codeSendFailed: 'Bestätigungscode konnte nicht gesendet werden',
    adminPhoneLabel: 'Admin-Telefon',
    adminPhonePlaceholder: 'Admin-Telefonnummer eingeben',
    passwordLabel: 'Passwort',
    passwordPlaceholder: 'Passwort eingeben',
    confirmPasswordLabel: 'Passwort bestätigen',
    confirmPasswordPlaceholder: 'Passwort bestätigen',
    adminAddressLine1Label: 'Admin-Adresszeile 1',
    adminAddressLine1Placeholder: 'Admin-Straße eingeben',
    adminAddressLine2Label: 'Admin-Adresszeile 2',
    adminAddressLine2Placeholder: 'Admin-Wohnung, Suite usw. (optional)',
    adminCountryLabel: 'Admin Land/Region',
    adminCountryPlaceholder: 'Land/Region auswählen',
    adminStateLabel: 'Admin Bundesland/Provinz',
    adminStatePlaceholder: 'Admin Bundesland/Provinz eingeben',
    adminCityLabel: 'Admin Stadt',
    adminCityPlaceholder: 'Admin Stadt eingeben',
    adminPostalCodeLabel: 'Admin Postleitzahl',
    adminPostalCodePlaceholder: 'Admin Postleitzahl eingeben',
    agreementCheckbox: 'Ich habe die ',
    agreementLink: 'Nutzungsbedingungen gelesen und akzeptiere sie',
    submitButton: 'Einreichen',
    resetButton: 'Zurücksetzen',
    termsOfService: 'Nutzungsbedingungen',
    privacyPolicy: 'Datenschutzrichtlinie',
    viewTerms: 'Nutzungsbedingungen',
    viewPrivacy: 'Datenschutzrichtlinie',
    termsClose: 'Schließen',
    termsCloseButton: 'Schließen',
    termsAgreeButton: 'Zustimmen',
    termsContent: [
      'Glücklicher Vogel (Zhuhai) Technologie GmbH Vereinbarungen, Bedingungen und Konditionen',
      'Lizenzlaufzeit\n\nDie Lizenz beginnt am Wirksamkeitsdatum (12 Monate ab Zahlungsdatum). Ausgenommen ist die LPT Audit Enterprise-Abonnementlizenz, die nach Abschluss der Implementierungsphase der LPT Audit Enterprise-Lösung beginnt.\nJede Lizenz kann um weitere 12 Monate verlängert werden. Ausgenommen sind die nicht verlängerbare LPT Audit Enterprise-Lizenz und die LPT Audit Lite-Lizenz, deren Laufzeit nur nach alleinigem Ermessen von LPT verlängert werden kann.',
      'Bedingungen und Beschränkungen\n\nDie Nutzung der lizenzierten Materialien unterliegt der Vereinbarung.\nWir können die Lizenz jederzeit aussetzen oder beenden, wenn wir nach eigenem Ermessen feststellen, dass der Lizenznehmer gegen diese Vereinbarung verstoßen hat.\nDer Lizenznehmer muss sicherstellen, dass jeder Prüferkunde vor der Nutzung der lizenzierten Materialien den LPT-Audit-Nutzungsbedingungen für Kunden zustimmt.',
      'Datenschutzerklärung\n\nLPT erhebt und verarbeitet personenbezogene Daten gemäß der Datenschutzerklärung.\nAlle Daten werden im Einklang mit den anwendbaren Datenschutzvorschriften verarbeitet.'
    ],
    privacyContent: 'Dies ist die Datenschutzrichtlinie der LPT-Prüfplattform. Alle personenbezogenen Daten werden gemäß den geltenden Datenschutzbestimmungen verarbeitet. Für weitere Details kontaktieren Sie bitte unser Support-Team.',
    accountCreateSuccess: 'Konto erfolgreich erstellt',
    accountCreateFail: 'Kontoerstellung fehlgeschlagen',
    formError: 'Bitte füllen Sie alle erforderlichen Felder korrekt aus',
    validation: {
      confirmPasswordMismatch: 'Passwörter stimmen nicht überein',
      passwordRequired: 'Bitte Passwort eingeben',
      passwordInvalid: 'Passwort muss mindestens 8 Zeichen haben, einschließlich eines Großbuchstabens, eines Kleinbuchstabens und einer Zahl',
      orgNameRequired: 'Bitte Organisationsnamen eingeben',
      legalNameRequired: 'Bitte rechtlichen Namen eingeben',
      contactEmailRequired: 'Bitte Kontakt-E-Mail eingeben',
      emailInvalid: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
      phoneRequired: 'Bitte Telefonnummer eingeben',
      regTypeRequired: 'Bitte Registrierungsart auswählen',
      regNumRequired: 'Bitte Registrierungsnummer eingeben',
      taxIdRequired: 'Bitte Steueridentifikationsnummer eingeben',
      legalRepLastNameRequired: 'Bitte Nachnamen des gesetzlichen Vertreters eingeben',
      legalRepFirstNameRequired: 'Bitte Vornamen des gesetzlichen Vertreters eingeben',
      addressRequired: 'Bitte Adresse eingeben',
      stateRequired: 'Bitte Bundesland oder Provinz eingeben',
      cityRequired: 'Bitte Stadt eingeben',
      postalCodeRequired: 'Bitte Postleitzahl eingeben',
      countryRequired: 'Bitte Land/Region auswählen',
      adminEmailRequired: 'Bitte Admin-E-Mail eingeben',
      verificationCodeRequired: 'Bitte Bestätigungscode eingeben',
      verificationCodeInvalid: 'Der Bestätigungscode muss aus 6 Ziffern bestehen',
      firstNameRequired: 'Bitte Vornamen eingeben',
      lastNameRequired: 'Bitte Nachnamen eingeben',
      agreementRequired: 'Sie müssen den Nutzungsbedingungen zustimmen'
    },
    industryOptions: {
      platforms: 'Plattformen',
      advertising: 'Werbung',
      energy: 'Energie',
      data_and_analytics: 'Daten & Analytik',
      messaging_and_telecommunications: 'Nachrichten & Telekommunikation',
      lending_and_investments: 'Kredite & Investitionen',
      real_estate: 'Immobilien',
      consumer_electronics: 'Unterhaltungselektronik',
      administrative_services: 'Administrative Dienste',
      health_care: 'Gesundheitswesen',
      agriculture_and_farming: 'Landwirtschaft',
      community_and_lifestyle: 'Gemeinschaft & Lebensstil',
      social_impact: 'Soziale Auswirkungen',
      events: 'Veranstaltungen',
      clothing_and_apparel: 'Kleidung & Mode',
      video: 'Video',
      internet_services: 'Internetdienste',
      travel_and_tourism: 'Reisen & Tourismus',
      information_technology: 'Informationstechnologie',
      content_and_publishing: 'Inhalte & Publishing',
      mobile: 'Mobil',
      government_and_military: 'Regierung & Militär',
      artificial_intelligence: 'Künstliche Intelligenz',
      blockchain_and_cryptocurrency: 'Blockchain & Kryptowährung',
      sustainability: 'Nachhaltigkeit',
      hardware: 'Hardware',
      sales_and_marketing: 'Vertrieb & Marketing',
      transportation: 'Transport',
      payments: 'Zahlungen',
      gaming: 'Gaming',
      science_and_engineering: 'Wissenschaft & Ingenieurwesen',
      apps: 'Apps',
      biotechnology: 'Biotechnologie',
      professional_services: 'Professionelle Dienste',
      navigation_and_mapping: 'Navigation & Kartierung',
      design: 'Design',
      sports: 'Sport',
      education: 'Bildung',
      natural_resources: 'Natürliche Ressourcen',
      commerce_and_shopping: 'Handel & Einkauf',
      manufacturing: 'Herstellung',
      media_and_entertainment: 'Medien & Unterhaltung',
      software: 'Software',
      consumer_goods: 'Konsumgüter',
      other: 'Sonstiges',
      music_and_audio: 'Musik & Audio',
      privacy_and_security: 'Datenschutz & Sicherheit',
      financial_services: 'Finanzdienstleistungen',
      food_and_beverage: 'Lebensmittel & Getränke'
    },
    registrationTypeOptions: {
      china_business_license: 'Chinesisches Geschäftslizenz',
      germany_handelsregister: 'Deutschland Handelsregisterauszug',
      other: 'Sonstiges'
    },
    registrationTypesLoading: 'Wird geladen…',
    registrationTypesEmpty: 'Keine Registrierungstypen verfügbar',
    registrationNumberExample: 'Beispiel'
  },
  faq: {
    hero: {
      badge: "Hilfecenter",
      title: "Häufig gestellte Fragen",
      subtitle: "Alles, was Sie über die LPT-Audit-Plattform wissen müssen. Nachfolgend finden Sie Antworten auf häufig gestellte Fragen.",
      searchPlaceholder: "Suchfragen..."
    },
    quickTags: {
      pricing: "Preise",
      security: "Datensicherheit",
      iso: "ISO-Standards",
      trial: "Kostenlose Testversion"
    },
    categories: {
      all: "Alle Fragen",
      general: "Allgemeine Informationen",
      pricing: "Preise und Pläne",
      features: "Merkmale und Fähigkeiten",
      security: "Sicherheit und Compliance",
      account: "Konto und Benutzer",
      technical: "Technische Unterstützung"
    },
    searchResults: "Es wurden {count} Ergebnisse für „{query}“ gefunden.",
    clearSearch: "Suche löschen",
    helpful: "War das hilfreich?",
    yes: "Ja",
    no: "NEIN",
    thanksFeedback: "Vielen Dank für Ihr Feedback!",
    noResults: "Keine passenden Fragen gefunden",
    noResultsDesc: "Bitte passen Sie Ihre Suchbegriffe an oder durchsuchen Sie alle Kategorien.",
    showAll: "Alle Fragen anzeigen",
    cta: {
      title: "Sie haben noch Fragen?",
      subtitle: "Unsere Audit-Experten sind bereit, die richtige Lösung für Ihr Unternehmen zu finden.",
      contactSupport: "Kontaktieren Sie den Support",
      bookDemo: "Buchen Sie eine Demo"
    },
    items: {
      whatIsLpt: {
        q: "Was ist die LPT-Softwareplattform?",
        a: "Die LPT-Softwareplattform ist eine umfassende, cloudbasierte Audit-Management- und Managementsystemlösung, die für professionelle Prüfer und Organisationen entwickelt wurde. Es unterstützt mehrere internationale Standards, darunter ISO 9001, ISO 14001, ISO 27001, IATF 16949, VDA 6.3 und mehr, und bietet ein durchgängiges Audit-Workflow-Management von der Planung bis zur Berichterstattung."
      },
      auditStandards: {
        q: "Welche Auditstandards werden unterstützt?",
        a: "Wir unterstützen eine Vielzahl internationaler Standards, darunter ISO 9001, IATF 16949, VDA 6.3, ISO 14001, ISO 45001, TISAX und ISO 27001. Sie können auch benutzerdefinierte Audit-Vorlagen mit unserem Template Creator-Tool erstellen."
      },
      getStarted: {
        q: "Wie starte ich mit unseren Softwarelösungen?",
        a: "Der Einstieg ist einfach: 1) Registrieren Sie Ihr Organisationskonto, 2) Wählen Sie ein Abonnement, 3) Wählen Sie Ihre Prüfungsstandards, 4) Laden Sie Ihre Prüfer ein. Sie können in wenigen Minuten einsatzbereit sein."
      },
      pricingPlans: {
        q: "Welche Preispläne sind verfügbar?",
        a: "Wir bieten mehrere Optionen an, mit denen Sie ebenfalls viel sparen können. Weitere Einzelheiten finden Sie in unseren Produkten."
      },
      cancelSubscription: {
        q: "Kann ich mein Abonnement kündigen oder ändern?",
        a: "Ja, Sie können Ihr Abonnement in Ihren Kontoeinstellungen ändern oder kündigen."
      },
      paymentMethods: {
        q: "Welche Zahlungsmethoden werden akzeptiert?",
        a: "Wir akzeptieren Visa, Mastercard, Wechat und Alipay und andere, je nachdem, in welchem ​​Land Sie sich befinden. Alle Zahlungen werden über unser sicheres, PCI DSS-konformes Zahlungsgateway abgewickelt."
      },
      customTemplates: {
        q: "Kann ich benutzerdefinierte Audit-Vorlagen erstellen?",
        a: "Ja, es gibt zwei Möglichkeiten, eigene Audit-Vorlagen zu erstellen. Eine unserer Softwarelösungen umfasst ein leistungsstarkes Tool zur Vorlagenerstellung zum Erstellen maßgeschneiderter Checklisten und Bewertungskriterien. Eine andere Möglichkeit besteht darin, uns zu kontaktieren, falls Sie bestimmte Vorlagen haben und diese nicht in unserem Portfolio finden."
      },
      supplierPortalWork: {
        q: "Wie funktioniert das Lieferantenportal?",
        a: "Das Lieferantenportal bietet Ihren Lieferanten unbegrenzten kostenlosen Zugang, um auf Audits zu reagieren, Nachweise hochzuladen und das Maßnahmenmanagement nach Bedarf und Definition durch den Auditor zu verwalten."
      },
      shareAuditsInternal: {
        q: "Kann ich meine Audits innerhalb der Organisation teilen?",
        a: "Ja, der Prüfer kann interne Benutzer zum internen Pool hinzufügen und ihnen kostenlosen Zugriff auf die Softwareplattform gewähren."
      },
      accessCost: {
        q: "Kostet der Zugang für Lieferanten, interne Benutzer, Kunden und andere Geld?",
        a: "Nein, diese Zugriffe sind in allen unseren Audit-Softwarelösungen enthalten."
      },
      shareAuditsExternal: {
        q: "Kann ich meine Audits mit der Zertifizierungsstelle oder einem Kunden teilen?",
        a: "Ja, Sie können sie teilen und der Zugang zu ihnen ist kostenlos. Sie können für sie ein Konto erstellen und sie erhalten Zugriff auf die von Ihnen freigegebenen Audits."
      },
      offlineMode: {
        q: "Kann ich meine Audit-Software offline nutzen?",
        a: "Ja, unsere Audit-Softwarelösungen verfügen über einen Offline-Modus."
      },
      exportAudits: {
        q: "Kann ich meine Audits exportieren?",
        a: "Sie können Ihre Audits kostenlos mit allen teilen. Sie haben über das Portal Zugriff und Zugriff auf die vom Prüfer freigegebenen Audits."
      },
      removeAccess: {
        q: "Wie kann ich den Zugriff oder eine Prüfung entfernen, nachdem ich sie freigegeben habe?",
        a: "Sie können als Auditor jederzeit die Freigabe von Audits aufheben und Zugriffe löschen."
      },
      dataSecurity: {
        q: "Wie werden meine Daten gesichert?",
        a: "Alle Daten werden im Ruhezustand (AES-256) und während der Übertragung (TLS 1.3) verschlüsselt. Unser Managementsystem und unsere Infrastruktur basieren auf ISO 27001 und TISAX."
      },
      backupHandling: {
        q: "Wie werden die Backups gehandhabt?",
        a: "Wir führen automatisierte regelmäßige Backups mit Georedundanz durch."
      },
      auditorLimit: {
        q: "Gibt es eine Begrenzung der Anzahl der Auditoren bzw. Audits?",
        a: "Nein, es gibt keine Beschränkung auf Auditoren oder Audits. Die Lizenzen sind an die Prüfer gebunden, Sie können jedoch jederzeit neue Lizenzen und Prüfer zu Ihrem Prüferpool hinzufügen."
      },
      supportedLanguages: {
        q: "Welche Sprachen werden unterstützt?",
        a: "Unsere Software unterstützt derzeit Englisch, Chinesisch, Deutsch, Spanisch und Französisch. Berichte können auch in diesen Sprachen erstellt werden."
      },
      auditManagementSupport: {
        q: "Wie unterstützt diese Audit-Software mein Audit-Management?",
        a: "Unsere Audit-Software bietet vielfältige Unterstützung. Der Auditbericht wird beispielsweise automatisch erstellt, während der Auditor das Audit durchführt. Der Auditor kann anschließend den Auditbericht einsehen und bei Bedarf oder Wunsch anpassen.<br><br>Der Workflow eines Audits ist implementiert und unterstützt den Auditor aktiv. Jedes Standardkapitel ist bereits implementiert und schaltet automatisch um, wenn beispielsweise eine Nichtbestätigung durch den Auditor gemeldet wird."
      },
      inexexperiencedUser: {
        q: "Kann ich die Prüfungssoftware nutzen, auch wenn ich weniger Erfahrung mit der Prüfung habe?",
        a: "Ja, unsere Audit-Software ist intuitiv entwickelt und führt Sie durch das Audit. Die automatische Infrastruktur wird von externen Prüfern auf der ganzen Welt erstellt, um die Konformität des Arbeitsablaufs sicherzustellen."
      },
      uploadFiles: {
        q: "Kann ich Dateien oder Bilder zu meinem Audit hochladen?",
        a: "Ja, Sie können Bilder oder Dateien aufnehmen und diese in Ihr Audit hochladen."
      },
      multipleAuditors: {
        q: "Kann ich ein Audit mit mehreren Auditoren durchführen?",
        a: "Ja, Sie können ein Audit mit mehreren Auditoren durchführen. Alle Prüfer können gleichzeitig in unserer Software zusammenarbeiten. Die Auditoren müssen dem Auditorenpool hinzugefügt werden, damit Sie sie als Lead-Auditor oder Co-Auditor zum Audit hinzufügen können."
      },
      buyLicences: {
        q: "Wer kann Lizenzen kaufen und Prüfer erstellen?",
        a: "Die Lizenzierung und Bindung von Auditoren an die Lizenzen kann nur auf der Plattform und durch den Administrator erfolgen. Bitte beachten Sie, dass die Lizenzen an den Prüfer gebunden sind und nicht auf einen anderen Prüfer übertragen werden können. Jeder Wirtschaftsprüfer benötigt eine eigene Lizenz."
      },
      addTemplates: {
        q: "Kann ich meinem Konto später weitere Audit-Vorlagen hinzufügen?",
        a: "Ja, Sie können Ihrem Konto jederzeit neue Audit-Vorlagen hinzufügen. Nach dem Kauf ist die Vorlage verfügbar."
      },
      templatePurchase: {
        q: "Muss ich Vorlagen für jeden Prüfer separat erwerben?",
        a: "Nein, sobald die Organisation eine Audit-Vorlage erworben hat, kann diese von allen lizenzierten Auditoren verwendet werden, die an die Organisation gebunden sind."
      }
    }
  },
  more: "Mehr",
  productionBrain: {
    downloadShortcut: {
      title: "Laden Sie die Website-Verknüpfung herunter",
      desc: "Ein-Klick-Zugriff auf die LPT-Audit-Plattform",
      btn: "Jetzt herunterladen"
    },
    hero: {
      badge: "Die vernetzte Plattform",
      title: "Wandeln Sie ihre Audits von der Checkliste zum strategischen Asset",
      desc1: "Vereinheitlichen Sie Ihr Risiko-, Compliance- und Audit-Management auf einer einzigen, leistungsstarken Plattform.",
      desc2: "Automatisieren Sie das Audit-Management und verbessern Sie die Effektivität Ihres Audit-Teams durch automatisierte und schlanke Arbeitsabläufe.",
      btnShop: "SHOP",
      btnExplore: "Entdecken Sie die Plattformtour"
    },
    stats: {
      timeSaved: {
        value: ">30 %",
        label: "Zeit gespart",
        desc: "Durchschnittliche jährliche Zeitersparnis bei der manuellen Beweiserhebung."
      },
      riskVisibility: {
        value: "Echtzeit",
        label: "Risikosichtbarkeit",
        desc: "Übergang von punktuellen Kontrollen zur kontinuierlichen Sicherung."
      },
      integrations: {
        value: "100+",
        label: "Integrationen",
        desc: "Integrieren Sie es nahtlos in Ihre bestehende Infrastruktur."
      },
      surpriseFindings: {
        value: "Null",
        label: "Überraschende Erkenntnisse",
        desc: "Erkennen Sie Kontrollfehler, bevor externe Prüfer eintreffen."
      }
    },
    solutions: {
      header: {
        title: "Speziell für jeden Geschäftsbereich entwickelt",
        desc: "Unabhängig davon, ob Sie komplexe, einfache oder flexible Audits oder Managementsysteme auf der ganzen Welt oder vor Ort verwalten, passen sich unsere Lösungen an Ihre spezifische Methodik an."
      },
      items: [
        {
          title: "Auditmanagement",
          description: "Optimieren Sie den gesamten Audit-Lebenszyklus. Automatisieren Sie Bewertungen, Workflow-Management und dynamische Berichte für das Audit-Team."
        },
        {
          title: "IT- und Sicherheits-Compliance",
          description: "Beschleunigen Sie die Einhaltung von ISO 27001, TISAX, PCI-DDS und HIPAA. Die Steuerungszuordnung stellt sicher, dass Sie mehrere Frameworks testen, prüfen und einhalten."
        },
        {
          title: "Automatisierter Workflow",
          description: "Digitalisieren Sie Ihren Audit-Workflow und Ihr Audit-Management. Automatisierte Arbeitsabläufe während des gesamten Prüfverfahrens."
        },
        {
          title: "Digitalisierung",
          description: "Digitalisieren Sie Ihr Audit-Management- und Compliance-Programm. Verfolgen Sie RCMs (Risk Control Matrix), verwalten Sie Zertifizierungen und automatisieren Sie Defizit-Workflows."
        }
      ]
    },
    features: {
      header: {
        title: "Funktionen der Enterprise-Klasse",
        desc: "Ein umfassendes Toolkit zur Zentralisierung von Daten, zur Automatisierung von Arbeitsabläufen und zur Bereitstellung umsetzbarer Analysen."
      },
      items: [
        {
          title: "Datengesteuerte Risikobewertungen",
          description: "Führen Sie auf der Grundlage Ihrer Prüfungsergebnisse und Überprüfungen vorab und nachträglich Risikobewertungen durch.",
          list: [
            "Benutzerdefinierte Risikobewertung",
            "Heatmap-Generierung",
            "Dynamische Risikoregister"
          ]
        },
        {
          title: "Direkte Implementierung",
          description: "Eliminieren Sie separate Ordner mit Beweisen. Integrieren Sie Dateien, Fotos etc. direkt in Ihr Audit.",
          list: [
            "Laden Sie Fotos in das Audit hoch",
            "Laden Sie Dateien in das Audit hoch",
            "In die Bibliothek hochladen"
          ]
        },
        {
          title: "Problem- und Behebungsverfolgung",
          description: "Lassen Sie nicht zu, dass Erkenntnisse unter den Tisch fallen. Weisen Sie Probleme zu, legen Sie Fristen fest und verfolgen Sie Behebungspläne bis zum Abschluss.",
          list: [
            "Automatisiertes Maßnahmenmanagement",
            "Automatisierte Nachverfolgungen",
            "Integriertes Lieferantenaktionsmanagement"
          ]
        },
        {
          title: "Konsistenz durch Automatisierung",
          description: "Verbundene Funktionen sorgen für konsistente Daten und Informationen über den gesamten Prüfvorgang hinweg.",
          list: [
            "Automatische Synchronisierung",
            "Automatisierte Übertragung zwischen Auditprozessschritten",
            "Fehlervermeidung durch Workflow"
          ]
        },
        {
          title: "Intelligentes Framework-Management",
          description: "Automatisierte Verknüpfungen und Verbindungen zwischen den verschiedenen Tools sorgen für Effektivität und Effizienz.",
          list: [
            "Crosswalk  Mapping",
            "Vorgefertigte Frameworks",
            "Gap Analysen"
          ]
        },
        {
          title: "Erweitertes Active Directory",
          description: "Behalten Sie alle Ihre Daten in Ihrem Audit-Cockpit. Laden Sie Lieferanten und Kunden zum Mitmachen ein, indem Sie den Schlüssel weiterhin in Ihren Händen halten. Definieren Sie die Zugriffsberechtigungen und Rollen.",
          list: [
            "Kontrollierte Einladungen",
            "Verwaltete Zugriff durch Auditoren",
            "Kontrollierte Audit-Freigabe"
          ]
        }
      ]
    },
    integration: {
      title: "Digitalisieren Sie Ihr gesamtes Auditmanagement",
      desc: "Unsere Softwarelösungen bieten ein umfassendes Audit-Management-System. Alle Daten und Informationen sind jederzeit digital verfügbar und entsprechen den vorgegeben Standards.",
      benefits: {
        digitalization: {
          label: "Vollständige Digitalisierung:",
          text: "Eine einzige Software für Ihr Auditmanagement."
        },
        sync: {
          label: "Kontinuierliche Synchronisierung:",
          text: "Regelmäßige Synchronisierungen stellen sicher, dass Ihr Compliance-Status immer auf dem neuesten Stand ist."
        },
        data: {
          label: "Kontrollierte Daten:",
          text: "Sie kontrollieren die Freigabe und Aufhebung der Freigabe Ihrer Prüfdaten."
        }
      },
      nodes: {
        center: "Audit",
        offline: "Offline-Modus",
        portal: "Lieferantenportal",
        templates: "Fertige Vorlagen",
        workflows: "Automatisierte Arbeitsabläufe",
        permissions: "Berechtigungsverwaltung",
        library: "Digitale Bibliothek"
      }
    },
    workflow: {
      header: {
        title: "Der intelligente Audit-Lebenszyklus",
        desc: "Ein optimierter Prozess, der von der Planung bis zur Berichterstattung auf maximale Effizienz und absolute Genauigkeit ausgelegt ist."
      },
      items: [
        {
          title: "1. Plan und Umfang",
          description: "Definieren Sie Ihre Strategie, verwenden Risikomatrixen und weisen Ressourcen basierend auf der Auditorenverfügbarkeit automatisch zu."
        },
        {
          title: "2. Auditierung",
          description: "Nutzen Sie digitale Auditvorlagen, arbeiten Sie in Echtzeit innerhalb der Plattform zusammen und erfassen Sie nahtlos automatisierte Beweise."
        },
        {
          title: "3. Überprüfen und beheben",
          description: "Heben Sie Unstimmigkeiten sofort hervor. Leiten Sie Erkenntnisse automatisch an die Maßnahmenverantwortlichen weiter, damit diese schnell behoben werden können."
        },
        {
          title: "4. Berichten und überwachen",
          description: "Veröffentlichen Sie sofort abschließende Auditberichte. Wechseln Sie zu einer kontinuierlichen Überwachung, um sicherzustellen, dass die Kontrollen das ganze Jahr über wirksam bleiben."
        }
      ]
    },
    value: {
      title: "Sicherheit und Zuverlässigkeit auf Bankniveau",
      lead: "Ihre Auditdaten sind Ihr sensibles Gut. Wir schützen es mit einer Sicherheitsarchitektur der Enterprise-Klasse, die den strengsten globalen Standards entspricht.",
      props: [
        {
          title: "Datenresidenz und Compliance",
          desc: "Hosten Sie Ihre Daten in regionalen AWS/Azure-Rechenzentren, um die lokalen Datenschutzgesetze (DSGVO, CCPA) einzuhalten."
        },
        {
          title: "Rollenbasierte Zugriffskontrolle (RBAC)",
          desc: "Durch differenzierte Berechtigungen wird sichergestellt, dass Benutzer nur die ihnen zugewiesenen Daten, Steuerelemente und Arbeitsabläufe sehen."
        },
        {
          title: "Unveränderliche Auditprotokolle",
          desc: "Jede Änderung, Freigabe und Konfigurationsaktualisierung wird kryptografisch protokolliert. Prüfen Sie die Audit-Plattform selbst."
        }
      ]
    },
    cta: {
      title: "Sind Sie bereit, Ihr Audit-Management zu modernisieren?",
      desc: "Schließen Sie sich führenden Unternehmen an, die ihr Audit-Management und ihre Auditabläufe in effektive und effiziente Abläufe umgewandelt haben.",
      btn: "Beginnen Sie noch heute"
    },
  },
  services: {
    research: {
      website: "CBIB-Trendlinie besuchen",
      categories: [
        { title: "Regierungsorientiert", description: "Strategische Forschung zur Unterstützung staatlicher Entscheidungen." },
        { title: "Auf die digitale Wirtschaft ausgerichtet", description: "Forschung zu digitaler Industrieinfrastruktur und neuen Managementmodellen." },
        { title: "Branchenorientiert", description: "Indexbasierte Forschungsprodukte als Werkzeuge für Politik- und Branchenanalysen." },
        { title: "Datengesteuert", description: "Digitale Forschung, die Industriedaten, Kennzahlen und Wissensgraphen verbindet." }
      ]
    },
    consulting: {
      banner: {
        title: "Industrieberatung",
        desc: "Strategische Beratung aus einer Hand für die Entwicklung der biopharmazeutischen Industrie"
      },
      intro: {
        title: "LPT-Industrieberatung im Überblick",
        desc: "Strategische Beratungsleistungen wie Branchenforschung, Planung, Bewertung und Monitoring"
      },
      advantage: {
        title: "Die besonderen Vorteile der LPT-Industrieberatung"
      },
      values: {
        title: "Vier zentrale Werte von BioMall",
        items: [
          {
            title: "Datengesteuert",
            desc: "Auf Grundlage von Datenvorteilen entlang der Industrie-, Innovations-, Standort- und Verwaltungsketten bieten wir professionelle regionale Bewertungen der biopharmazeutischen Industrie."
          },
          {
            title: "Integrierte Lösungen",
            desc: "Wir verbinden Branchenforschung, Planungsentwurf, Ressourcenintegration und Plattformumsetzung zu einer ganzheitlichen regionalen Lösung für die biopharmazeutische Industrie."
          },
          {
            title: "Professionelles Serviceteam",
            desc: "Unser spezialisiertes Team konzentriert sich auf die biopharmazeutische Industrieforschung. Die Kernmitglieder verfügen über langjährige Erfahrung in Forschung, Beratung und Planung."
          }
        ]
      },
      appointment: {
        title: "Sprechen Sie mit unseren Branchenexperten<br>Erfahren Sie mehr über die LPT-Industrieberatung",
        hotline: "Rufen Sie unsere Beratungshotline an: 000-000-0000"
      },
      witness: {
        title: "Kundenreferenzen",
        desc: "Mehr als 150 erfolgreiche Kooperationen mit Behörden und Industrieparks im ganzen Land"
      },
      list: [
        {
          tit: "Industrieforschung",
          content: "Auf Basis der CBIB-Benchmarkanalyse zeigen wir mit Daten die Stärken und Schwächen regionaler Industrieentwicklung, quantifizieren Entwicklungslücken und stellen den Entwicklungsstand umfassend und objektiv dar.",
          images: [
            "Blaubuch der chinesischen biopharmazeutischen Industrie",
            "Blaubuch der Entwicklungszone Guangzhou",
            "Blaubuch der Biotechnologie-Industriebasis Pingshan",
            "Blaubuch der Wirtschaftsentwicklungszone Rizhao u. a."
          ]
        },
        {
          tit: "Industrieplanung",
          content: "Datengesteuerte Positionierung klärt Entwicklungsziele und -pfade, integriert professionelle Serviceplattformen und schafft Gesamtlösungen vom Top-Level-Design bis zum laufenden Betrieb.",
          images: [
            "Entwicklungsplan der biopharmazeutischen Industrie im Shuitu-Park der Liangjiang New Area Chongqing",
            "Industrieentwicklungsplan des Hangzhou Pharmaceutical Port",
            "Industrieentwicklungsplan der Hightech-Zone Hangzhou",
            "Industrieplan der Wissenschafts- und Innovationsbasis Changli im Zhongguancun Life Science Park"
          ]
        },
        {
          tit: "Projektbewertung",
          content: "Makroökonomische und technologische Trendbewertungen werden mit Modellen zur ökologischen Parkentwicklung und zur jeweiligen Entwicklungsphase kombiniert.",
          images: [
            "Bewertung der Unternehmensansiedlung in der Hightech-Zone Hangzhou",
            "Bewertung der Produktansiedlung von WuXi Biologics u. a."
          ]
        },
        {
          tit: "Industriemonitoring",
          content: "Durch dynamisches Datenmonitoring entstehen Berichte zu regionalen Wirtschaftsakteuren, Innovationsergebnissen und politischen Veränderungen, die Parks bei der Beobachtung ihrer regionalen und industriellen Entwicklung unterstützen.",
          images: [
            "Kurzbericht der Nationalen Entwicklungs- und Reformkommission",
            "Politikbericht des Beijing Biological Center",
            "Kurzbericht der Hightech-Zone Xi'an u. a."
          ]
        },
        {
          tit: "Spezialforschung",
          content: "Wir analysieren den nationalen und internationalen Industriestatus aus mehreren Perspektiven und identifizieren regionale Stärken und Schwächen durch Benchmarking mit führenden Regionen.",
          images: [
            "Bewertung politischer Auswirkungen der NDRC",
            "Spezielle Politikanalyse des Beijing Biological Center",
            "Bereichsübergreifende Spezialforschung im Suzhou Industrial Park",
            "Forschung zur Generikapolitik in Guangzhou"
          ]
        }
      ],
      cases: [
        { tit: "Karte der biopharmazeutischen Industrie Shanghai" },
        { tit: "Innovationsserviceplattform für die biopharmazeutische Industrie Shanghai" },
        { tit: "Karte der biopharmazeutischen Industrie Guangzhou" },
        { tit: "Zhongguancun Development Group (Planung + digitale Mittelplattform)" },
        { tit: "Smart Park im Zhongguancun Life Science Park" },
        { tit: "Datenplattform von China Fortune Land Development" }
      ]
    },
    recruitment: {
      banner: {
        title: "Cloud-Ansiedlung: Experten für Unternehmensstandorte",
        desc: "Basierend auf Unternehmens-Big-Data und Investitionslogik<br />Unterstützen wir Behörden und Parks bei der digitalen Transformation ihrer Ansiedlungsarbeit"
      },
      challenges: {
        title: "Neue Herausforderungen für Behörden und Parks bei der Unternehmensansiedlung",
        items: [
          "Wie kann die Ansiedlungsarbeit während einer Pandemie schnell wieder aufgenommen werden?",
          "Wie lassen sich Industrieentwicklung und professionelle Services im Zuge neuer industrieller Infrastruktur beschleunigen?",
          "Wie können der Wert eines Parks wirksam vermittelt und seine Markenwirkung ausgebaut werden?",
          "Wie lassen sich Umfeld und Branchentrends besser verstehen, um Projekte erfolgreich anzusiedeln?"
        ]
      },
      cloud: {
        title: "Cloud-Ansiedlung",
        desc: "Innovative Komplettlösung für die digitale Unternehmensansiedlung",
        list: [
          {
            tit: "Online-Ansiedlungsveranstaltung",
            content: "Wir organisieren digitale Präsentationen und Verhandlungstermine für Parks und bieten den vollständigen Service von Planung und gezielter Einladung bis zur anschließenden Kommunikation.",
            features: [
              "<strong>Start mit einem Klick</strong> Online-Veranstaltungen schnell durchführen",
              "<strong>Exklusiver QR-Code</strong> Individuelles Erlebnis für alle Teilnehmenden",
              "<strong>Stabil und reibungslos</strong> Ergebnisberichte sofort erstellen"
            ]
          },
          {
            tit: "Intelligente Ansiedlungsplattform als SaaS",
            content: "Auf Basis von Big Data werden Ansiedlungshinweise gebündelt und regionale Strategien präzise mit passenden Zielunternehmen im ganzen Land verknüpft.",
            features: [
              "<strong>Individuelle Modelle</strong> 45 Prognosemodelle auf Basis regionaler und sektoraler Ansiedlungslogik",
              "<strong>Kontinuierliche Daten</strong> Über 2 Mio. Gesundheitsunternehmen, 250.000 Produkte und 700.000 klinische Datensätze",
              "<strong>Intelligente Analyse</strong> Relevante Ansiedlungsinformationen in Echtzeit aus großen Datenmengen gewinnen",
              "<strong>Wirksame Vernetzung</strong> Projekte durch die Verbindung von Online- und Offline-Aktivitäten voranbringen"
            ]
          },
          {
            tit: "Digitaler Zwilling für Industrieparks",
            content: "Digitale Darstellung des Geschäftsumfelds eines Parks mit realen VR-Szenen, öffentlichen Services und digitalen Plattformen.",
            features: [
              "<strong>VR-Panorama</strong> Reale Parkumgebung umfassend darstellen",
              "<strong>3D-Modellierung</strong> Künftige Planung anschaulich präsentieren",
              "<strong>Micro-Park</strong> Einrichtungen des Parks detailliert vorstellen"
            ]
          }
        ]
      },
      prediction: {
        line1: "Über 45 Prognosemodelle für biopharmazeutische Teilbranchen",
        line2: "Schnelle Erstellung eines präzisen Profils speziell für Ihren Park",
        line3: "Dynamisch aktualisierte Listen potenzieller Zielkunden",
        btn: "Kostenlose Testversion anfordern"
      },
      location: {
        title: "Standortauswahl für Pharmaunternehmen",
        subtitle: "MedSite-Plattform",
        desc: "Über 20.000 hochwertige biopharmazeutische Unternehmen effektiv erreichen",
        detail: "Wir stellen präzise und verlässliche Hinweise zu Unternehmensstandorten und Projekten bereit und schaffen digitale Online-Marketingplattformen.",
        btn: "MedSite öffnen"
      },
      witness: {
        title: "Kundenreferenzen",
        desc: "Mehr als 150 Behörden und biopharmazeutische Parks setzen auf LPT"
      }
    },
    innovation: {
      title: "Entwicklung der biopharmazeutischen Industrie",
      subtitle: "Digitale Forschung und Innovation für die Gesundheitswirtschaft",
      banner: {
        title: "Innovationsservices für Unternehmen",
        desc: "Neue Infrastruktur für die Life-Science-Branche und beschleunigtes hochwertiges Wachstum kleiner und mittlerer Unternehmen"
      },
      menu: {
        biomall: "BioMall – Innovationsservicezentrum für die biopharmazeutische Industrie",
        medical: "Innovations- und Demonstrationszentrum für Medizinprodukte"
      },
      supplyChain: {
        title: "Die biopharmazeutische Lieferkette ist entscheidend",
        desc: "Sie begleitet den gesamten Produktlebenszyklus von Forschung und Entwicklung bis zur Vermarktung. Digitale Hebel sind für Industrieparks ein unverzichtbarer Weg."
      },
      stakeholders: [
        {
          title: "Parkverwaltung",
          desc: "Wie lassen sich professionelle Services verbessern und mehr Optionen in der Lieferkette anbieten?"
        },
        {
          title: "Serviceanbieter",
          desc: "Wie lässt sich die Kundennähe erhöhen und die Marktabdeckung weiter ausbauen?"
        },
        {
          title: "Unternehmen im Park",
          desc: "Wie erhalten Unternehmen professionellere technische Services und finden passende hochwertige Anbieter?"
        }
      ],
      mall: {
        title: "BioMall im Überblick",
        desc: "BioMall ist eine Innovationsinfrastruktur, die Innovationen kleiner und mittlerer Unternehmen beschleunigt und das Serviceniveau von Industrieparks verbessert. Online- und Offline-Ressourcen werden verbunden, um hochwertige und kosteneffiziente Produkte und Services anzubieten."
      },
      functions: {
        title: "Funktionssystem von BioMall"
      },
      platforms: [
        {
          title: "Digitale Beschaffung",
          features: ["Produktsuche", "Online-Bestellung", "Bestellverwaltung", "Vertragsverwaltung"]
        },
        {
          title: "Digitales Marketing",
          features: ["Gezielte Kundengewinnung", "Anfragenverwaltung", "Private Kanäle", "Messeservices"]
        },
        {
          title: "Digitale öffentliche Services",
          features: ["Förderanträge", "F&E-Services", "Talentservices", "Finanzservices"]
        },
        {
          title: "Digitale Lieferkette",
          features: ["Intelligente Logistik", "Lagerverwaltung", "Auslieferung", "Zollservices"]
        }
      ],
      values: {
        title: "Vier zentrale Werte von BioMall",
        items: [
          "Nicht nur digitale Online-Infrastruktur, sondern eine umfassende Verbindung von Online- und Offline-Angeboten",
          "Bessere Ressourcenverteilung zur beschleunigten Bündelung der biopharmazeutischen Industrie",
          "Engpässe in der Lieferkette der biopharmazeutischen Entwicklung lösen",
          "Hochwertige Anbieter gewinnen, vorgelagerte Wertschöpfungsketten stärken und regionales BIP sowie Steuereinnahmen erhöhen"
        ]
      }
    },
    common: {
      learnMore: "Mehr erfahren",
      getDemo: "Demo anfordern",
      applyFree: "Kostenlos anfragen",
      buyNow: "Jetzt kaufen",
      followUs: "LPT folgen",
      contactPhone: "Kontakt: 000-000-0000"
    }
  },
  actionManagement: {
    generalInfo: {
      evaluation: "Bewertung"
    },
    submitChanges: "Änderungen absenden"
  }
};
